window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Helper files ================*/
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2
      'use strict';
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}


/*================ Vendor files ================*/
// ../../node_modules/lazysizes/lazysizes.min.js
!function(){"use strict";function e(n){return"undefined"==typeof this||Object.getPrototypeOf(this)!==e.prototype?new e(n):(O=this,O.version="3.3.6",O.tools=new E,O.isSupported()?(O.tools.extend(O.defaults,n||{}),O.defaults.container=t(O.defaults),O.store={elements:{},containers:[]},O.sequences={},O.history=[],O.uid=0,O.initialized=!1):"undefined"!=typeof console&&null!==console,O)}function t(e){if(e&&e.container){if("string"==typeof e.container)return window.document.documentElement.querySelector(e.container);if(O.tools.isNode(e.container))return e.container}return O.defaults.container}function n(e,t){return"string"==typeof e?Array.prototype.slice.call(t.querySelectorAll(e)):O.tools.isNode(e)?[e]:O.tools.isNodeList(e)?Array.prototype.slice.call(e):[]}function i(){return++O.uid}function o(e,t,n){t.container&&(t.container=n),e.config?e.config=O.tools.extendClone(e.config,t):e.config=O.tools.extendClone(O.defaults,t),"top"===e.config.origin||"bottom"===e.config.origin?e.config.axis="Y":e.config.axis="X"}function r(e){var t=window.getComputedStyle(e.domEl);e.styles||(e.styles={transition:{},transform:{},computed:{}},e.styles.inline=e.domEl.getAttribute("style")||"",e.styles.inline+="; visibility: visible; ",e.styles.computed.opacity=t.opacity,t.transition&&"all 0s ease 0s"!==t.transition?e.styles.computed.transition=t.transition+", ":e.styles.computed.transition=""),e.styles.transition.instant=s(e,0),e.styles.transition.delayed=s(e,e.config.delay),e.styles.transform.initial=" -webkit-transform:",e.styles.transform.target=" -webkit-transform:",a(e),e.styles.transform.initial+="transform:",e.styles.transform.target+="transform:",a(e)}function s(e,t){var n=e.config;return"-webkit-transition: "+e.styles.computed.transition+"-webkit-transform "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s, opacity "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s; transition: "+e.styles.computed.transition+"transform "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s, opacity "+n.duration/1e3+"s "+n.easing+" "+t/1e3+"s; "}function a(e){var t,n=e.config,i=e.styles.transform;t="top"===n.origin||"left"===n.origin?/^-/.test(n.distance)?n.distance.substr(1):"-"+n.distance:n.distance,parseInt(n.distance)&&(i.initial+=" translate"+n.axis+"("+t+")",i.target+=" translate"+n.axis+"(0)"),n.scale&&(i.initial+=" scale("+n.scale+")",i.target+=" scale(1)"),n.rotate.x&&(i.initial+=" rotateX("+n.rotate.x+"deg)",i.target+=" rotateX(0)"),n.rotate.y&&(i.initial+=" rotateY("+n.rotate.y+"deg)",i.target+=" rotateY(0)"),n.rotate.z&&(i.initial+=" rotateZ("+n.rotate.z+"deg)",i.target+=" rotateZ(0)"),i.initial+="; opacity: "+n.opacity+";",i.target+="; opacity: "+e.styles.computed.opacity+";"}function l(e){var t=e.config.container;t&&O.store.containers.indexOf(t)===-1&&O.store.containers.push(e.config.container),O.store.elements[e.id]=e}function c(e,t,n){var i={target:e,config:t,interval:n};O.history.push(i)}function f(){if(O.isSupported()){y();for(var e=0;e<O.store.containers.length;e++)O.store.containers[e].addEventListener("scroll",d),O.store.containers[e].addEventListener("resize",d);O.initialized||(window.addEventListener("scroll",d),window.addEventListener("resize",d),O.initialized=!0)}return O}function d(){T(y)}function u(){var e,t,n,i;O.tools.forOwn(O.sequences,function(o){i=O.sequences[o],e=!1;for(var r=0;r<i.elemIds.length;r++)n=i.elemIds[r],t=O.store.elements[n],q(t)&&!e&&(e=!0);i.active=e})}function y(){var e,t;u(),O.tools.forOwn(O.store.elements,function(n){t=O.store.elements[n],e=w(t),g(t)?(t.config.beforeReveal(t.domEl),e?t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.target+t.styles.transition.delayed):t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.target+t.styles.transition.instant),p("reveal",t,e),t.revealing=!0,t.seen=!0,t.sequence&&m(t,e)):v(t)&&(t.config.beforeReset(t.domEl),t.domEl.setAttribute("style",t.styles.inline+t.styles.transform.initial+t.styles.transition.instant),p("reset",t),t.revealing=!1)})}function m(e,t){var n=0,i=0,o=O.sequences[e.sequence.id];o.blocked=!0,t&&"onload"===e.config.useDelay&&(i=e.config.delay),e.sequence.timer&&(n=Math.abs(e.sequence.timer.started-new Date),window.clearTimeout(e.sequence.timer)),e.sequence.timer={started:new Date},e.sequence.timer.clock=window.setTimeout(function(){o.blocked=!1,e.sequence.timer=null,d()},Math.abs(o.interval)+i-n)}function p(e,t,n){var i=0,o=0,r="after";switch(e){case"reveal":o=t.config.duration,n&&(o+=t.config.delay),r+="Reveal";break;case"reset":o=t.config.duration,r+="Reset"}t.timer&&(i=Math.abs(t.timer.started-new Date),window.clearTimeout(t.timer.clock)),t.timer={started:new Date},t.timer.clock=window.setTimeout(function(){t.config[r](t.domEl),t.timer=null},o-i)}function g(e){if(e.sequence){var t=O.sequences[e.sequence.id];return t.active&&!t.blocked&&!e.revealing&&!e.disabled}return q(e)&&!e.revealing&&!e.disabled}function w(e){var t=e.config.useDelay;return"always"===t||"onload"===t&&!O.initialized||"once"===t&&!e.seen}function v(e){if(e.sequence){var t=O.sequences[e.sequence.id];return!t.active&&e.config.reset&&e.revealing&&!e.disabled}return!q(e)&&e.config.reset&&e.revealing&&!e.disabled}function b(e){return{width:e.clientWidth,height:e.clientHeight}}function h(e){if(e&&e!==window.document.documentElement){var t=x(e);return{x:e.scrollLeft+t.left,y:e.scrollTop+t.top}}return{x:window.pageXOffset,y:window.pageYOffset}}function x(e){var t=0,n=0,i=e.offsetHeight,o=e.offsetWidth;do isNaN(e.offsetTop)||(t+=e.offsetTop),isNaN(e.offsetLeft)||(n+=e.offsetLeft),e=e.offsetParent;while(e);return{top:t,left:n,height:i,width:o}}function q(e){function t(){var t=c+a*s,n=f+l*s,i=d-a*s,y=u-l*s,m=r.y+e.config.viewOffset.top,p=r.x+e.config.viewOffset.left,g=r.y-e.config.viewOffset.bottom+o.height,w=r.x-e.config.viewOffset.right+o.width;return t<g&&i>m&&n<w&&y>p}function n(){return"fixed"===window.getComputedStyle(e.domEl).position}var i=x(e.domEl),o=b(e.config.container),r=h(e.config.container),s=e.config.viewFactor,a=i.height,l=i.width,c=i.top,f=i.left,d=c+a,u=f+l;return t()||n()}function E(){}var O,T;e.prototype.defaults={origin:"bottom",distance:"20px",duration:500,delay:0,rotate:{x:0,y:0,z:0},opacity:0,scale:.9,easing:"cubic-bezier(0.6, 0.2, 0.1, 1)",container:window.document.documentElement,mobile:!0,reset:!1,useDelay:"always",viewFactor:.2,viewOffset:{top:0,right:0,bottom:0,left:0},beforeReveal:function(e){},beforeReset:function(e){},afterReveal:function(e){},afterReset:function(e){}},e.prototype.isSupported=function(){var e=document.documentElement.style;return"WebkitTransition"in e&&"WebkitTransform"in e||"transition"in e&&"transform"in e},e.prototype.reveal=function(e,s,a,d){var u,y,m,p,g,w;if(void 0!==s&&"number"==typeof s?(a=s,s={}):void 0!==s&&null!==s||(s={}),u=t(s),y=n(e,u),!y.length)return O;a&&"number"==typeof a&&(w=i(),g=O.sequences[w]={id:w,interval:a,elemIds:[],active:!1});for(var v=0;v<y.length;v++)p=y[v].getAttribute("data-sr-id"),p?m=O.store.elements[p]:(m={id:i(),domEl:y[v],seen:!1,revealing:!1},m.domEl.setAttribute("data-sr-id",m.id)),g&&(m.sequence={id:g.id,index:g.elemIds.length},g.elemIds.push(m.id)),o(m,s,u),r(m),l(m),O.tools.isMobile()&&!m.config.mobile||!O.isSupported()?(m.domEl.setAttribute("style",m.styles.inline),m.disabled=!0):m.revealing||m.domEl.setAttribute("style",m.styles.inline+m.styles.transform.initial);return!d&&O.isSupported()&&(c(e,s,a),O.initTimeout&&window.clearTimeout(O.initTimeout),O.initTimeout=window.setTimeout(f,0)),O},e.prototype.sync=function(){if(O.history.length&&O.isSupported()){for(var e=0;e<O.history.length;e++){var t=O.history[e];O.reveal(t.target,t.config,t.interval,!0)}f()}return O},E.prototype.isObject=function(e){return null!==e&&"object"==typeof e&&e.constructor===Object},E.prototype.isNode=function(e){return"object"==typeof window.Node?e instanceof window.Node:e&&"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName},E.prototype.isNodeList=function(e){var t=Object.prototype.toString.call(e),n=/^\[object (HTMLCollection|NodeList|Object)\]$/;return"object"==typeof window.NodeList?e instanceof window.NodeList:e&&"object"==typeof e&&n.test(t)&&"number"==typeof e.length&&(0===e.length||this.isNode(e[0]))},E.prototype.forOwn=function(e,t){if(!this.isObject(e))throw new TypeError('Expected "object", but received "'+typeof e+'".');for(var n in e)e.hasOwnProperty(n)&&t(n)},E.prototype.extend=function(e,t){return this.forOwn(t,function(n){this.isObject(t[n])?(e[n]&&this.isObject(e[n])||(e[n]={}),this.extend(e[n],t[n])):e[n]=t[n]}.bind(this)),e},E.prototype.extendClone=function(e,t){return this.extend(this.extend({},e),t)},E.prototype.isMobile=function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},T=window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(e){window.setTimeout(e,1e3/60)},"function"==typeof define&&"object"==typeof define.amd&&define.amd?define(function(){return e}):"undefined"!=typeof module&&module.exports?module.exports=e:window.ScrollReveal=e}();

/*================ Vue App ================*/
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(14)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction) {
  isProduction = _isProduction

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[data-vue-ssr-id~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

  /**
   * Helper methods
   * @type {Object}
   */
  methods: {

    /**
     * Converts an amount into currency format
     * @param  {Integer} amount The price of whatever
     * @return {String}         The formatted amount
     */
    money: function money(amount) {

      // The currency converter format
      return this.$root.currencyFormatted(amount / 100);
    },

    /**
     * Generates a shopify image url
     * @param  {String} src  The image src
     * @param  {String} size The size to set the image to
     * @return {String}      The fomatted url
     */
    sImage: function sImage(src, size) {
      return (slate ? slate : window.slate).Image.getSizedImageUrl(src, size);
    },

    /**
     * Adds a cache busting string to AJAX urls
     * @param  {Boolean} [no_question=false] Wether to add the ?
     * @return {String}                      The cache busting string
     */
    cacheBuster: function cacheBuster() {
      var no_question = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return (no_question ? '' : '?') + new Date().getTime() + Math.round(Math.random() * 10000);
    }

  }

};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Cart Methods
 * @type {Object}
 */
module.exports = {

  /**
   * Cart methods
   * @type {Object}
   */
  methods: {

    /**
     * Grabs the cart
     * @return {Null}
     */
    grabCart: function grabCart() {

      // set up our request and self reference
      var r = new XMLHttpRequest(),
          self = this;

      // Add to the updating queue
      app.cart_updating++;

      // Make the call to the cart
      r.open("GET", "/cart.js" + this.cacheBuster(), true);

      // Updates the cart
      r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
        if (! --app.cart_updating) app.cart = JSON.parse(r.responseText);
      };

      // send the request
      r.send();
    },

    /**
     * Updates the cart with query_vars
     * @param  {String}  [data={}]    The products data
     * @param  {Boolean} stop_refresh Should we stop the refresh?
     * @return {Null}
     */
    updateCart: function updateCart() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stop_refresh = arguments[1];
      var use_updates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


      // set up our request and self reference
      var r = new XMLHttpRequest(),
          self = this;

      // Add to the updating queue
      app.cart_updating++;

      // Make the call to the cart
      r.open("POST", "/cart/update.js" + this.cacheBuster());

      // Set the headers
      r.setRequestHeader("Content-type", "application/json");

      // Updates the cart
      r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
        if (! --app.cart_updating && !stop_refresh) app.cart = JSON.parse(r.responseText);
      };

      // send the request
      r.send(JSON.stringify(use_updates ? { updates: data } : data));
    },

    /**
     * Ajaxes product/s into the cart
     * @param  {Object}  [data={}]    The products data
     * @param  {Boolean} stop_refresh Wether to refresh the app cart
     * @return {Null}
     */
    addToCart: function addToCart() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stop_refresh = arguments[1];


      // set up our request and self reference
      var r = new XMLHttpRequest(),
          self = this;

      // Add to the updating queue
      app.cart_updating++;

      // Make the call to the cart
      r.open("POST", "/cart/add.js" + this.cacheBuster());

      // Set the headers
      r.setRequestHeader("Content-type", "application/json");

      // Updates the cart
      r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
        --app.cart_updating;
        if (!stop_refresh) self.grabCart();
      };

      // send the request
      r.send(JSON.stringify(data));
    },

    /**
     * Adds a product to the cart
     * @param  {Integer} variant_id The id of the product's variant
     * @param  {Integer} quantity   The quantity of the variant to add
     * @return {Null}
     */
    addSingleToCart: function addSingleToCart(variant_id, quantity, stop_refresh) {

      // Open minicart
      if (app.minicart) app.minicart.open = true;

      // Add the item to the cart
      this.addToCart({
        id: variant_id,
        quantity: quantity
      }, stop_refresh);
    },

    /**
     * Adds multiple products to the cart
     * @return {Null}
     */
    addMultipleToCart: function addMultipleToCart() {
      var _this = this;

      // If there are no products
      if (!this.quantities.reduce(function (t, v) {
        return +v + t;
      }, 0)) return alert('make sure to add quantities which products you would like!');

      // Open minicart
      if (app.minicart) app.minicart.open = true;

      // Set up our products
      var products_data = {},
          products = this.product.variants.map(function (v, i) {

        // Set our data
        var data = {
          id: v.id,
          quantity: app.cart.items.reduce(function (qty, item) {
            return item.id == v.id ? qty + item.quantity : qty;
          }, +_this.quantities[i])
        };

        // reset the quantity
        _this.$set(_this.quantities, i, !i ? 1 : 0);

        // return a built object
        return data;
      }).filter(function (v) {
        return v.quantity;
      });

      // Force the model update
      this.$forceUpdate();

      // Build our data
      for (var i = 0, l = products.length; i < l; i++) {
        if (products[i].quantity) products_data[products[i].id] = products[i].quantity;
      } // update the cart with the products
      this.updateCart(products_data);
    },

    /**
     * Deletes an item from the cart
     * @param  {Object} item The item to delete
     * @return {Null}
     */
    removeCartItem: function removeCartItem(item) {

      // init the data to be passed through
      var data = {};

      // Add the nulled qty
      data[item.variant_id] = 0;

      // removes the item
      this.updateCart(data);
    },

    /**
     * Updates the quantity of a cart item
     * @param  {Object} item   The item to update
     * @param  {Number} amount The amount to change the quantity by
     * @return {Null}
     */
    updateCartItem: function updateCartItem(item, amount) {

      // init the data to be passed through
      var data = {};

      // Add the nulled qty
      data[item.variant_id] = amount;

      // Update the item qty
      this.updateCart(data);
    }

  }

};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Product
 * @type {Object}
 */
module.exports = {

  /**
   * Product methods
   * @type {Object}
   */
  methods: {

    /**
     * Grabs the cart
     * @return {Null}
     */
    grabProduct: function grabProduct(product_handle) {

      // set up our request and self reference
      var product_form = document.querySelector('.page-product--handle'),
          r = new XMLHttpRequest(),
          self = this;

      // Find the product id
      if (!product_handle) product_handle = product_form ? product_form.getAttribute('data-product-handle') : null;

      // jump out if no product id
      if (!product_handle) return;

      // Make the call to the cart
      r.open("GET", '/products/' + product_handle + '.js' + this.cacheBuster(), true);

      // Updates the cart
      r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200) return;
        self.product = JSON.parse(r.responseText);
        self.quantities = self.product.variants.map(function (v, i) {
          return i ? '0' : '1';
        });
        self.current_variant = self.product.variants[0];
      };

      // send the request
      r.send();
    }

  }

};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Product
 * @type {Object}
 */
module.exports = {

  /**
   * Data pertaining to currency
   * @type {Object}
   */
  data: {

    // Stores the locale of the currency
    currency_locale: localStorage.getItem("currency_locale") || 'USD',

    // Stores the currency Symbols
    currency_symbols: {
      'USD': '$', // US Dollar
      'CAD': '$', // CAD Dollar
      'EUR': '€', // Euro
      'CRC': '₡', // Costa Rican Colón
      'GBP': '£', // British Pound Sterling
      'ILS': '₪', // Israeli New Sheqel
      'INR': '₹', // Indian Rupee
      'JPY': '¥', // Japanese Yen
      'KRW': '₩', // South Korean Won
      'NGN': '₦', // Nigerian Naira
      'PHP': '₱', // Philippine Peso
      'PLN': 'zł', // Polish Zloty
      'PYG': '₲', // Paraguayan Guarani
      'THB': '฿', // Thai Baht
      'UAH': '₴', // Ukrainian Hryvnia
      'VND': '₫' // Vietnamese Dong
    }

  },

  /**
   * Watches to add to the component
   * @type {Object}
   */
  watch: {

    /**
     * Stores the currency locale change
     * @param  {String} new_locale The new locale
     * @return {Null}
     */
    currency_locale: function currency_locale(new_locale) {

      // Store the new currency
      localStorage.setItem("currency_locale", new_locale);
    }

  },

  /**
   * Product methods
   * @type {Object}
   */
  methods: {

    /**
     * Gets the root
     * @return {Object}
     */
    currencySelf: function currencySelf() {
      return this.$root.currency_locale ? this.$root : this;
    },

    /**
     * Grabs the cart
     * @return {Float} The converted currency
     */
    currencyConvert: function currencyConvert(amount) {
      return (amount / this.currencySelf().currency_conversion).toFixed(2);
    },

    /**
     * returns the currency formatted
     * @param  {Float}  amount The amount to convert
     * @return {String}        returns the currency with format
     */
    currencyFormatted: function currencyFormatted(amount) {

      // return the amount formatted
      return this.currencySelf().currency_symbol + this.currencySelf().currencyConvert(amount) + ' ' + this.currencySelf().currency_locale;
    },

    /**
     * Returns the current currency locale
     * @return {String} The current locale
     */
    getLocale: function getLocale() {
      return this.currencySelf().currency_locale;
    },

    /**
     * Gets a currency's symbol
     * @param  {String} [currency_locale='USD'] The type of currency
     * @return {String}                         The currency's symbol
     */
    getCurrencySymbol: function getCurrencySymbol() {
      var currency_locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'USD';

      return this.currencySelf().currency_symbols[currency_locale];
    }

  },

  /**
   * Computed properties associated with the component
   * @type {Object}
   */
  computed: {

    /**
     * Grabs the currency conversion rate
     * @return {Float} The currency at decimal
     */
    currency_conversion: function currency_conversion() {
      return Currency.rates[this.currencySelf().currency_locale];
    },

    /**
     * Returns the correct currency symbol
     * @return {String} The currency Sybol
     */
    currency_symbol: function currency_symbol() {

      // Store the current symbol
      var symbol = this.currencySelf().currency_symbols[this.currencySelf().currency_locale];

      // return symbol otherwise dollar sign
      return symbol ? symbol : '$';
    }

  }

};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vueDirectiveGenerator = __webpack_require__(9);

var _vueDirectiveGenerator2 = _interopRequireDefault(_vueDirectiveGenerator);

var _cart = __webpack_require__(4);

var _cart2 = _interopRequireDefault(_cart);

var _product = __webpack_require__(5);

var _product2 = _interopRequireDefault(_product);

var _shipping = __webpack_require__(82);

var _shipping2 = _interopRequireDefault(_shipping);

var _currency = __webpack_require__(6);

var _currency2 = _interopRequireDefault(_currency);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Grab Vue
window.Vue = __webpack_require__(83);

// Grab the vue components generator


// Grab our cart methods


// Grab our helper methods


// Custom components
var components = ['faq', 'quantity', 'mini-cart', 'cart-note', 'cart-updating', 'search-feed', 'form-search', 'form-contact', 'form-product', 'form-shipping', 'form-currency', 'form-product-seperate', 'link-product', 'video-article'];

// Boot up the Vue instance
window.app = new Vue({

  // Just target the entire window
  el: '#app',

  // So no conflicts with liquid
  delimiters: ['${', '}'],

  // Attach our components
  components: (0, _vueDirectiveGenerator2.default)(components),

  // Store the data relevant to the site
  data: Object.assign(_shipping2.default.data, _currency2.default.data, {
    cart: {
      note: '',
      loading: true
    },
    cart_updating: 0,
    cart_updating_shipping: 0,
    minicart: null
  }),

  /**
   * When the app is ready
   * @return {Null}
   */
  mounted: function mounted() {
    var _this = this;

    // Start by instantiating the cart
    setTimeout(function () {
      return _this.grabCart();
    }, 1000);

    // If the rates are not set try to get from storage
    this.setInitialShippingRates();
  },

  /**
   * Holds watcher methods
   * @type {Object}
   */
  watch: Object.assign(_shipping2.default.watch, _currency2.default.watch, {}),

  /**
   * Methods we can action with
   * @type {Object}
   */
  methods: Object.assign(_helpers2.default.methods, _cart2.default.methods, _shipping2.default.methods, _currency2.default.methods, {

    /**
     * Hides a value when the currency is set to USD
     * @param  {String} value The value to hide
     * @return {String}       The hidden or exposed value
     */
    hideWhenUSD: function hideWhenUSD(value) {
      return this.currency_locale == 'USD' ? '' : value;
    }

  }),

  /**
   * Contains the computed properties
   * @type {Object}
   */
  computed: Object.assign(_shipping2.default.computed, _currency2.default.computed, {})

});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (components) {

  // Set up our vue components object
  var vue_components = {};

  // Loop through the components
  for (var i = 0, l = components.length; i < l; i++) {

    // Store the selector for easy access
    var selector = components[i].match(/\/?([^\/]+)\/?$/)[1],
        component_type = (components[i].match(/\/?([^\/]+)\//) || [,])[1] || '',
        folder_type = component_type || 'components';

    // Add the selector to the view components
    // for rendering
    vue_components[selector] = Vue.component((component_type ? component_type.replace(/(es|s)$/, '') + '-' : '') + selector, __webpack_require__(10)("./" + folder_type + '/' + selector + '/' + selector + '.vue').default);
  }

  // return the generated vue components object
  return vue_components;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./components/cart-note/cart-note.vue": 11,
	"./components/cart-updating/cart-updating.vue": 17,
	"./components/faq/faq.vue": 22,
	"./components/form-contact/form-contact.vue": 27,
	"./components/form-currency/form-currency.vue": 32,
	"./components/form-product-seperate/form-product-seperate.vue": 37,
	"./components/form-product/form-product.vue": 42,
	"./components/form-search/form-search.vue": 47,
	"./components/form-shipping/form-shipping.vue": 52,
	"./components/link-product/link-product.vue": 57,
	"./components/mini-cart/mini-cart.vue": 62,
	"./components/quantity/quantity.vue": 67,
	"./components/search-feed/search-feed.vue": 72,
	"./components/video-article/video-article.vue": 77
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_note_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_note_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_note_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d59fda4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_cart_note_vue__ = __webpack_require__(16);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(12)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_note_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d59fda4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_cart_note_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/cart-note/cart-note.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d59fda4", Component.options)
  } else {
    hotAPI.reload("data-v-2d59fda4", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(13);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("0e764436", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d59fda4\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./cart-note.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d59fda4\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./cart-note.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tCART-NOTE\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.cart-note {\n  margin-bottom: 20px;\n}\n.cart-note__link {\n    cursor: pointer;\n}\n.cart-note__label {\n    font-weight: bold;\n}\n.cart-note__options {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n}\n.mini-cart .cart-note__textarea {\n    background: #fff;\n}\n", ""]);

// exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cart = __webpack_require__(4);

var _cart2 = _interopRequireDefault(_cart);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export the component
/*

	CART-NOTE

*/

// import the cart updating component
module.exports = {

  /**
   * Component Data
   * @type {Object}
   */
  data: function data() {
    return {
      editing: false
    };
  },

  /**
   * Component properties
   * @type {Array}
   */
  props: {

    // {{ settings.cart_notes_enable }}
    enabled: true,

    // {{ cart.note }}
    // note: String,

    // {{ 'cart.general.note' | t }}
    text: String

  },

  /**
   * Handles the computed properties
   * @type {Object}
   */
  computed: {

    /**
     * retrieves the cart's note
     * @return {String} The cart's note
     */
    note: function note() {
      return this.$root.cart.note;
    }

  },

  /**
   * Helper methods
   * @type {Object}
   */
  methods: Object.assign(_helpers2.default.methods, _cart2.default.methods, {

    /**
     * Toggles the editing state
     * @return {Null}
     */
    toggleEditing: function toggleEditing() {
      this.editing = !this.editing;
      if (this.editing) {
        this.saved_note = this.$root.cart.note;
      } else {
        this.$root.cart.note = this.saved_note;
      }
    },

    /**
     * Deletes the note from the cart
     * @return {Null}
     */
    deleteNote: function deleteNote() {

      // Delete the contents of the note
      this.$root.cart.note = '';

      // Now save the note
      this.saveNote();
    },

    /**
     * Saves the cart's note
     * @return {Null}
     */
    saveNote: function saveNote() {

      // Updates the carts note
      this.updateCart({ note: this.note }, false, false);

      // disable editing mode
      this.editing = false;
    }

  })

};

// Grab our helper methods

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cart-note" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.editing,
            expression: "editing"
          }
        ],
        staticClass: "cart-note__note"
      },
      [
        _vm.text
          ? _c(
              "label",
              {
                staticClass: "cart-note__label",
                attrs: { for: "CartSpecialInstructions" }
              },
              [_vm._v("\n\t\t\t" + _vm._s(_vm.text) + "\n\t\t")]
            )
          : _vm._e(),
        _c("br"),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.$root.cart.note,
              expression: "$root.cart.note"
            }
          ],
          staticClass: "cart-note__textarea",
          attrs: { name: "note", id: "CartSpecialInstructions" },
          domProps: { value: _vm.$root.cart.note },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.$root.cart, "note", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "cart-note__options" }, [
          _c(
            "a",
            {
              staticClass: "cart-note__link a",
              on: {
                click: function($event) {
                  _vm.toggleEditing()
                }
              }
            },
            [_c("small", [_vm._v("Cancel")])]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "cart-note__link a",
              on: {
                click: function($event) {
                  _vm.saveNote()
                }
              }
            },
            [_c("small", [_vm._v("Save")])]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.editing,
            expression: "!editing"
          }
        ]
      },
      [
        _c("cart-updating", [
          _vm.note
            ? _c("span", [_vm._v(_vm._s(_vm.note)), _c("br")])
            : _vm._e(),
          _vm._v(" "),
          _vm.note
            ? _c(
                "a",
                {
                  staticClass: "a cart-note__link",
                  on: {
                    click: function($event) {
                      _vm.deleteNote()
                    }
                  }
                },
                [_c("small", [_vm._v("Remove note")])]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "a cart-note__link",
              on: {
                click: function($event) {
                  _vm.toggleEditing()
                }
              }
            },
            [
              _c("small", [
                _vm.note
                  ? _c("span", [_vm._v("Edit note")])
                  : _c("span", [_vm._v("Add a note?")])
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d59fda4", esExports)
  }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_updating_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_updating_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_updating_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad65968_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_cart_updating_vue__ = __webpack_require__(21);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cart_updating_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cad65968_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_cart_updating_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/cart-updating/cart-updating.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-cad65968", Component.options)
  } else {
    hotAPI.reload("data-v-cad65968", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(19);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("14c0209b", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cad65968\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./cart-updating.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-cad65968\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./cart-updating.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tCART-UPDATING\n\n*/\n", ""]);

// exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	CART-UPDATING

*/

module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    type: String,
    text: String
  },

  /**
  * Component data
  * @type {Array}
  */
  data: function data() {
    return {
      base: 'cart_updating'
    };
  },

  /**
   * Fires when the component is loaded
   */
  computed: {

    /**
     * Returns the text to show when updating
     * @return {String}
     */
    updating_text: function updating_text() {
      return this.text ? this.text : 'Updating...';
    },

    /**
     * Returns wether updating is happening
     * @return {Boolean}
     */
    updating: function updating() {

      // Set the updating type
      var type = !this.type ? this.base : this.base + '_' + this.type;

      // return the state of the type that's updating
      return this.$root[type];
    }

  }

};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "cart-updating" }, [
    _vm.updating
      ? _c("span", [_vm._v("\n\t\t" + _vm._s(_vm.updating_text) + "\n\t")])
      : _c("span", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cad65968", esExports)
  }
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3112a85c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_faq_vue__ = __webpack_require__(26);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(23)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_faq_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3112a85c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/faq/faq.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3112a85c", Component.options)
  } else {
    hotAPI.reload("data-v-3112a85c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("f1c1e720", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3112a85c\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./faq.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-3112a85c\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./faq.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFAQ\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.faq {\n  position: relative;\n}\n.faq__anchor {\n    position: absolute;\n    top: -150px;\n    left: 0;\n}\n.faq__title {\n    cursor: pointer;\n    position: relative;\n    font-size: 1em;\n    margin: 0;\n    padding: 10px 40px 10px 10px;\n    background: #efefef;\n    color: #000;\n}\n.faq__question.faq__question--open .faq__title {\n      background: #efefef;\n}\n.faq__title:hover {\n      color: #eb412c;\n}\n.faq__question:nth-child(even) .faq__title {\n      background-color: #e7e7e7;\n}\n.faq__question {\n    border: 1px solid #efefef;\n    margin-bottom: -1px;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n}\n.faq__question.faq__question--open {\n      border-color: #efefef;\n}\n.faq__answer {\n    display: none;\n    -webkit-animation: faqIn 0.2s;\n            animation: faqIn 0.2s;\n    margin: 0;\n    padding: 10px 20px;\n}\n.faq__question--open .faq__answer {\n      display: block;\n}\n.faq__answer ul {\n      margin: 10px 0;\n}\n.faq__toggle {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    line-height: 1em;\n    font-size: 2em;\n    -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n    padding-bottom: 6px;\n}\n.faq__toggle:before {\n      font-weight: normal;\n      vertical-align: middle;\n      display: inline-block;\n      -webkit-transition: all 0.2s;\n      -o-transition: all 0.2s;\n      transition: all 0.2s;\n      content: '+';\n}\n.faq__question--open .faq__toggle:before {\n      -webkit-transform: rotate(45deg);\n          -ms-transform: rotate(45deg);\n              transform: rotate(45deg);\n}\n", ""]);

// exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	FAQ

*/

module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    questions: Object,
    title: String
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {

    this.$forceUpdate();
  },


  /**
   * Methods accessible to the component
   * @type {Object}
   */
  methods: {

    /**
     * Converts converted entities
     * @param  {String} html The incoming chars
     * @return {String}      The processed strings
     */
    processEntities: function processEntities(html) {

      // Helps with decoding html elements
      var txt = document.createElement("textarea");
      txt.innerHTML = html;

      // return decoded vals
      return txt.value.replace(/\&quo/g, '"').replace(/^\&nbsp;|\&nbsp;$/, '').trim();
    },

    /**
     * Toggles the question open and closed
     * @param  {Object} question The question being toggled
     * @return {Null}
     */
    toggleQuestion: function toggleQuestion(question) {

      // Close other questions
      for (var i = 0; i < this.questions.length; i++) {
        if (question.title != this.questions[i].title) this.questions[i].is_open = false;
      } // Set the question state to open/closed
      question.is_open = !question.is_open;

      // Force the updating of the component
      this.$forceUpdate();

      // update sticky sidebar
      if (window.cc_stickySidebar) window.cc_stickySidebar.updateSticky();
    }

  }

};

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq" },
    [
      _c("div", { staticClass: "faq__anchor", attrs: { id: "FAQ" } }),
      _vm._v(" "),
      _vm.title
        ? _c("h2", { staticClass: "faq__header h4" }, [
            _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.questions, function(question) {
        return _c(
          "div",
          {
            class: [
              "faq__question",
              { "faq__question--open": question.is_open }
            ]
          },
          [
            _c(
              "h3",
              {
                staticClass: "faq__title h--alt",
                on: {
                  click: function($event) {
                    _vm.toggleQuestion(question)
                  }
                }
              },
              [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.processEntities(question.title))
                  }
                }),
                _vm._v(" "),
                _c("a", { staticClass: "faq__toggle" })
              ]
            ),
            _vm._v(" "),
            _c("div", {
              staticClass: "faq__answer",
              domProps: {
                innerHTML: _vm._s(_vm.processEntities(question.answer))
              }
            })
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3112a85c", esExports)
  }
}

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_contact_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_contact_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_contact_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db8867f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_contact_vue__ = __webpack_require__(31);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_contact_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db8867f8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-contact/form-contact.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db8867f8", Component.options)
  } else {
    hotAPI.reload("data-v-db8867f8", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(29);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("82d2ef5c", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db8867f8\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-contact.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-db8867f8\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-contact.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-CONTACT\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.form-contact__description {\n  margin-bottom: 20px;\n}\n.form-contact__item {\n  padding: 10px 0;\n}\n.form-contact__item:last-child {\n    padding-bottom: 0;\n}\n.form-contact__item:first-child {\n    padding-top: 0;\n}\n.form-contact__submit {\n  margin-top: 10px;\n}\n.form-contact__inputs {\n  position: relative;\n}\n.form-contact--processing .form-contact__inputs input, .form-contact--processing .form-contact__inputs textarea, .form-contact--processing .form-contact__inputs select, .form-contact--processing .form-contact__inputs button {\n    opacity: 0.5;\n}\n.form-contact--processing .form-contact__inputs:before {\n    content: 'Sending...';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    z-index: 1;\n}\n.form-contact--inline .form-contact__inputs {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n.form-contact--inline .form-contact__item {\n  padding: 0;\n  min-width: 0;\n}\n.form-contact--inline .form-contact__input {\n  font-family: \"Nunito\", \"Roboto\", sans-serif;\n  min-width: 0;\n  border-right: none;\n}\n.form-contact--inline .form-contact__submit {\n  font-family: \"Nunito\", \"Roboto\", sans-serif;\n  margin: 0;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n}\n", ""]);

// exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	FORM-CONTACT

*/

module.exports = {

  /**
   * Component properties
   * @type {Object}
   */
  props: {
    'type': 'contact',
    'button': 'Send',
    'success_message': 'Your submission has been sent!',
    'success': false,
    'modifier': String,
    'description': String,
    'hidden': Array,
    'inputs': Array,
    'errors': Array,
    'no_ajax': false
  },

  /**
  * The object's data
  * @type {Object}
  */
  data: function data() {
    return {
      processing: false,
      form_inputs: [],
      form: null,
      manually_submit: false
    };
  },

  /**
   * Fires when component mounts
   * @return {Null}
   */
  mounted: function mounted() {

    // Main form element
    this.form = this.$el.querySelector('form');

    // Set the inputs
    this.form_inputs = this.form.querySelectorAll('input');

    // highjack the form's submission
    this.form.addEventListener('submit', this.submit);
  },

  /**
   * Methods accessible to the component
   * @type {Object}
   */
  methods: {

    /**
     * Used to submit the form
     * @return {Null}
     */
    submit: function submit(e) {

      // Clear out old errors
      this.errors = [];

      // Set the processing to true
      this.processing = true;

      // jump out if we are faced with a challenge
      if (this.manually_submit || this.no_ajax) return this.manually_submit = false;

      // Prevent the form from submitting
      if (e) e.preventDefault();

      // Stores the values to submit
      var r = new XMLHttpRequest(),
          self = this,
          values = '',
          action = this.form.action,
          method = this.form.method;

      // Fields
      for (var i = 0, l = this.form_inputs.length; i < l; i++) {

        // Store the values for submission
        values += (!i ? '' : '&') + this.form_inputs[i].name + '=' + this.form_inputs[i].value;

        // Catch values in case need to challenge
        this.form_inputs[i].setAttribute('old_value', this.form_inputs[i].value);
      }

      // Make the call to the cart
      r.open(method || 'POST', action || '/contact', true);

      // set the headers
      r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");

      // Updates the cart
      r.onreadystatechange = function () {

        // jump out if not ready
        if (r.readyState != 4) return;

        // Stop the processing
        self.processing = false;

        // if success
        if (r.status == 200) {

          // If is a challenge
          if (r.responseURL && r.responseURL.match(/\/challenge/) || r.responseText.match(/template-challenge|\/password/) || ~r.responseText.indexOf('template-challenge')) {

            // Set manually submitting to true
            self.manually_submit = true;

            // Loop through inputs and grab their old values
            for (var _i = 0, _l = self.form_inputs.length; _i < _l; _i++) {
              self.form_inputs[_i].value = self.form_inputs[_i].getAttribute('old_value');
            } // resubmit the form
            self.form.submit();

            // skip out on all else
            return false;
          }

          // Set the success state to true
          self.success = true;
        } else {
          self.errors.push('Oops, something went wrong!');
        }
      };

      // send the request
      r.send(values);
    }

  }

};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-contact",
      class: [
        { "form-contact--processing": _vm.processing },
        "form-contact--" + _vm.modifier
      ]
    },
    [
      _c(
        "form",
        {
          staticClass: "form-contact__form",
          attrs: {
            id: "form-contact__" + _vm.type,
            action: "/contact#form-contact__" + _vm.type,
            method: "POST"
          }
        },
        [
          _c("input", { attrs: { type: "hidden", name: "utf8", value: "✓" } }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "form_type" },
            domProps: { value: _vm.type }
          }),
          _vm._v(" "),
          _vm.errors && _vm.errors.length
            ? _c("div", [
                _c("h3", { staticClass: "h3" }, [_vm._v("Error:")]),
                _vm._v(" "),
                _c("p", [_vm._v("Please fix the fields referenced below.")]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "form-contact__errors" },
                  _vm._l(_vm.errors, function(error) {
                    return _c("li", [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(
                            error.charAt(0).toUpperCase() + error.slice(1)
                          ) +
                          "\n\t\t\t\t"
                      )
                    ])
                  })
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.success
            ? _c(
                "div",
                {
                  staticClass:
                    "form-contact__description form-contact__description--success"
                },
                [_vm._v("\n\t\t\t" + _vm._s(_vm.success_message) + "\n\t\t")]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.success && _vm.description
            ? _c("div", { staticClass: "form-contact__description h4" }, [
                _vm._v("\n\t\t\t" + _vm._s(_vm.description) + "\n\t\t")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.success
            ? _c(
                "div",
                { staticClass: "form-contact__inputs" },
                [
                  _vm._l(_vm.inputs, function(input, index) {
                    return _c("div", { staticClass: "form-contact__item" }, [
                      input.label
                        ? _c(
                            "label",
                            {
                              staticClass: "form-contact__label",
                              attrs: {
                                for: "form-contact__" + index + "-" + _vm.type
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(input.label) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      input.type == "textarea"
                        ? _c(
                            "textarea",
                            {
                              staticClass:
                                "form-contact__input form-contact__input--textarea",
                              attrs: {
                                name: "contact[" + input.name + "]",
                                id: "form-contact__" + index + "-" + _vm.type,
                                placeholder: input.placeholder,
                                required: input.required
                              }
                            },
                            [_vm._v(_vm._s(input.value))]
                          )
                        : _c("input", {
                            class: [
                              "form-contact__input",
                              "form-contact__input--" +
                                (input.type ? input.type : "text")
                            ],
                            attrs: {
                              id: "form-contact__" + index + "-" + _vm.type,
                              type: input.type ? input.type : "text",
                              name: "contact[" + input.name + "]",
                              placeholder: input.placeholder,
                              required: input.required
                            },
                            domProps: { value: input.value }
                          })
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "form-contact__submit btn",
                      attrs: { type: "submit", name: "commit" }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(_vm.button) + "\n\t\t\t")]
                  )
                ],
                2
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db8867f8", esExports)
  }
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_currency_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_currency_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_currency_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398fe94c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_currency_vue__ = __webpack_require__(36);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(33)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_currency_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398fe94c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_currency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-currency/form-currency.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-398fe94c", Component.options)
  } else {
    hotAPI.reload("data-v-398fe94c", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(34);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("245990fe", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-398fe94c\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-currency.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-398fe94c\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-currency.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-CURRENCY\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.form-currency {\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n  text-align: center;\n  -webkit-transition: all 0.2s;\n  -o-transition: all 0.2s;\n  transition: all 0.2s;\n  height: 100%;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  margin-right: 0;\n}\n.form-currency + .mini-cart .site-header__cart {\n    padding-left: 10px;\n}\n.form-currency__display {\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n}\n.form-currency__display:after {\n      content: '';\n      -webkit-transition: all 0.2s;\n      -o-transition: all 0.2s;\n      transition: all 0.2s;\n      position: relative;\n      display: inline-block;\n      width: 8px;\n      height: 8px;\n      margin-left: 7px;\n      border: 2px solid #000;\n      border-left: none;\n      border-top: none;\n      -webkit-transform: translate(-50%, -50%) rotate(45deg);\n          -ms-transform: translate(-50%, -50%) rotate(45deg);\n              transform: translate(-50%, -50%) rotate(45deg);\n}\n.form-currency:hover .form-currency__display {\n      color: #eb412c !important;\n      -webkit-animation: rainbowcolor 10s;\n              animation: rainbowcolor 10s;\n}\n.form-currency:hover .form-currency__display:after {\n        border-color: #eb412c !important;\n        -webkit-animation: rainbowborder 10s;\n                animation: rainbowborder 10s;\n}\n.form-currency__select {\n    opacity: 0;\n    position: absolute;\n    top: 50%;\n    left: 0;\n    min-width: 100%;\n    height: 30px;\n    border: none;\n    padding: 0;\n    display: block;\n    -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n}\n@media only screen and (max-width: 449px) {\n.form-currency__locale {\n      display: none;\n}\n}\n", ""]);

// exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _currency = __webpack_require__(6);

var _currency2 = _interopRequireDefault(_currency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export the component
module.exports = {

  /**
   * Properties passed through to the component
   * @type {Object}
   */
  props: {},

  /**
   * Component data
   * @type {Array}
   */
  data: function data() {
    return {

      // The changeable currencies
      currencies: ['USD', 'CAD', 'EUR', 'GBP']

    };
  },

  /**
   * The methods attached to the component
   * @type {Object}
   */
  methods: Object.assign(_currency2.default.methods, {})

}; /*
   
   	FORM-CURRENCY
   
   */

// Grab our cart methods

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-currency" }, [
    _c("div", { staticClass: "form-currency__display" }, [
      _c("span", { staticClass: "form-currency__symbol" }, [
        _vm._v(
          "\n\t\t\t" +
            _vm._s(_vm.getCurrencySymbol(_vm.$root.currency_locale)) +
            "\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "form-currency__locale" }, [
        _vm._v("\n\t\t\t" + _vm._s(_vm.$root.currency_locale) + "\n\t\t")
      ])
    ]),
    _vm._v(" "),
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.$root.currency_locale,
            expression: "$root.currency_locale"
          }
        ],
        staticClass: "form-currency__select",
        on: {
          change: function($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function(o) {
                return o.selected
              })
              .map(function(o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.$set(
              _vm.$root,
              "currency_locale",
              $event.target.multiple ? $$selectedVal : $$selectedVal[0]
            )
          }
        }
      },
      _vm._l(_vm.currencies, function(currency) {
        return _c("option", { domProps: { value: currency } }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.getCurrencySymbol(currency)) +
              "\n\t\t\t" +
              _vm._s(currency) +
              "\n\t\t"
          )
        ])
      })
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-398fe94c", esExports)
  }
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_seperate_js__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_seperate_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_seperate_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5059c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_product_seperate_vue__ = __webpack_require__(41);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_seperate_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a5059c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_product_seperate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-product-seperate/form-product-seperate.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a5059c2", Component.options)
  } else {
    hotAPI.reload("data-v-7a5059c2", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(39);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("5c24c694", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a5059c2\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-product-seperate.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7a5059c2\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-product-seperate.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-PRODUCT-SEPERATE\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.form-product-seperate__quantity {\n  position: relative;\n}\n.form-product-seperate__footer {\n  margin-top: 10px;\n}\n.form-product-seperate__increment {\n  position: absolute;\n  height: calc(100% - 2px);\n  width: 25px;\n  top: 1px;\n  left: 1px;\n  background: #000;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: #fff;\n  cursor: pointer;\n  -webkit-transition: all 0.2s;\n  -o-transition: all 0.2s;\n  transition: all 0.2s;\n}\n.form-product-seperate__increment--plus {\n    left: auto;\n    right: 1px;\n}\n.form-product-seperate__increment:hover {\n    background: #477cc9;\n}\n.form-product-seperate__variants {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n.form-product-seperate__price-wrapper {\n  font-size: 0.8em;\n}\n.form-product-seperate__label {\n  margin: 0;\n  line-height: 1em;\n}\n.form-product-seperate__image {\n  display: block;\n  margin-right: 10px;\n  min-width: 70px;\n  min-height: 70px;\n  width: 70px;\n  height: 70px;\n  background-position: center center;\n  background-size: cover;\n  position: relative;\n  border: 1px solid #efefef;\n}\n.form-product-seperate__image:before {\n    content: '';\n    position: relative;\n    display: block;\n    padding-bottom: 100%;\n}\n.form-product-seperate__content {\n  display: block;\n  width: calc(100% - 70px - 10px);\n}\n.form-product-seperate__form {\n  width: 100%;\n  max-height: 70px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px;\n}\n@media only screen and (min-width: 450px) {\n.form-product-seperate__form {\n      width: calc(50% - 5px);\n}\n}\n@media only screen and (min-width: 750px) and (max-width: 989px) {\n.form-product-seperate__form {\n      width: 100%;\n}\n}\n.form-product-seperate__input {\n  min-width: 0;\n  width: 100%;\n  text-align: center;\n}\n", ""]);

// exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cart = __webpack_require__(4);

var _cart2 = _interopRequireDefault(_cart);

var _product = __webpack_require__(5);

var _product2 = _interopRequireDefault(_product);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export the directive
module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    handle: String
  },

  /**
   * Data associated with the component
   * @return {Object}
   */
  data: function data() {
    return {
      product: {
        variants: []
      },
      quantities: []
    };
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {

    // Instantiate the current product
    this.grabProduct(this.handle);
  },


  /**
   * Methods we can action with
   * @type {Object}
   */
  methods: Object.assign(_helpers2.default.methods, _cart2.default.methods, _product2.default.methods, {

    /**
     * Updates the quantities on variants
     * @return {Null}
     */
    update_variant_quantities: function update_variant_quantities(variant_id, amount) {

      // Updates the quantity on a variant
      this.quantities.splice(variant_id, 1, Math.max(+this.quantities[variant_id] + amount, 0));

      // force the model to reflect the changes
      this.$forceUpdate();
    }

  }),

  /**
   * Props that are computed
   * @type {Object}
   */
  computed: {

    /**
     * The total quantities of variants
     * @return {String} Number of selected variants
     */
    total_quantities: function total_quantities() {

      // The total to display
      var total = this.quantities.reduce(function (t, v) {
        return +v + t;
      }, 0);

      // return the total or empty string
      return total ? total + ' ' + this.product.title + (total > 1 ? 's' : '') : '';
    }

  }

};

// Grab our helper methods
/*

	FORM-PRODUCT-SEPERATE

*/

// Grab our cart methods

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-product-seperate" }, [
    _c(
      "div",
      { staticClass: "form-product-seperate__variants" },
      _vm._l(_vm.product.variants, function(variant, variant_i) {
        return _c(
          "form",
          {
            staticClass: "form-product-seperate__form",
            attrs: {
              action: "/cart/add",
              method: "post",
              enctype: "multipart/form-data"
            }
          },
          [
            variant.featured_image
              ? _c("a", {
                  staticClass: "form-product-seperate__image",
                  style:
                    "background-image:url(" +
                    _vm.sImage(variant.featured_image.src, "100x100") +
                    ");",
                  attrs: { href: "#image-" + variant.featured_image.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-product-seperate__content" }, [
              _c("div", { staticClass: "form-product-seperate__title" }, [
                _c("label", { staticClass: "form-product-seperate__label" }, [
                  _vm._v(
                    "\n\t\t\t      " + _vm._s(variant.title) + "\n\t\t\t    "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-product-seperate__price-wrapper",
                    attrs: { "data-price-wrapper": "" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "form-product-seperate__price",
                        attrs: { "data-product-price": "" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t        " +
                            _vm._s(_vm.money(variant.price)) +
                            "\n\t\t\t      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    variant.compare_at_price &&
                    variant.compare_at_price > variant.price
                      ? _c("span", [
                          _c(
                            "span",
                            {
                              staticClass: "visually-hidden",
                              attrs: { "data-compare-text": "" }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tRegular Price\n\t\t\t\t\t\t\t\t"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "s",
                            {
                              staticClass:
                                "form-product-seperate__price form-product-seperate__price--compare",
                              attrs: { "data-compare-price": "" }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t        " +
                                  _vm._s(_vm.money(variant.compare_at_price)) +
                                  "\n\t\t\t\t      "
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-product-seperate__quantity" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.quantities[variant_i],
                      expression: "quantities[variant_i]"
                    }
                  ],
                  staticClass:
                    "form-product-seperate__input form-product-seperate__number",
                  attrs: { type: "number", value: "0", min: "0" },
                  domProps: { value: _vm.quantities[variant_i] },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.quantities, variant_i, $event.target.value)
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "form-product-seperate__increment form-product-seperate__increment--minus",
                    on: {
                      click: function($event) {
                        _vm.update_variant_quantities(variant_i, -1)
                      }
                    }
                  },
                  [_vm._v("-")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass:
                      "form-product-seperate__increment form-product-seperate__increment--plus",
                    on: {
                      click: function($event) {
                        _vm.update_variant_quantities(variant_i, 1)
                      }
                    }
                  },
                  [_vm._v("+")]
                )
              ])
            ])
          ]
        )
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-product-seperate__footer" }, [
      _vm.total_quantities
        ? _c(
            "a",
            {
              staticClass:
                "form-product-seperate__submit form-product-seperate__add-all btn btn--black",
              on: {
                click: function($event) {
                  _vm.addMultipleToCart()
                }
              }
            },
            [
              _c("span", { attrs: { "data-add-to-cart-text": "" } }, [
                _vm.product.available
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t\tAdd " +
                          _vm._s(_vm.total_quantities) +
                          " To Cart\n          "
                      )
                    ])
                  : _c("span", [_vm._v("\n\t\t\t\t\tSold Out\n\t\t\t\t\t")])
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a5059c2", esExports)
  }
}

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_js__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91b0b738_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_product_vue__ = __webpack_require__(46);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(43)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_product_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91b0b738_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-product/form-product.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-91b0b738", Component.options)
  } else {
    hotAPI.reload("data-v-91b0b738", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(44);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("56505fa0", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-91b0b738\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-product.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-91b0b738\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-product.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-PRODUCT-SEPERATE\n\n*/\n", ""]);

// exports


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cart = __webpack_require__(4);

var _cart2 = _interopRequireDefault(_cart);

var _product = __webpack_require__(5);

var _product2 = _interopRequireDefault(_product);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export the directive
module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    handle: String
  },

  /**
   * The form's data
   * @return {Object}
   */
  data: function data() {
    return {
      product: {
        variants: [],
        price_varies: false
      },
      quantity: 1,
      current_variant: {}
    };
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {

    // Instantiate the current product
    this.grabProduct(this.handle);
  },


  // Methods we can action with
  methods: Object.assign(_helpers2.default.methods, _cart2.default.methods, _product2.default.methods, {})

};

// Grab our helper methods
/*

	FORM-PRODUCT-SEPERATE

*/

// Grab our cart methods

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-product__separate" }, [
    _c(
      "form",
      {
        staticClass: "page-product__form",
        attrs: {
          action: "/cart/add",
          method: "post",
          enctype: "multipart/form-data"
        }
      },
      [
        _vm.product.variants.length > 1
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "page-product__selector-wrapper selector-wrapper js"
                },
                [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.current_variant,
                          expression: "current_variant"
                        }
                      ],
                      staticClass: "page-product__select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.current_variant = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.product.variants, function(variant) {
                      return _c("option", { domProps: { value: variant } }, [
                        _vm._v(
                          "\n\t          " +
                            _vm._s(variant.title) +
                            "\n\t        "
                        )
                      ])
                    })
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "page-product__multiplier" }, [
          _c("div", { staticClass: "page-product__quantity" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.quantity,
                  expression: "quantity"
                }
              ],
              staticClass: "page-product__number",
              attrs: { type: "number", min: "1" },
              domProps: { value: _vm.quantity },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.quantity = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "page-product__price-wrapper",
              attrs: { "data-price-wrapper": "" }
            },
            [
              _c(
                "span",
                {
                  staticClass: "page-product__price",
                  attrs: { "data-product-price": "" }
                },
                [
                  _vm._v(
                    "\n\t\t      " +
                      _vm._s(_vm.money(_vm.current_variant.price)) +
                      "\n\t\t    "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.current_variant.compare_at_price &&
              _vm.current_variant.compare_at_price > _vm.current_variant.price
                ? _c("span", [
                    _c(
                      "span",
                      {
                        staticClass: "visually-hidden",
                        attrs: { "data-compare-text": "" }
                      },
                      [
                        _vm._v(
                          "\n\t\t        " +
                            _vm._s(
                              _vm._f("t")("products.product.regular_price")
                            ) +
                            "\n\t\t      "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "s",
                      {
                        staticClass:
                          "page-product__price page-product__price--compare",
                        attrs: { "data-compare-price": "" }
                      },
                      [
                        _vm._v(
                          "\n\t\t        " +
                            _vm._s(
                              _vm.money(_vm.current_variant.compare_at_price)
                            ) +
                            "\n\t\t      "
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-product__total" }, [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.money(_vm.current_variant.price * _vm.quantity)) +
              "\n\t\t"
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "page-product__submit btn",
            attrs: {
              disabled: !_vm.current_variant.available,
              "data-add-to-cart": ""
            },
            on: {
              click: function($event) {
                _vm.current_variant.available
                  ? _vm.addSingleToCart(_vm.current_variant.id, _vm.quantity)
                  : null
              }
            }
          },
          [
            _c("span", { attrs: { "data-add-to-cart-text": "" } }, [
              _vm.current_variant.available
                ? _c(
                    "span",
                    [
                      _c("cart-updating", { attrs: { text: "Adding..." } }, [
                        _vm._v("\n\t\t\t\t\t\tAdd to cart\n\t\t\t\t\t")
                      ])
                    ],
                    1
                  )
                : _c("span", [_vm._v("\n\t\t\t\t\tSold out\n\t        ")])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-91b0b738", esExports)
  }
}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_search_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_search_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_search_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd9e5270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_search_vue__ = __webpack_require__(51);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(48)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_search_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd9e5270_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-search/form-search.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dd9e5270", Component.options)
  } else {
    hotAPI.reload("data-v-dd9e5270", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(49);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("2401caad", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dd9e5270\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-search.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-dd9e5270\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-search.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-SEARCH\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.form-search {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  -webkit-transform-origin: center center;\n      -ms-transform-origin: center center;\n          transform-origin: center center;\n  -webkit-transform: translateY(100%);\n      -ms-transform: translateY(100%);\n          transform: translateY(100%);\n  -webkit-transition: opacity 0.2s 0.2s, -webkit-transform 0.2s 0.2s;\n  transition: opacity 0.2s 0.2s, -webkit-transform 0.2s 0.2s;\n  -o-transition: transform 0.2s 0.2s, opacity 0.2s 0.2s;\n  transition: transform 0.2s 0.2s, opacity 0.2s 0.2s;\n  transition: transform 0.2s 0.2s, opacity 0.2s 0.2s, -webkit-transform 0.2s 0.2s;\n}\n.form-search__items {\n    display: none;\n    position: absolute;\n    left: 0;\n    bottom: 100%;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    max-width: 320px;\n}\n.form-search--below .form-search__items {\n      bottom: auto;\n      top: 100%;\n}\n.form-search:hover .form-search__items,\n    .form-search--interacting .form-search__items {\n      display: block;\n}\n.form-search--none .form-search__items,\n    .form-search--none:hover .form-search__items {\n      display: none;\n}\n.form-search__image {\n    display: block;\n    width: 100px;\n    min-width: 100px;\n    background-position: center center;\n    background-size: cover;\n}\n.form-search__image + .form-search__content {\n      max-width: calc(100% - 100px);\n}\n.form-search__item {\n    display: block;\n    background: #fff;\n    border: 1px solid #efefef;\n    border-top: none;\n    overflow: hidden;\n}\n.form-search__item:first-child {\n      border-top: 1px solid #efefef;\n}\n.form-search__item:nth-child(1) {\n      -webkit-animation-delay: 0.3s;\n              animation-delay: 0.3s;\n}\n.form-search__item:nth-child(2) {\n      -webkit-animation-delay: 0.2s;\n              animation-delay: 0.2s;\n}\n.form-search__item:nth-child(3) {\n      -webkit-animation-delay: 0.1s;\n              animation-delay: 0.1s;\n}\n.form-search__item:nth-child(4) {\n      -webkit-animation-delay: 0s;\n              animation-delay: 0s;\n}\n.form-search__link {\n    -webkit-box-pack: start;\n    -webkit-justify-content: flex-start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n    -webkit-box-align: stretch;\n    -webkit-align-items: stretch;\n        -ms-flex-align: stretch;\n            align-items: stretch;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    text-decoration: none;\n    color: #000;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n}\n.form-search__link:hover {\n      color: #eb412c;\n}\n.form-search__type {\n    font-size: 0.7em;\n    color: #888;\n    display: block;\n    text-transform: capitalize;\n}\n.form-search__content {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    text-align: left;\n    max-width: 100%;\n    padding: 20px;\n}\n.form-search__form {\n    width: 100%;\n}\n.form-search__input {\n    -webkit-border-radius: 0px;\n    width: 100%;\n    height: 50px;\n    background-color: rgba(255, 255, 255, 0.1);\n    border: none;\n    padding: 0 20px;\n    font-size: 1em;\n    line-height: 1em;\n    color: #fff;\n    text-align: left;\n}\n.form-search__input:focus {\n      outline: none;\n}\n.form-search__input::-webkit-input-placeholder {\n      color: #000;\n      opacity: 0.2;\n}\n.form-search__input::-moz-placeholder {\n      color: #000;\n      opacity: 0.2;\n}\n.form-search__input:-ms-input-placeholder {\n      color: #000;\n      opacity: 0.2;\n}\n.form-search__input:-moz-placeholder {\n      color: #000;\n      opacity: 0.2;\n}\n.form-search__button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 50px;\n    width: 50px;\n    background-color: transparent;\n    border: none;\n    color: #000;\n    opacity: 0.5;\n}\n.form-search__button .icon {\n      width: 20px;\n      height: 20px;\n}\n.form-search__button:hover {\n      color: #fff;\n      background-color: transparent;\n      opacity: 1;\n}\n", ""]);

// exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	FORM-SEARCH

*/

module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    term: String,
    position: 'above'
  },

  /**
   * The data on the component
   * @return {Object}
   */
  data: function data() {
    return {

      // Holds the items from the search results
      items: [],

      // Flag to watch for user interaction
      is_interacting: false,

      // Stores the latest search time
      latest_search: null

    };
  },

  /**
   * When the component mounts
   * @return {Null}
   */
  mounted: function mounted() {

    // Updates the list if search field
    if (this.term) this.updateList();
  },


  /**
   * The components computed props
   * @type {Object}
   */
  computed: {

    input_term: {

      /**
       * Gets the term with transformations
       * @return {String} The search term
       */
      get: function get() {
        return this.term.replace(/\**$/, '');
      },


      /**
       * Transforms and sets the search term
       * @param {String} term The transformable search term
       */
      set: function set(term) {
        this.term = term.replace(/\**$/, '');
        this.updateList();
        return this.term;
      }
    },

    /**
     * Is the user interacting?
     * @return {[type]} [description]
     */
    interacting: {

      /**
       * Get the interacting state
       * @return {Boolean} The interacting state
       */
      get: function get() {
        return this.is_interacting;
      },

      /**
       * Sets the interaction state
       * @param  {Boolean} is_interacting The interaction state
       * @return {Boolean}
       */
      set: function set(is_interacting) {
        var _this = this;

        if (is_interacting) {
          this.is_interacting = is_interacting;
        } else {
          setTimeout(function () {
            return _this.is_interacting = is_interacting;
          }, 0);
        }
        return is_interacting;
      }

    }

  },

  /**
   * Methods on the component
   * @type {Object}
   */
  methods: {

    /**
     * Updates the list with relevant search items
     * @return {Null}
     */
    updateList: function updateList() {

      // Set the latest search flag
      this.latest_search = new Date();

      // reset the list on empty term
      if (!this.term) {
        this.latest_search = null;
        this.items = [];
        return null;
      }

      // Set up our env vars
      var r = new XMLHttpRequest(),
          self = this,
          search_date = this.latest_search;

      // Make the call to the cart
      r.open("GET", '/search?q=' + this.input_term + '*&view=json', true);

      // Updates the cart
      r.onreadystatechange = function () {

        // jump out if not ready
        if (r.readyState != 4) return;

        // Parse the search return
        if (self.latest_search == search_date) {
          self.latest_search = null;
          self.items = JSON.parse(r.responseText);
        }
      };

      // send the request
      r.send();
    }

  }

};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-search",
      class: [
        "form-search--" + _vm.position,
        { "form-search--interacting": _vm.interacting }
      ]
    },
    [
      _vm.input_term
        ? _c(
            "ul",
            { staticClass: "form-search__items" },
            [
              _vm.latest_search
                ? _c(
                    "li",
                    {
                      staticClass: "form-search__item animated fadeInLeftSmall"
                    },
                    [
                      _c("span", { staticClass: "form-search__content" }, [
                        _c("span", [
                          _c("small", { staticClass: "form-search__type" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tSearching site for\n\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "form-search__title" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(_vm.input_term) +
                                "\n\t\t\t\t\t\t"
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                : _vm.items.length > 1
                  ? _vm._l(_vm.items, function(item) {
                      return _c(
                        "li",
                        {
                          staticClass:
                            "form-search__item animated fadeInLeftSmall",
                          class: ["form-search__item--" + item.object_type]
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "form-search__link",
                              attrs: { href: item.url }
                            },
                            [
                              item.image && !item.image.match("no-image")
                                ? _c("span", {
                                    staticClass: "form-search__image",
                                    style:
                                      "background-image: url(" +
                                      _vm.$root.sImage(
                                        item.image,
                                        "100x100_crop_center"
                                      ) +
                                      ")"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "form-search__content" },
                                [
                                  _c("span", [
                                    _c(
                                      "small",
                                      { staticClass: "form-search__type" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              item.object_type.replace(
                                                /_/g,
                                                " "
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.title
                                      ? _c(
                                          "span",
                                          { staticClass: "form-search__title" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(item.title) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\tView all (" +
                                              _vm._s(item.results_count) +
                                              ") results\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                  ])
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  : _c(
                      "li",
                      {
                        staticClass:
                          "form-search__item animated fadeInLeftSmall"
                      },
                      [
                        _c("span", { staticClass: "form-search__content" }, [
                          _c("span", [
                            _c("small", { staticClass: "form-search__type" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\tNo results found for:\n\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "form-search__title" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.input_term) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          ])
                        ])
                      ]
                    )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form-search__search",
          attrs: { action: "/search", method: "get", role: "search" }
        },
        [
          _c(
            "label",
            {
              staticClass: "form-search__label label-hidden",
              attrs: { for: "Search" }
            },
            [_vm._v("\n\t\t\t\tSearch\n\t\t\t\t")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.input_term,
                expression: "input_term"
              }
            ],
            staticClass: "form-search__input",
            attrs: {
              type: "text",
              name: "q",
              autocomplete: "off",
              id: "Search",
              placeholder: "Search"
            },
            domProps: { value: _vm.input_term },
            on: {
              focus: function($event) {
                _vm.interacting = true
              },
              blur: function($event) {
                _vm.interacting = false
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.input_term = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "form-search__button btn",
              attrs: { type: "submit" }
            },
            [_vm._t("default", [_vm._v("Search")])],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd9e5270", esExports)
  }
}

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_shipping_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_shipping_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_form_shipping_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e60efa58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_shipping_vue__ = __webpack_require__(56);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(53)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_form_shipping_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e60efa58_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_form_shipping_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/form-shipping/form-shipping.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e60efa58", Component.options)
  } else {
    hotAPI.reload("data-v-e60efa58", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(54);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("a5126f9e", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e60efa58\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-shipping.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-e60efa58\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./form-shipping.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tFORM-SHIPPING\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.form-shipping {\n  margin: 20px 0;\n}\n.form-shipping__input--select {\n    margin-bottom: -1px;\n}\n.form-shipping__input {\n    z-index: 1;\n    position: relative;\n    border: 1px solid #efefef;\n    background-color: #fff;\n}\n.form-shipping__input:focus {\n      z-index: 2;\n}\n.form-shipping__submit {\n    margin: 10px 0 0 10px;\n}\n.form-shipping__info {\n    margin: 0;\n}\n", ""]);

// exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Start the directive
module.exports = {

  /**
   * Component properties
   * @type {Object}
   */
  props: {
    shipping_show: Boolean
  },

  /**
   * Store data relevant to the component
   * @type {Object}
   */
  data: function data() {
    return {

      /**
       * Sets the editing state
       * @type {Boolean}
       */
      editing: false,

      /**
       * The shippable provinces
       * @type {Object}
       */
      provinces: {
        'US': ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Federated States of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Island', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
        'Canada': ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon Territory']
      },

      /**
       * The shippable countries
       * @type {Array}
       */
      countries: ['Canada', 'US']

    };
  },

  watch: {

    /**
     * When the shipping country changes
     * @return {Null}
     */
    'shipping.country': function shippingCountry() {

      // If the current country's province does not match
      // the current province, set the province to the first
      // of the country's provinces
      if (this.current_provinces && !~this.current_provinces.indexOf(this.shipping.province)) this.shipping.province = this.current_provinces[0];
    }

  },

  /**
   * Methods attached to the shipping directive
   */
  methods: Object.assign(_helpers2.default.methods, {

    /**
     * Deletes shipping data
     * @return {Null}
     */
    deleteInfo: function deleteInfo() {

      // deletes shipping address
      this.$root.deleteShippingAddress();

      // resets the shipping rates
      this.$root.resetShippingRates();
    },

    /**
     * Edits the info
     * @return {Null}
     */
    resetInfo: function resetInfo() {

      // resets the shipping rates
      this.$root.resetShippingRates();

      // Set the editing state true
      this.editing = true;
    }

  }),

  /**
   * Computed props
   * @type {Object}
   */
  computed: {

    /**
     * Set the shipping to the root's shipping
     * @return {Object} The shipping object
     */
    shipping: function shipping() {
      return this.$root.shipping;
    },

    /**
     * Outputs provinces relative to the current country
     * @return {Array} The list of provinces
     */
    current_provinces: function current_provinces() {
      return this.shipping.country ? this.provinces[this.shipping.country] : null;
    }

  }

}; /*
   
   	FORM-SHIPPING
   
   */

// Grab our helper methods

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-shipping" }, [
    !_vm.shipping.rates.length && !_vm.$root.cart_updating_shipping
      ? _c("form", { staticClass: "form-shipping__form" }, [
          !_vm.editing
            ? _c("div", [
                _c(
                  "a",
                  {
                    staticClass: "a",
                    on: {
                      click: function($event) {
                        _vm.editing = true
                      }
                    }
                  },
                  [
                    _c("small", [
                      _vm._v("\n\t\t\t\t\tCheck estimated shipping\n\t\t\t\t")
                    ])
                  ]
                )
              ])
            : _c("div", [
                _vm.shipping.error
                  ? _c("p", { staticClass: "alert alert--error" }, [
                      _c("small", [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.shipping.error) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.shipping.country,
                        expression: "shipping.country"
                      }
                    ],
                    staticClass:
                      "form-shipping__input form-shipping__input--select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.shipping,
                          "country",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.countries, function(country) {
                    return _c("option", { domProps: { value: country } }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(country) + "\n\t\t\t\t")
                    ])
                  })
                ),
                _c("br"),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.shipping.province,
                        expression: "shipping.province"
                      },
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.shipping.country,
                        expression: "shipping.country"
                      }
                    ],
                    staticClass:
                      "form-shipping__input form-shipping__input--select",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.shipping,
                          "province",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  _vm._l(_vm.current_provinces, function(province, province_i) {
                    return _c("option", { domProps: { value: province } }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(province) + "\n\t\t\t\t")
                    ])
                  })
                ),
                _c("br"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.shipping.zip,
                      expression: "shipping.zip"
                    }
                  ],
                  staticClass: "form-shipping__input",
                  attrs: { type: "text", placeholder: "Zip code" },
                  domProps: { value: _vm.shipping.zip },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.shipping, "zip", $event.target.value)
                    }
                  }
                }),
                _c("br"),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "a",
                    on: {
                      click: function($event) {
                        _vm.editing = false
                      }
                    }
                  },
                  [_c("small", [_vm._v("\n\t\t\t\t\tCancel\n\t\t\t\t")])]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "btn form-shipping__submit",
                    on: {
                      click: function($event) {
                        _vm.$root.updateShippintRates()
                      }
                    }
                  },
                  [_vm._v("Get Estimates")]
                )
              ])
        ])
      : !_vm.shipping.error
        ? _c(
            "p",
            { staticClass: "form-shipping__info" },
            [
              _c("strong", [_vm._v("Estimated Shipping:")]),
              _c("br"),
              _vm._v(" "),
              _c("cart-updating", { attrs: { type: "shipping" } }, [
                _vm.$root.shipping_total
                  ? _c("span", [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$root.shipping_cheapest.name) +
                          ": " +
                          _vm._s(_vm.money(_vm.$root.shipping_total)) +
                          "\n\t\t\t"
                      )
                    ])
                  : _vm._e()
              ]),
              _c("br"),
              _vm._v(" "),
              _vm.shipping.rates.length
                ? _c(
                    "a",
                    {
                      on: {
                        click: function($event) {
                          _vm.resetInfo()
                        }
                      }
                    },
                    [
                      _c("small", [
                        _vm._v(
                          "\n\t\t\t\t(" +
                            _vm._s(_vm.shipping.country) +
                            ",\n\t\t\t\t" +
                            _vm._s(_vm.shipping.province) +
                            ",\n\t\t\t\t" +
                            _vm._s(_vm.shipping.zip) +
                            ")\n\t\t\t"
                        )
                      ]),
                      _c("br")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.shipping.rates.length
                ? _c(
                    "a",
                    {
                      staticClass: "a",
                      on: {
                        click: function($event) {
                          _vm.resetInfo()
                        }
                      }
                    },
                    [_c("small", [_vm._v("\n\t\t\t\tChange\n\t\t\t")])]
                  )
                : _vm._e(),
              _vm._v("  \n\n\t\t"),
              _c(
                "a",
                {
                  staticClass: "a",
                  on: {
                    click: function($event) {
                      _vm.deleteInfo()
                    }
                  }
                },
                [_c("small", [_vm._v("\n\t\t\t\tReset\n\t\t\t")])]
              )
            ],
            1
          )
        : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e60efa58", esExports)
  }
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_product_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_product_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_link_product_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1927b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_link_product_vue__ = __webpack_require__(61);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(58)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_link_product_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1927b8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_link_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/link-product/link-product.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a1927b8", Component.options)
  } else {
    hotAPI.reload("data-v-2a1927b8", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(59);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("dc4bbc10", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a1927b8\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./link-product.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a1927b8\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./link-product.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tLINK-PRODUCT\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.link-product {\n  cursor: pointer;\n  display: none;\n  position: relative;\n}\n.link-product__image {\n    position: absolute;\n    bottom: calc(100% + 10px);\n    left: 50%;\n    -webkit-transform: translate(-50%, -5px);\n        -ms-transform: translate(-50%, -5px);\n            transform: translate(-50%, -5px);\n    opacity: 0;\n    border: 2px solid #000;\n}\n.link-product__image img {\n      display: none;\n      position: relative;\n      max-width: none;\n      z-index: 2;\n}\n.link-product__image:before {\n      content: '';\n      display: block;\n      position: absolute;\n      top: 100%;\n      left: 50%;\n      -webkit-transform: translate(-50%, -50%) rotate(45deg);\n          -ms-transform: translate(-50%, -50%) rotate(45deg);\n              transform: translate(-50%, -50%) rotate(45deg);\n      z-index: 1;\n      width: 10px;\n      height: 10px;\n      background: #000;\n}\n.link-product:hover .link-product__image {\n      opacity: 1;\n      -webkit-transform: translate(-50%, 0);\n          -ms-transform: translate(-50%, 0);\n              transform: translate(-50%, 0);\n      -webkit-transition: all 0.2s;\n      -o-transition: all 0.2s;\n      transition: all 0.2s;\n}\n.link-product:hover .link-product__image img {\n        display: block;\n}\n.link-product--loaded {\n    display: inline-block;\n}\n", ""]);

// exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _product = __webpack_require__(5);

var _product2 = _interopRequireDefault(_product);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export the component
/*

	LINK-PRODUCT

*/

// import product methods
module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {

    // The handle of the product
    handle: String

  },

  /**
   * The form's data
   * @return {Object}
   */
  data: function data() {
    return {
      product: null
    };
  },

  /**
  * Fires when the component is loaded
  */
  mounted: function mounted() {

    // Instantiate the current product
    this.grabProduct(this.handle);
  },


  // Methods we can action with
  methods: Object.assign(_product2.default.methods, _helpers2.default.methods, {}),

  // computed props on the component
  computed: {

    /**
     * Builds the image to go along with the link
     * @return {String} The image src
     */
    img_src: function img_src() {
      return this.sImage(this.product.featured_image, '100x100_crop_center');
    }

  }

};

// Grab our helper methods

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "link-product a",
      class: [{ "link-product--loaded": _vm.product }],
      on: {
        click: function($event) {
          _vm.$root.addSingleToCart(_vm.product.variants[0].id, 1)
        }
      }
    },
    [
      _vm.product
        ? _c("span", [
            _vm._v("\n\t\t" + _vm._s(_vm.product.title) + " +\n\t\t"),
            _vm.img_src
              ? _c("span", { staticClass: "link-product__image" }, [
                  _c("img", { attrs: { src: _vm.img_src } })
                ])
              : _vm._e()
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a1927b8", esExports)
  }
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mini_cart_js__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mini_cart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mini_cart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245eae92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_cart_vue__ = __webpack_require__(66);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(63)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mini_cart_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245eae92_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_cart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/mini-cart/mini-cart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-245eae92", Component.options)
  } else {
    hotAPI.reload("data-v-245eae92", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(64);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("71a9a145", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-245eae92\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./mini-cart.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-245eae92\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./mini-cart.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tMINI-CART\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.mini-cart {\n  position: relative;\n  overflow: visible;\n  z-index: 100;\n}\n.mini-cart__empty {\n    text-align: center;\n    padding: 20px 0;\n}\n.mini-cart__empty p {\n      margin-top: 0;\n}\n.mini-cart__wrapper {\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    max-width: 320px;\n    width: 100%;\n    padding: 0 20px;\n    background: #efefef;\n    -webkit-transition: all 0.2s;\n    -o-transition: all 0.2s;\n    transition: all 0.2s;\n    -webkit-transform: translateX(100%);\n        -ms-transform: translateX(100%);\n            transform: translateX(100%);\n}\n.mini-cart--open .mini-cart__wrapper {\n      -webkit-transform: translateX(0);\n          -ms-transform: translateX(0);\n              transform: translateX(0);\n      -webkit-box-shadow: -10px 0 20px 0px rgba(0, 0, 0, 0.1);\n              box-shadow: -10px 0 20px 0px rgba(0, 0, 0, 0.1);\n}\n.mini-cart__overlay {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #000;\n    opacity: 0.5;\n}\n.mini-cart__title {\n    text-transform: uppercase;\n    margin: 0;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding-right: 30px;\n}\n.mini-cart__title .cart-updating {\n      font-family: \"Nunito\", \"Roboto\", sans-serif;\n      font-size: 0.8em;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n      -webkit-align-items: center;\n          -ms-flex-align: center;\n              align-items: center;\n      font-weight: normal;\n}\n.mini-cart__header {\n    margin: 0 -20px;\n    padding: 20px;\n    background: #000;\n    color: #fff;\n    position: relative;\n}\n.mini-cart__items {\n    padding: 0;\n}\n.mini-cart__total {\n    text-align: right;\n}\n.mini-cart__push {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    overflow: hidden;\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n    height: calc(100vh - 67px);\n    padding: 20px;\n    margin: 0px -20px 0;\n}\n@media only screen and (max-width: 749px) {\n.mini-cart__push {\n        padding: 20px 20px 70px;\n}\n}\n.mini-cart__close {\n    position: absolute;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    cursor: pointer;\n    top: 0;\n    right: 0;\n    padding: 20px 20px 23px;\n    height: 100%;\n    font-size: 2em;\n}\n.mini-cart__buttons {\n    text-align: right;\n}\n.mini-cart__buttons .btn {\n      min-width: 0px;\n      width: 100%;\n}\n.mini-cart__buttons:first-child {\n      margin-bottom: 20px;\n}\n.mini-cart__currency {\n    margin-left: 10px;\n    display: inline-block;\n}\n.mini-cart__item {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n    -webkit-justify-content: space-between;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    margin-bottom: 20px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid #cfcfcf;\n    font-size: 0.8em;\n}\n.mini-cart__item:last-child {\n      margin-bottom: 0;\n}\n.mini-cart__item-footer {\n      text-align: right;\n      -webkit-align-self: stretch;\n          -ms-flex-item-align: stretch;\n              align-self: stretch;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -webkit-flex-direction: column;\n          -ms-flex-direction: column;\n              flex-direction: column;\n      -webkit-box-pack: justify;\n      -webkit-justify-content: space-between;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n}\n.mini-cart__item-footer .component-quantity {\n        -webkit-box-pack: end;\n        -webkit-justify-content: flex-end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n}\n.mini-cart__item-header {\n      padding-left: 10px;\n}\n.mini-cart__item-title {\n      font-family: \"Roboto\", sans-serif;\n      font-weight: 700;\n      margin: 0;\n      font-size: 1em;\n}\n.mini-cart__item-remove {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      font-size: 1.25em;\n      padding: 0;\n      width: 20px;\n      height: 20px;\n      -webkit-transform: translate(-50%, -50%);\n          -ms-transform: translate(-50%, -50%);\n              transform: translate(-50%, -50%);\n}\n.mini-cart__item-image {\n      position: relative;\n      display: -webkit-box;\n      display: -webkit-flex;\n      display: -ms-flexbox;\n      display: flex;\n}\n.mini-cart__item .component-quantity__adjust {\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n}\n.mini-cart--open {\n    overflow: hidden;\n}\n", ""]);

// exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _cart = __webpack_require__(4);

var _cart2 = _interopRequireDefault(_cart);

var _helpers = __webpack_require__(3);

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Start the component
/*

	MINI-CART

*/

// Grab our cart methods
module.exports = {

  data: function data() {
    return {
      open: false
    };
  },

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    cart: Object
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {

    // Attach the minicart to the app
    this.$root.minicart = this;

    // Make the component visible
    this.$el.style.display = 'block';
  },


  /**
   * Watchers for observing changes on properties
   * @type {Object}
   */
  watch: {

    /**
     * Watches for when the open state changes
     * aka when the sidebar is open
     * @param {Boolean} state
     */
    open: function open(state) {
      document.body.classList[state ? 'add' : 'remove']('mini-cart--open');
    }

  },

  /**
   * Methods we can action with
   * @type {Object}
   */
  methods: Object.assign(_helpers2.default.methods, _cart2.default.methods, {

    /**
     * Opens and closes the mini cart
     * @return {Null}
     */
    toggleOpen: function toggleOpen() {
      this.open = !this.open;
    }

  })

};

// Grab our helper methods

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: ["mini-cart"]
    },
    [
      _vm.cart.item_count
        ? _c(
            "a",
            {
              staticClass: "site-header__cart animated bounce",
              attrs: { href: "#cart" },
              on: {
                click: function($event) {
                  _vm.toggleOpen()
                }
              }
            },
            [
              _vm._t("default"),
              _vm._v(" "),
              _c("span", { staticClass: "site-header__cart-count" }, [
                _vm._v("\n\t\t\t" + _vm._s(_vm.cart.item_count) + "\n\t\t")
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.open
        ? _c("a", {
            staticClass: "mini-cart__overlay",
            on: {
              click: function($event) {
                _vm.toggleOpen()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mini-cart__wrapper" }, [
        _c("div", { staticClass: "mini-cart__contents" }, [
          _c("div", { staticClass: "mini-cart__header" }, [
            _c(
              "h2",
              { staticClass: "mini-cart__title" },
              [
                _c("span", [_vm._v("Cart")]),
                _vm._v(" "),
                _c("cart-updating", [
                  _vm.cart.item_count
                    ? _c("span", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(_vm.money(_vm.cart.total_price)) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mini-cart__close",
                on: {
                  click: function($event) {
                    _vm.toggleOpen()
                  }
                }
              },
              [_vm._v("\n\t\t\t\t\t×\n\t\t\t\t")]
            )
          ]),
          _vm._v(" "),
          _vm.cart.item_count
            ? _c("div", { staticClass: "mini-cart__push" }, [
                _c(
                  "div",
                  { staticClass: "mini-cart__items" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._l(_vm.cart.items, function(item) {
                      return _c("div", { staticClass: "mini-cart__item" }, [
                        _c("div", { staticClass: "mini-cart__item-image" }, [
                          _c(
                            "a",
                            {
                              staticClass: "mini-cart__item-remove btn",
                              on: {
                                click: function($event) {
                                  _vm.removeCartItem(item)
                                }
                              }
                            },
                            [
                              _c("small", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t×\n\t\t\t\t\t\t\t\t"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          item.image
                            ? _c(
                                "a",
                                {
                                  staticClass: "mini-cart__item-image",
                                  attrs: { href: item.url }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.sImage(
                                        item.image,
                                        "50x50_crop_center"
                                      ),
                                      alt: item.title
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mini-cart__item-header" }, [
                            _c("h3", { staticClass: "mini-cart__item-title" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t" +
                                  _vm._s(item.title) +
                                  "\n\t\t\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "mini-cart__item-quantity" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(item.quantity) +
                                    " ×\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.original_price != item.price
                              ? _c("span", [
                                  _c(
                                    "span",
                                    { staticClass: "visually-hidden" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tDiscount Price\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.money(item.price)) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "visually-hidden" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tOriginal Price\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("s", [
                                    _vm._v(
                                      _vm._s(_vm.money(item.original_price))
                                    )
                                  ])
                                ])
                              : _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.money(item.price)) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  )
                                ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mini-cart__item-footer" }, [
                          _c("span", { staticClass: "mini-cart__item-price" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.money(item.price * item.quantity)) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "component-quantity" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "component-quantity__adjust component-quantity__adjust--minus",
                                attrs: { "data-amount": "-1" },
                                on: {
                                  click: function($event) {
                                    item.quantity > 1
                                      ? _vm.updateCartItem(
                                          item,
                                          --item.quantity
                                        )
                                      : null
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t−\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "component-quantity__adjust component-quantity__adjust--plus",
                                on: {
                                  click: function($event) {
                                    _vm.updateCartItem(item, ++item.quantity)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t+\n\t\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mini-cart__buttons" }, [
                  _c(
                    "div",
                    { staticClass: "mini-cart__total" },
                    [
                      _c(
                        "p",
                        [
                          _c("strong", [_vm._v("Subtotal:")]),
                          _c("br"),
                          _vm._v(" "),
                          _c("cart-updating", [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.money(_vm.cart.total_price)) +
                                "\n\t\t\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.cart.total_discount
                        ? _c(
                            "p",
                            [
                              _c("strong", [_vm._v("Discount")]),
                              _c("br"),
                              _vm._v(" "),
                              _c("cart-updating", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.money(_vm.cart.total_discount)) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("form-shipping"),
                      _vm._v(" "),
                      _c("cart-note", {
                        attrs: { note: _vm.cart.note, text: "Note:" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                  _c("br"),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v("  \n\n\t\t\t\t\t"),
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mini-cart__currency" },
                    [_c("form-currency")],
                    1
                  )
                ])
              ])
            : _c(
                "div",
                { staticClass: "mini-cart__empty" },
                [
                  _c("cart-updating", [
                    _c("p", [_vm._v("Your cart is empty.")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn",
                        attrs: { href: "/collections/shop" }
                      },
                      [_vm._v("\n\t\t\t\t\t\tShop\n\t\t\t\t\t")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn",
                        attrs: { href: "/collections/shop" }
                      },
                      [_vm._v("\n\t\t\t\t\t\tVideos\n\t\t\t\t\t")]
                    )
                  ])
                ],
                1
              )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mini-cart__buttons" }, [
      _c(
        "form",
        { attrs: { action: "/cart", method: "post", novalidate: "" } },
        [
          _c("input", {
            staticClass: "btn",
            attrs: { type: "submit", name: "checkout", value: "Checkout" }
          })
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "form",
      { attrs: { action: "/cart", method: "post", novalidate: "" } },
      [
        _c("input", {
          staticClass: "btn",
          attrs: { type: "submit", name: "checkout", value: "Checkout" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "a", attrs: { href: "/cart" } }, [
      _c("small", [_vm._v("\n\t\t\t\t\t\t\tModify Cart\n\t\t\t\t\t\t")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "a", attrs: { href: "/collections/shop" } }, [
      _c("small", [_vm._v("\n\t\t\t\t\t\t\tShop\n\t\t\t\t\t\t")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-245eae92", esExports)
  }
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_quantity_js__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_quantity_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_quantity_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a66b784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_quantity_vue__ = __webpack_require__(71);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_quantity_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a66b784_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_quantity_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/quantity/quantity.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a66b784", Component.options)
  } else {
    hotAPI.reload("data-v-2a66b784", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(69);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("1ac00375", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a66b784\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./quantity.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2a66b784\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./quantity.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tQUANTITY\n\n*/\n", ""]);

// exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	QUANTITY

*/

module.exports = {

	/**
  * Component properties
  * @type {Array}
  */
	props: [],

	/**
  * Fires when the component is loaded
  */
	mounted: function mounted() {
		console.log('quantity is now loaded');
	}
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "quantity" }, [
      _c("h1", { staticClass: "quantity__title h1" }, [
        _vm._v("\n\t\tQuantity Title\n\t")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "quantity__text" }, [
        _vm._v(
          "\n\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit. Impedit non, dolorum deleniti voluptates perferendis, perspiciatis cum praesentium labore consectetur, eaque neque illo, dolore laboriosam obcaecati vel nisi quibusdam dolor! Optio?\n\t"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a66b784", esExports)
  }
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_feed_js__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_feed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_search_feed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b15d28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_search_feed_vue__ = __webpack_require__(76);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(73)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_search_feed_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31b15d28_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_search_feed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/search-feed/search-feed.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-31b15d28", Component.options)
  } else {
    hotAPI.reload("data-v-31b15d28", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(74);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("9c819182", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31b15d28\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./search-feed.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-31b15d28\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./search-feed.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tSEARCH-FEED\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.search-feed__filters {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  padding: 0;\n  list-style: none;\n  margin: 10px 0 20px;\n}\n@media only screen and (min-width: 750px) {\n.search-feed__filters {\n      margin: 0 0 20px;\n}\n}\n.search-feed__empty h2 {\n  margin: 0;\n}\n.search-feed__content {\n  display: block;\n  padding: 10px;\n}\n@media only screen and (min-width: 450px) {\n.search-feed__content {\n      padding: 20px;\n}\n}\n.search-feed__item {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border: 1px solid #efefef;\n  border-bottom: none;\n  text-decoration: none;\n  color: #000;\n}\n.search-feed__item:hover {\n    color: #eb412c;\n}\n.search-feed__item:last-child {\n    border-bottom: 1px solid #efefef;\n}\n.search-feed__type {\n  text-transform: capitalize;\n  color: #888;\n}\n.search-feed__image {\n  display: block;\n  width: 100px;\n  height: 100px;\n  min-width: 100px;\n  min-height: 100px;\n  background-position: center;\n  background-size: cover;\n  border-right: 1px solid #efefef;\n}\n.search-feed__title {\n  font-size: 1em;\n  font-weight: normal;\n  margin: 0;\n}\n.search-feed__filter {\n  cursor: pointer;\n  margin-right: 10px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-top: 10px;\n}\n.search-feed__filter:last-child {\n    margin-right: 0;\n}\n@media only screen and (min-width: 750px) {\n.search-feed__filter {\n      margin-top: 0px;\n}\n}\n.search-feed__link {\n  padding: 7.5px 10px;\n  background: #efefef;\n  display: inline-block;\n  color: #000;\n  border-radius: 5px;\n  -webkit-transition: all 0.2s;\n  -o-transition: all 0.2s;\n  transition: all 0.2s;\n  text-transform: capitalize;\n  font-size: 0.8em;\n}\n.search-feed__link:after {\n    content: '+';\n    padding-left: 5px;\n    display: inline-block;\n}\n.search-feed__filter--active .search-feed__link {\n    background: #000;\n    color: #fff;\n}\n.search-feed__filter--active .search-feed__link:after {\n      content: '\\D7';\n}\n.search-feed__link:hover {\n    color: #fff;\n    background: #333333;\n}\n", ""]);

// exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	SEARCH-FEED

*/

module.exports = {

  /**
   * Component properties
   * @type {Array}
   */
  props: {

    /**
     * The search results
     * @type {Array}
     */
    results: Array

  },

  /**
   * Component Data
   * @return {Object}
   */
  data: function data() {
    return {

      /**
       * Holds the filters
       * @type {Object}
       */
      filters: {}

    };
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {

    // Add the filters
    for (var i = 0, l = this.results.length; i < l; i++) {
      if (!this.filters[this.results[i].type]) this.filters[this.results[i].type] = true;
    }
  },


  /**
   * Computed props on the component
   * @type {Object}
   */
  computed: {},

  /**
   * Component's methods
   * @type {Object}
   */
  methods: {

    /**
     * Toggles the state of the filter
     * @param  {String} filter The filter to toggle
     * @return {Null}
     */
    toggleFilter: function toggleFilter(filter) {

      // Loop through the objects
      this.filters[filter] = !this.filters[filter];

      // Force the refresh, sigh....
      this.$forceUpdate();
    },


    /**
     * Counts the items with the specefied type
     * @param  {String}  type The type of filter
     * @return {Integer}      The item count
     */
    countFilter: function countFilter(type) {
      return this.results.filter(function (r) {
        return r.type == type;
      }).length;
    }
  }

};

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-feed" },
    [
      Object.keys(this.filters).length > 1
        ? _c(
            "ul",
            { staticClass: "search-feed__filters" },
            _vm._l(_vm.filters, function(state, filter) {
              return _c(
                "li",
                {
                  staticClass: "search-feed__filter",
                  class: { "search-feed__filter--active": state }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "search-feed__link",
                      on: {
                        click: function($event) {
                          _vm.toggleFilter(filter)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(filter) +
                          "s (" +
                          _vm._s(_vm.countFilter(filter)) +
                          ")\n\t\t\t"
                      )
                    ]
                  )
                ]
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.results.length
        ? _c("div", { staticClass: "search-feed__empty" }, [
            _c("h2", [_vm._v("Shucks!")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "We couldn't find anything matching what you were looking for."
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.results, function(result) {
        return _c(
          "a",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.filters[result.type] ||
                  !Object.keys(_vm.filters).some(function(v) {
                    return _vm.filters[v]
                  }),
                expression:
                  "filters[result.type] || !Object.keys(filters).some(v => filters[v])"
              }
            ],
            staticClass: "search-feed__item",
            attrs: { href: result.url }
          },
          [
            result.image
              ? _c("span", {
                  staticClass: "search-feed__image",
                  style: "background-image: url(" + result.image + ");"
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "search-feed__content" }, [
              _c("small", { staticClass: "search-feed__type" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(result.type) + "\n\t\t\t")
              ]),
              _vm._v(" "),
              _c("h3", { staticClass: "search-feed__title" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(result.title) + "\n\t\t\t")
              ])
            ])
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31b15d28", esExports)
  }
}

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_article_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_article_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_video_article_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40833d2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_video_article_vue__ = __webpack_require__(81);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(78)
}
var normalizeComponent = __webpack_require__(2)
/* script */
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_video_article_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40833d2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_video_article_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scripts/app/components/video-article/video-article.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40833d2e", Component.options)
  } else {
    hotAPI.reload("data-v-40833d2e", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(79);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1)("137378b2", content, false);
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-40833d2e\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./video-article.scss", function() {
     var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-40833d2e\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../node_modules/sass-loader/lib/loader.js!./video-article.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(0)(undefined);
// imports


// module
exports.push([module.i, "/*\n\n\tVIDEO-ARTICLE\n\n*/\n/*================ Color Variables ================*/\n/*================ Typography Variables ================*/\n/*============================================================================\n  Grid Breakpoints and Class Names\n    - Do not change the variable names\n==============================================================================*/\n/*============================================================================\n  Generate breakpoint-specific column widths and push classes\n    - Default column widths: $breakpoint-has-widths: ($small, $medium-up);\n    - Default is no push classes\n    - Will not work if `styles/global/grid.scss` is removed\n==============================================================================*/\n/*================ Sizing Variables ================*/\n/*================ Z-Index ================*/\n/*================ Border ================*/\n/*================ Transition Helpers ================*/\n/*================ Article Video ================*/\n/*================ Header ================*/\n/*================ Logo Variables ================*/\n/*================ Mixins ================*/\n/*============================================================================\n  Prefix mixin for generating vendor prefixes.\n  Based on https://github.com/thoughtbot/bourbon/blob/v4-stable/app/assets/stylesheets/addons/_prefixer.scss\n\n  Usage:\n    // Input:\n    .element {\n      @include prefix(transform, scale(1), ms webkit spec);\n    }\n\n    // Output:\n    .element {\n      -ms-transform: scale(1);\n      -webkit-transform: scale(1);\n      transform: scale(1);\n    }\n==============================================================================*/\n/*================ Media Query Mixin ================*/\n/*================ Responsive Show/Hide Helper ================*/\n/*================ Responsive Text Alignment Helper ================*/\n.video-article {\n  position: relative;\n  width: 100%;\n  min-width: 320px;\n  overflow: hidden;\n}\n.video-article:before {\n    content: '';\n    display: block;\n    position: relative;\n    padding-bottom: 56.25%;\n}\n.video-article__iframe {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

	VIDEO-ARTICLE

*/

module.exports = {

  /**
   * Stores the component's data
   * @return {Object}
   */
  data: function data() {
    return {
      iframe: null,
      yt_video: null,
      video_state: -1,
      video_props: ['mode=transparent', 'autohide=1', 'wmode=transparent', 'title=0', 'modestbranding=1', 'enablejsapi=1', 'rel=0']
    };
  },

  /**
   * Component properties
   * @type {Array}
   */
  props: {
    src: String
  },

  /**
   * Fires when the component is loaded
   */
  mounted: function mounted() {
    var _this = this;

    // assign the youtube video observing object
    window.onYouTubeIframeAPIReady = function () {
      return _this.initYoutubeLogic();
    };
  },


  /**
   * Watches for changes on the component
   * @type {Object}
   */
  watch: {

    /**
     * Tracks the state of the video
     * @param  {Integer} state the video's state
     * @return {Null}
     */
    video_state: function video_state(state) {

      switch (state) {
        case 1:
          document.body.classList.add('video-article--playing');
          break;
        case 2:
          document.body.classList.remove('video-article--playing');
          break;
        default:

      }
    }

  },

  /**
   * Holds the computed properties
   * @type {Object}
   */
  computed: {

    /**
     * Compiles the video SRC
     * @return {String} The video src for the iframe
     */
    video_src: function video_src() {

      // return the src if it's already an embed url
      if (this.src.match(/\/embed\//)) return this.src;

      // Grabs the id from the video url
      var src = this.src.match(/v=([^&]+)/, '')[1].replace(/^\s+|\s+$/, '');

      // returns the embed url
      return 'https://www.youtube.com/embed/' + src + '?' + this.video_props_string;
    },

    /**
     * returns the video props as a query string
     * @return {String} The query string
     */
    video_props_string: function video_props_string() {
      return this.video_props.join('&');
    }

  },

  /**
   * Methods attached to the component
   * @type {Object}
   */
  methods: {

    /**
     * Initiates the youtube logic
     * @return {Null}
     */
    initYoutubeLogic: function initYoutubeLogic() {

      // Sets the iframe instance
      this.iframe = this.$el.querySelector('.video-article__iframe');

      // Sets the youtube player
      this.yt_video = new YT.Player(this.iframe);

      // Sets up a state watcher
      this.setStateWatcher();
    },

    /**
     * Sets up a watcher that broadcast on video state change
     * @return {Null}
     */
    setStateWatcher: function setStateWatcher() {
      var _this2 = this;

      // Add the state change callback
      this.yt_video.addEventListener('onStateChange', function (e) {
        return _this2.video_state = e.data;
      });
    }

  }

};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-article" }, [
    _c("iframe", {
      staticClass: "video-article__iframe",
      attrs: {
        src: _vm.video_src,
        frameborder: "0",
        gesture: "media",
        allow: "encrypted-media",
        allowfullscreen: ""
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40833d2e", esExports)
  }
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Shipping Methods
 * @type {Object}
 */
module.exports = {

  /**
   * Shipping Data
   * @type {Object}
   */
  data: {
    shipping: {
      rates: [],
      zip: '',
      country: 'Canada',
      province: 'Alberta'
    }
  },

  /**
   * Shipping Watchers
   * @type {Object}
   */
  watch: {

    /**
     * Watch for updates on the cart
     * @param  {Object} cart The root cart object
     * @return {Null}
     */
    cart: function cart() {
      this.updateShippintRates();
    }

  },

  /**
   * Shipping Methods
   * @type {Object}
   */
  methods: {

    /**
     * Unsets the shipping rates
     */
    resetShippingRates: function resetShippingRates() {

      // reset the rates
      this.shipping.rates = [];
    },


    /**
     * Deletes the shipping address from storage
     */
    deleteShippingAddress: function deleteShippingAddress() {

      // delete from storage
      localStorage.setItem('rates_address_info', '');
    },


    /**
     * Sets the initial shipping rates based on storage
     */
    setInitialShippingRates: function setInitialShippingRates() {

      // initiate the shippint
      var stored_shipping = localStorage.getItem('rates_address_info'),
          shipping = stored_shipping ? JSON.parse(stored_shipping) : null;

      // Set the props and refersh rates
      if (shipping) {
        this.shipping.zip = shipping.zip;
        this.shipping.country = shipping.country;
        this.shipping.province = shipping.province;
        this.updateShippintRates();
      }
    },


    /**
     * Updates the rates
     * @return {Null}
     */
    updateShippintRates: function updateShippintRates() {

      // Skip out if nothing in cart
      if (!this.cart.items || !this.cart.items.length) return;

      // If information is not entered jump out
      if (!this.shipping.zip || !this.shipping.province || !this.shipping.country) return; // alert('please enter required information');

      // Set up our env vars
      var r = new XMLHttpRequest(),
          self = this;

      // Add to the updating queue
      self.cart_updating_shipping++;

      // Make the call to the cart
      r.open("GET", "/cart/shipping_rates.json" + "?shipping_address[zip]=" + this.shipping.zip + "&shipping_address[country]=" + this.shipping.country + "&shipping_address[province]=" + this.shipping.province, +"&" + this.cacheBuster(true), true);

      // Updates the cart
      r.onreadystatechange = function () {

        // jump out if not ready
        if (r.readyState != 4) return;

        // decrement the shipping updating
        --self.cart_updating_shipping;

        // if success
        if (r.status == 200) {
          self.storeShippingRates(r.responseText);
        } else {
          self.storeShippingError(r.responseText);
        }
      };

      // send the request
      r.send();
    },


    /**
     * Set the shipping data
     * @param {Object} data The shipping data json
     */
    storeShippingRates: function storeShippingRates(data) {

      // Unset shipping errors
      this.shipping.error = '';

      // Set the shipping rates
      this.shipping.rates = JSON.parse(data).shipping_rates;

      // Store the current address information
      localStorage.setItem('rates_address_info', JSON.stringify({
        zip: this.shipping.zip,
        province: this.shipping.province,
        country: this.shipping.country
      }));
    },


    /**
     * Handles shipping rates error return
     * @param  {String} data Json string
     * @return {Null}
     */
    storeShippingError: function storeShippingError(data) {

      console.log(JSON.parse(data));

      // Set the shipping error
      // this.shipping.error =
      //   JSON.parse(data).error
      //     .replace(/{"|"}|[^"]+"=>"/g,'');

      // Set the error
      this.shipping.error = 'Oops, something went wrong when retreiving your shipping rates. Please make sure your postal/zip code is correct.';

      // reset the shipping rates
      this.resetShippingRates();
    }
  },

  /**
   * Computed Shipping props
   * @type {Object}
   */
  computed: {

    /**
     * Determins the shipping total
     * @return {Integer} The total of the shipping
     */
    shipping_total: function shipping_total() {
      return !this.shipping_cheapest ? 0 : this.shipping_cheapest.price * 100;
    },

    /**
     * Gets the cheapest shipping option
     * @return {Object} The cheapest shipping option
     */
    shipping_cheapest: function shipping_cheapest() {
      return !this.shipping.rates.length ? null : this.shipping.rates.sort(function (a, b) {
        return a.price - b.price;
      })[0];
    }

  }

};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.11
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):t.Vue=e()}(this,function(){"use strict";function t(t){return void 0===t||null===t}function e(t){return void 0!==t&&null!==t}function n(t){return!0===t}function r(t){return"string"==typeof t||"number"==typeof t||"boolean"==typeof t}function i(t){return null!==t&&"object"==typeof t}function o(t){return"[object Object]"===Nn.call(t)}function a(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function s(t){return null==t?"":"object"==typeof t?JSON.stringify(t,null,2):String(t)}function c(t){var e=parseFloat(t);return isNaN(e)?t:e}function u(t,e){for(var n=Object.create(null),r=t.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}function l(t,e){if(t.length){var n=t.indexOf(e);if(n>-1)return t.splice(n,1)}}function f(t,e){return Mn.call(t,e)}function d(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}function p(t,e){function n(n){var r=arguments.length;return r?r>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n}function v(t,e){e=e||0;for(var n=t.length-e,r=new Array(n);n--;)r[n]=t[n+e];return r}function h(t,e){for(var n in e)t[n]=e[n];return t}function m(t){for(var e={},n=0;n<t.length;n++)t[n]&&h(e,t[n]);return e}function y(t,e,n){}function g(t,e){if(t===e)return!0;var n=i(t),r=i(e);if(!n||!r)return!n&&!r&&String(t)===String(e);try{var o=Array.isArray(t),a=Array.isArray(e);if(o&&a)return t.length===e.length&&t.every(function(t,n){return g(t,e[n])});if(o||a)return!1;var s=Object.keys(t),c=Object.keys(e);return s.length===c.length&&s.every(function(n){return g(t[n],e[n])})}catch(t){return!1}}function _(t,e){for(var n=0;n<t.length;n++)if(g(t[n],e))return n;return-1}function b(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}function $(t){var e=(t+"").charCodeAt(0);return 36===e||95===e}function C(t,e,n,r){Object.defineProperty(t,e,{value:n,enumerable:!!r,writable:!0,configurable:!0})}function w(t){return"function"==typeof t&&/native code/.test(t.toString())}function x(t){return new mr(void 0,void 0,void 0,String(t))}function k(t,e){var n=t.componentOptions,r=new mr(t.tag,t.data,t.children,t.text,t.elm,t.context,n,t.asyncFactory);return r.ns=t.ns,r.isStatic=t.isStatic,r.key=t.key,r.isComment=t.isComment,r.fnContext=t.fnContext,r.fnOptions=t.fnOptions,r.fnScopeId=t.fnScopeId,r.isCloned=!0,e&&(t.children&&(r.children=A(t.children,!0)),n&&n.children&&(n.children=A(n.children,!0))),r}function A(t,e){for(var n=t.length,r=new Array(n),i=0;i<n;i++)r[i]=k(t[i],e);return r}function O(t,e,n){t.__proto__=e}function S(t,e,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];C(t,o,e[o])}}function T(t,e){if(i(t)&&!(t instanceof mr)){var n;return f(t,"__ob__")&&t.__ob__ instanceof wr?n=t.__ob__:Cr.shouldConvert&&!ur()&&(Array.isArray(t)||o(t))&&Object.isExtensible(t)&&!t._isVue&&(n=new wr(t)),e&&n&&n.vmCount++,n}}function E(t,e,n,r,i){var o=new vr,a=Object.getOwnPropertyDescriptor(t,e);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set,u=!i&&T(n);Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(t):n;return vr.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(e)&&I(e))),e},set:function(e){var r=s?s.call(t):n;e===r||e!=e&&r!=r||(c?c.call(t,e):n=e,u=!i&&T(e),o.notify())}})}}function j(t,e,n){if(Array.isArray(t)&&a(e))return t.length=Math.max(t.length,e),t.splice(e,1,n),n;if(e in t&&!(e in Object.prototype))return t[e]=n,n;var r=t.__ob__;return t._isVue||r&&r.vmCount?n:r?(E(r.value,e,n),r.dep.notify(),n):(t[e]=n,n)}function N(t,e){if(Array.isArray(t)&&a(e))t.splice(e,1);else{var n=t.__ob__;t._isVue||n&&n.vmCount||f(t,e)&&(delete t[e],n&&n.dep.notify())}}function I(t){for(var e=void 0,n=0,r=t.length;n<r;n++)(e=t[n])&&e.__ob__&&e.__ob__.dep.depend(),Array.isArray(e)&&I(e)}function L(t,e){if(!e)return t;for(var n,r,i,a=Object.keys(e),s=0;s<a.length;s++)r=t[n=a[s]],i=e[n],f(t,n)?o(r)&&o(i)&&L(r,i):j(t,n,i);return t}function M(t,e,n){return n?function(){var r="function"==typeof e?e.call(n,n):e,i="function"==typeof t?t.call(n,n):t;return r?L(r,i):i}:e?t?function(){return L("function"==typeof e?e.call(this,this):e,"function"==typeof t?t.call(this,this):t)}:e:t}function D(t,e){return e?t?t.concat(e):Array.isArray(e)?e:[e]:t}function P(t,e,n,r){var i=Object.create(t||null);return e?h(i,e):i}function F(t,e,n){function r(r){var i=xr[r]||Or;u[r]=i(t[r],e[r],n,r)}"function"==typeof e&&(e=e.options),function(t,e){var n=t.props;if(n){var r,i,a={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(a[Pn(i)]={type:null});else if(o(n))for(var s in n)i=n[s],a[Pn(s)]=o(i)?i:{type:i};t.props=a}}(e),function(t,e){var n=t.inject,r=t.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(o(n))for(var a in n){var s=n[a];r[a]=o(s)?h({from:a},s):{from:s}}}(e),function(t){var e=t.directives;if(e)for(var n in e){var r=e[n];"function"==typeof r&&(e[n]={bind:r,update:r})}}(e);var i=e.extends;if(i&&(t=F(t,i,n)),e.mixins)for(var a=0,s=e.mixins.length;a<s;a++)t=F(t,e.mixins[a],n);var c,u={};for(c in t)r(c);for(c in e)f(t,c)||r(c);return u}function R(t,e,n,r){if("string"==typeof n){var i=t[e];if(f(i,n))return i[n];var o=Pn(n);if(f(i,o))return i[o];var a=Fn(o);if(f(i,a))return i[a];return i[n]||i[o]||i[a]}}function H(t,e,n,r){var i=e[t],o=!f(n,t),a=n[t];if(U(Boolean,i.type)&&(o&&!f(i,"default")?a=!1:U(String,i.type)||""!==a&&a!==Hn(t)||(a=!0)),void 0===a){a=function(t,e,n){if(!f(e,"default"))return;var r=e.default;if(t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n])return t._props[n];return"function"==typeof r&&"Function"!==B(e.type)?r.call(t):r}(r,i,t);var s=Cr.shouldConvert;Cr.shouldConvert=!0,T(a),Cr.shouldConvert=s}return a}function B(t){var e=t&&t.toString().match(/^\s*function (\w+)/);return e?e[1]:""}function U(t,e){if(!Array.isArray(e))return B(e)===B(t);for(var n=0,r=e.length;n<r;n++)if(B(e[n])===B(t))return!0;return!1}function V(t,e,n){if(e)for(var r=e;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,t,e,n))return}catch(t){z(t,r,"errorCaptured hook")}}z(t,e,n)}function z(t,e,n){if(Jn.errorHandler)try{return Jn.errorHandler.call(null,t,e,n)}catch(t){K(t,null,"config.errorHandler")}K(t,e,n)}function K(t,e,n){if(!Gn&&!Zn||"undefined"==typeof console)throw t;console.error(t)}function J(){Tr=!1;var t=Sr.slice(0);Sr.length=0;for(var e=0;e<t.length;e++)t[e]()}function q(t,e){var n;if(Sr.push(function(){if(t)try{t.call(e)}catch(t){V(t,e,"nextTick")}else n&&n(e)}),Tr||(Tr=!0,Er?Ar():kr()),!t&&"undefined"!=typeof Promise)return new Promise(function(t){n=t})}function W(t){G(t,Mr),Mr.clear()}function G(t,e){var n,r,o=Array.isArray(t);if((o||i(t))&&!Object.isFrozen(t)){if(t.__ob__){var a=t.__ob__.dep.id;if(e.has(a))return;e.add(a)}if(o)for(n=t.length;n--;)G(t[n],e);else for(n=(r=Object.keys(t)).length;n--;)G(t[r[n]],e)}}function Z(t){function e(){var t=arguments,n=e.fns;if(!Array.isArray(n))return n.apply(null,arguments);for(var r=n.slice(),i=0;i<r.length;i++)r[i].apply(null,t)}return e.fns=t,e}function X(e,n,r,i,o){var a,s,c,u;for(a in e)s=e[a],c=n[a],u=Dr(a),t(s)||(t(c)?(t(s.fns)&&(s=e[a]=Z(s)),r(u.name,s,u.once,u.capture,u.passive)):s!==c&&(c.fns=s,e[a]=c));for(a in n)t(e[a])&&i((u=Dr(a)).name,n[a],u.capture)}function Y(r,i,o){function a(){o.apply(this,arguments),l(s.fns,a)}r instanceof mr&&(r=r.data.hook||(r.data.hook={}));var s,c=r[i];t(c)?s=Z([a]):e(c.fns)&&n(c.merged)?(s=c).fns.push(a):s=Z([c,a]),s.merged=!0,r[i]=s}function Q(t,n,r,i,o){if(e(n)){if(f(n,r))return t[r]=n[r],o||delete n[r],!0;if(f(n,i))return t[r]=n[i],o||delete n[i],!0}return!1}function tt(t){return e(t)&&e(t.text)&&function(t){return!1===t}(t.isComment)}function et(i,o){var a,s,c,u,l=[];for(a=0;a<i.length;a++)t(s=i[a])||"boolean"==typeof s||(u=l[c=l.length-1],Array.isArray(s)?s.length>0&&(tt((s=et(s,(o||"")+"_"+a))[0])&&tt(u)&&(l[c]=x(u.text+s[0].text),s.shift()),l.push.apply(l,s)):r(s)?tt(u)?l[c]=x(u.text+s):""!==s&&l.push(x(s)):tt(s)&&tt(u)?l[c]=x(u.text+s.text):(n(i._isVList)&&e(s.tag)&&t(s.key)&&e(o)&&(s.key="__vlist"+o+"_"+a+"__"),l.push(s)));return l}function nt(t,e){return(t.__esModule||fr&&"Module"===t[Symbol.toStringTag])&&(t=t.default),i(t)?e.extend(t):t}function rt(t){return t.isComment&&t.asyncFactory}function it(t){if(Array.isArray(t))for(var n=0;n<t.length;n++){var r=t[n];if(e(r)&&(e(r.componentOptions)||rt(r)))return r}}function ot(t,e,n){n?Lr.$once(t,e):Lr.$on(t,e)}function at(t,e){Lr.$off(t,e)}function st(t,e,n){Lr=t,X(e,n||{},ot,at),Lr=void 0}function ct(t,e){var n={};if(!t)return n;for(var r=0,i=t.length;r<i;r++){var o=t[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==e&&o.fnContext!==e||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(ut)&&delete n[u];return n}function ut(t){return t.isComment&&!t.asyncFactory||" "===t.text}function lt(t,e){e=e||{};for(var n=0;n<t.length;n++)Array.isArray(t[n])?lt(t[n],e):e[t[n].key]=t[n].fn;return e}function ft(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function dt(t,e){if(e){if(t._directInactive=!1,ft(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)dt(t.$children[n]);vt(t,"activated")}}function pt(t,e){if(!(e&&(t._directInactive=!0,ft(t))||t._inactive)){t._inactive=!0;for(var n=0;n<t.$children.length;n++)pt(t.$children[n]);vt(t,"deactivated")}}function vt(t,e){var n=t.$options[e];if(n)for(var r=0,i=n.length;r<i;r++)try{n[r].call(t)}catch(n){V(n,t,e+" hook")}t._hasHookEvent&&t.$emit("hook:"+e)}function ht(){Ur=!0;var t,e;for(Fr.sort(function(t,e){return t.id-e.id}),Vr=0;Vr<Fr.length;Vr++)e=(t=Fr[Vr]).id,Hr[e]=null,t.run();var n=Rr.slice(),r=Fr.slice();Vr=Fr.length=Rr.length=0,Hr={},Br=Ur=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,dt(t[e],!0)}(n),function(t){var e=t.length;for(;e--;){var n=t[e],r=n.vm;r._watcher===n&&r._isMounted&&vt(r,"updated")}}(r),lr&&Jn.devtools&&lr.emit("flush")}function mt(t,e,n){Jr.get=function(){return this[e][n]},Jr.set=function(t){this[e][n]=t},Object.defineProperty(t,n,Jr)}function yt(t){t._watchers=[];var e=t.$options;e.props&&function(t,e){var n=t.$options.propsData||{},r=t._props={},i=t.$options._propKeys=[],o=!t.$parent;Cr.shouldConvert=o;var a=function(o){i.push(o);var a=H(o,e,n,t);E(r,o,a),o in t||mt(t,"_props",o)};for(var s in e)a(s);Cr.shouldConvert=!0}(t,e.props),e.methods&&function(t,e){t.$options.props;for(var n in e)t[n]=null==e[n]?y:p(e[n],t)}(t,e.methods),e.data?function(t){var e=t.$options.data;e=t._data="function"==typeof e?function(t,e){try{return t.call(e,e)}catch(t){return V(t,e,"data()"),{}}}(e,t):e||{},o(e)||(e={});var n=Object.keys(e),r=t.$options.props,i=(t.$options.methods,n.length);for(;i--;){var a=n[i];r&&f(r,a)||$(a)||mt(t,"_data",a)}T(e,!0)}(t):T(t._data={},!0),e.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),r=ur();for(var i in e){var o=e[i],a="function"==typeof o?o:o.get;r||(n[i]=new Kr(t,a||y,y,qr)),i in t||gt(t,i,o)}}(t,e.computed),e.watch&&e.watch!==ir&&function(t,e){for(var n in e){var r=e[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)bt(t,n,r[i]);else bt(t,n,r)}}(t,e.watch)}function gt(t,e,n){var r=!ur();"function"==typeof n?(Jr.get=r?_t(e):n,Jr.set=y):(Jr.get=n.get?r&&!1!==n.cache?_t(e):n.get:y,Jr.set=n.set?n.set:y),Object.defineProperty(t,e,Jr)}function _t(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),vr.target&&e.depend(),e.value}}function bt(t,e,n,r){return o(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,r)}function $t(t,e){if(t){for(var n=Object.create(null),r=fr?Reflect.ownKeys(t).filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}):Object.keys(t),i=0;i<r.length;i++){for(var o=r[i],a=t[o].from,s=e;s;){if(s._provided&&a in s._provided){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in t[o]){var c=t[o].default;n[o]="function"==typeof c?c.call(e):c}}return n}}function Ct(t,n){var r,o,a,s,c;if(Array.isArray(t)||"string"==typeof t)for(r=new Array(t.length),o=0,a=t.length;o<a;o++)r[o]=n(t[o],o);else if("number"==typeof t)for(r=new Array(t),o=0;o<t;o++)r[o]=n(o+1,o);else if(i(t))for(s=Object.keys(t),r=new Array(s.length),o=0,a=s.length;o<a;o++)c=s[o],r[o]=n(t[c],c,o);return e(r)&&(r._isVList=!0),r}function wt(t,e,n,r){var i,o=this.$scopedSlots[t];if(o)n=n||{},r&&(n=h(h({},r),n)),i=o(n)||e;else{var a=this.$slots[t];a&&(a._rendered=!0),i=a||e}var s=n&&n.slot;return s?this.$createElement("template",{slot:s},i):i}function xt(t){return R(this.$options,"filters",t)||Un}function kt(t,e,n,r){var i=Jn.keyCodes[e]||n;return i?Array.isArray(i)?-1===i.indexOf(t):i!==t:r?Hn(r)!==e:void 0}function At(t,e,n,r,o){if(n)if(i(n)){Array.isArray(n)&&(n=m(n));var a,s=function(i){if("class"===i||"style"===i||Ln(i))a=t;else{var s=t.attrs&&t.attrs.type;a=r||Jn.mustUseProp(e,s,i)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}if(!(i in a)&&(a[i]=n[i],o)){(t.on||(t.on={}))["update:"+i]=function(t){n[i]=t}}};for(var c in n)s(c)}else;return t}function Ot(t,e){var n=this._staticTrees||(this._staticTrees=[]),r=n[t];return r&&!e?Array.isArray(r)?A(r):k(r):(r=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,null,this),Tt(r,"__static__"+t,!1),r)}function St(t,e,n){return Tt(t,"__once__"+e+(n?"_"+n:""),!0),t}function Tt(t,e,n){if(Array.isArray(t))for(var r=0;r<t.length;r++)t[r]&&"string"!=typeof t[r]&&Et(t[r],e+"_"+r,n);else Et(t,e,n)}function Et(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function jt(t,e){if(e)if(o(e)){var n=t.on=t.on?h({},t.on):{};for(var r in e){var i=n[r],a=e[r];n[r]=i?[].concat(i,a):a}}else;return t}function Nt(t){t._o=St,t._n=c,t._s=s,t._l=Ct,t._t=wt,t._q=g,t._i=_,t._m=Ot,t._f=xt,t._k=kt,t._b=At,t._v=x,t._e=gr,t._u=lt,t._g=jt}function It(t,e,r,i,o){var a=o.options;this.data=t,this.props=e,this.children=r,this.parent=i,this.listeners=t.on||jn,this.injections=$t(a.inject,i),this.slots=function(){return ct(r,i)};var s=Object.create(i),c=n(a._compiled),u=!c;c&&(this.$options=a,this.$slots=this.slots(),this.$scopedSlots=t.scopedSlots||jn),a._scopeId?this._c=function(t,e,n,r){var o=Dt(s,t,e,n,r,u);return o&&(o.fnScopeId=a._scopeId,o.fnContext=i),o}:this._c=function(t,e,n,r){return Dt(s,t,e,n,r,u)}}function Lt(t,e){for(var n in e)t[Pn(n)]=e[n]}function Mt(r,o,a,s,c){if(!t(r)){var u=a.$options._base;if(i(r)&&(r=u.extend(r)),"function"==typeof r){var l;if(t(r.cid)&&(l=r,void 0===(r=function(r,o,a){if(n(r.error)&&e(r.errorComp))return r.errorComp;if(e(r.resolved))return r.resolved;if(n(r.loading)&&e(r.loadingComp))return r.loadingComp;if(!e(r.contexts)){var s=r.contexts=[a],c=!0,u=function(){for(var t=0,e=s.length;t<e;t++)s[t].$forceUpdate()},l=b(function(t){r.resolved=nt(t,o),c||u()}),f=b(function(t){e(r.errorComp)&&(r.error=!0,u())}),d=r(l,f);return i(d)&&("function"==typeof d.then?t(r.resolved)&&d.then(l,f):e(d.component)&&"function"==typeof d.component.then&&(d.component.then(l,f),e(d.error)&&(r.errorComp=nt(d.error,o)),e(d.loading)&&(r.loadingComp=nt(d.loading,o),0===d.delay?r.loading=!0:setTimeout(function(){t(r.resolved)&&t(r.error)&&(r.loading=!0,u())},d.delay||200)),e(d.timeout)&&setTimeout(function(){t(r.resolved)&&f(null)},d.timeout))),c=!1,r.loading?r.loadingComp:r.resolved}r.contexts.push(a)}(l,u,a))))return function(t,e,n,r,i){var o=gr();return o.asyncFactory=t,o.asyncMeta={data:e,context:n,children:r,tag:i},o}(l,o,a,s,c);o=o||{},Ft(r),e(o.model)&&function(t,n){var r=t.model&&t.model.prop||"value",i=t.model&&t.model.event||"input";(n.props||(n.props={}))[r]=n.model.value;var o=n.on||(n.on={});e(o[i])?o[i]=[n.model.callback].concat(o[i]):o[i]=n.model.callback}(r.options,o);var f=function(n,r,i){var o=r.options.props;if(!t(o)){var a={},s=n.attrs,c=n.props;if(e(s)||e(c))for(var u in o){var l=Hn(u);Q(a,c,u,l,!0)||Q(a,s,u,l,!1)}return a}}(o,r);if(n(r.options.functional))return function(t,n,r,i,o){var a=t.options,s={},c=a.props;if(e(c))for(var u in c)s[u]=H(u,c,n||jn);else e(r.attrs)&&Lt(s,r.attrs),e(r.props)&&Lt(s,r.props);var l=new It(r,s,o,i,t),f=a.render.call(null,l._c,l);return f instanceof mr&&(f.fnContext=i,f.fnOptions=a,r.slot&&((f.data||(f.data={})).slot=r.slot)),f}(r,f,o,a,s);var d=o.on;if(o.on=o.nativeOn,n(r.options.abstract)){var p=o.slot;o={},p&&(o.slot=p)}!function(t){t.hook||(t.hook={});for(var e=0;e<Gr.length;e++){var n=Gr[e],r=t.hook[n],i=Wr[n];t.hook[n]=r?function(t,e){return function(n,r,i,o){t(n,r,i,o),e(n,r,i,o)}}(i,r):i}}(o);var v=r.options.name||c;return new mr("vue-component-"+r.cid+(v?"-"+v:""),o,void 0,void 0,void 0,a,{Ctor:r,propsData:f,listeners:d,tag:c,children:s},l)}}}function Dt(t,i,o,a,s,c){return(Array.isArray(o)||r(o))&&(s=a,a=o,o=void 0),n(c)&&(s=Xr),function(t,n,i,o,a){if(e(i)&&e(i.__ob__))return gr();e(i)&&e(i.is)&&(n=i.is);if(!n)return gr();Array.isArray(o)&&"function"==typeof o[0]&&((i=i||{}).scopedSlots={default:o[0]},o.length=0);a===Xr?o=function(t){return r(t)?[x(t)]:Array.isArray(t)?et(t):void 0}(o):a===Zr&&(o=function(t){for(var e=0;e<t.length;e++)if(Array.isArray(t[e]))return Array.prototype.concat.apply([],t);return t}(o));var s,c;if("string"==typeof n){var u;c=t.$vnode&&t.$vnode.ns||Jn.getTagNamespace(n),s=Jn.isReservedTag(n)?new mr(Jn.parsePlatformTagName(n),i,o,void 0,void 0,t):e(u=R(t.$options,"components",n))?Mt(u,i,t,o,n):new mr(n,i,o,void 0,void 0,t)}else s=Mt(n,i,t,o);return e(s)?(c&&Pt(s,c),s):gr()}(t,i,o,a,s)}function Pt(r,i,o){if(r.ns=i,"foreignObject"===r.tag&&(i=void 0,o=!0),e(r.children))for(var a=0,s=r.children.length;a<s;a++){var c=r.children[a];e(c.tag)&&(t(c.ns)||n(o))&&Pt(c,i,o)}}function Ft(t){var e=t.options;if(t.super){var n=Ft(t.super);if(n!==t.superOptions){t.superOptions=n;var r=function(t){var e,n=t.options,r=t.extendOptions,i=t.sealedOptions;for(var o in n)n[o]!==i[o]&&(e||(e={}),e[o]=function(t,e,n){{if(Array.isArray(t)){var r=[];n=Array.isArray(n)?n:[n],e=Array.isArray(e)?e:[e];for(var i=0;i<t.length;i++)(e.indexOf(t[i])>=0||n.indexOf(t[i])<0)&&r.push(t[i]);return r}return t}}(n[o],r[o],i[o]));return e}(t);r&&h(t.extendOptions,r),(e=t.options=F(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function Rt(t){this._init(t)}function Ht(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,r=n.cid,i=t._Ctor||(t._Ctor={});if(i[r])return i[r];var o=t.name||n.options.name,a=function(t){this._init(t)};return a.prototype=Object.create(n.prototype),a.prototype.constructor=a,a.cid=e++,a.options=F(n.options,t),a.super=n,a.options.props&&function(t){var e=t.options.props;for(var n in e)mt(t.prototype,"_props",n)}(a),a.options.computed&&function(t){var e=t.options.computed;for(var n in e)gt(t.prototype,n,e[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,zn.forEach(function(t){a[t]=n[t]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=t,a.sealedOptions=h({},a.options),i[r]=a,a}}function Bt(t){return t&&(t.Ctor.options.name||t.tag)}function Ut(t,e){return Array.isArray(t)?t.indexOf(e)>-1:"string"==typeof t?t.split(",").indexOf(e)>-1:!!function(t){return"[object RegExp]"===Nn.call(t)}(t)&&t.test(e)}function Vt(t,e){var n=t.cache,r=t.keys,i=t._vnode;for(var o in n){var a=n[o];if(a){var s=Bt(a.componentOptions);s&&!e(s)&&zt(n,o,r,i)}}}function zt(t,e,n,r){var i=t[e];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),t[e]=null,l(n,e)}function Kt(t){for(var n=t.data,r=t,i=t;e(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(n=Jt(i.data,n));for(;e(r=r.parent);)r&&r.data&&(n=Jt(n,r.data));return function(t,n){if(e(t)||e(n))return qt(t,Wt(n));return""}(n.staticClass,n.class)}function Jt(t,n){return{staticClass:qt(t.staticClass,n.staticClass),class:e(t.class)?[t.class,n.class]:n.class}}function qt(t,e){return t?e?t+" "+e:t:e||""}function Wt(t){return Array.isArray(t)?function(t){for(var n,r="",i=0,o=t.length;i<o;i++)e(n=Wt(t[i]))&&""!==n&&(r&&(r+=" "),r+=n);return r}(t):i(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}function Gt(t){return bi(t)?"svg":"math"===t?"math":void 0}function Zt(t){if("string"==typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}function Xt(t,e){var n=t.data.ref;if(n){var r=t.context,i=t.componentInstance||t.elm,o=r.$refs;e?Array.isArray(o[n])?l(o[n],i):o[n]===i&&(o[n]=void 0):t.data.refInFor?Array.isArray(o[n])?o[n].indexOf(i)<0&&o[n].push(i):o[n]=[i]:o[n]=i}}function Yt(r,i){return r.key===i.key&&(r.tag===i.tag&&r.isComment===i.isComment&&e(r.data)===e(i.data)&&function(t,n){if("input"!==t.tag)return!0;var r,i=e(r=t.data)&&e(r=r.attrs)&&r.type,o=e(r=n.data)&&e(r=r.attrs)&&r.type;return i===o||wi(i)&&wi(o)}(r,i)||n(r.isAsyncPlaceholder)&&r.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function Qt(t,n,r){var i,o,a={};for(i=n;i<=r;++i)e(o=t[i].key)&&(a[o]=i);return a}function te(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,r,i,o=t===Ai,a=e===Ai,s=ee(t.data.directives,t.context),c=ee(e.data.directives,e.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,ne(i,"update",e,t),i.def&&i.def.componentUpdated&&l.push(i)):(ne(i,"bind",e,t),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)ne(u[n],"inserted",e,t)};o?Y(e,"insert",f):f()}l.length&&Y(e,"postpatch",function(){for(var n=0;n<l.length;n++)ne(l[n],"componentUpdated",e,t)});if(!o)for(n in s)c[n]||ne(s[n],"unbind",t,t,a)}(t,e)}function ee(t,e){var n=Object.create(null);if(!t)return n;var r,i;for(r=0;r<t.length;r++)(i=t[r]).modifiers||(i.modifiers=Ti),n[function(t){return t.rawName||t.name+"."+Object.keys(t.modifiers||{}).join(".")}(i)]=i,i.def=R(e.$options,"directives",i.name);return n}function ne(t,e,n,r,i){var o=t.def&&t.def[e];if(o)try{o(n.elm,t,n,r,i)}catch(r){V(r,n.context,"directive "+t.name+" "+e+" hook")}}function re(n,r){var i=r.componentOptions;if(!(e(i)&&!1===i.Ctor.options.inheritAttrs||t(n.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=n.data.attrs||{},u=r.data.attrs||{};e(u.__ob__)&&(u=r.data.attrs=h({},u));for(o in u)a=u[o],c[o]!==a&&ie(s,o,a);(Qn||er)&&u.value!==c.value&&ie(s,"value",u.value);for(o in c)t(u[o])&&(hi(o)?s.removeAttributeNS(vi,mi(o)):di(o)||s.removeAttribute(o))}}function ie(t,e,n){if(pi(e))yi(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n));else if(di(e))t.setAttribute(e,yi(n)||"false"===n?"false":"true");else if(hi(e))yi(n)?t.removeAttributeNS(vi,mi(e)):t.setAttributeNS(vi,e,n);else if(yi(n))t.removeAttribute(e);else{if(Qn&&!tr&&"TEXTAREA"===t.tagName&&"placeholder"===e&&!t.__ieph){var r=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",r)};t.addEventListener("input",r),t.__ieph=!0}t.setAttribute(e,n)}}function oe(n,r){var i=r.elm,o=r.data,a=n.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Kt(r),c=i._transitionClasses;e(c)&&(s=qt(s,Wt(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}function ae(t){function e(){(a||(a=[])).push(t.slice(v,i).trim()),v=i+1}var n,r,i,o,a,s=!1,c=!1,u=!1,l=!1,f=0,d=0,p=0,v=0;for(i=0;i<t.length;i++)if(r=n,n=t.charCodeAt(i),s)39===n&&92!==r&&(s=!1);else if(c)34===n&&92!==r&&(c=!1);else if(u)96===n&&92!==r&&(u=!1);else if(l)47===n&&92!==r&&(l=!1);else if(124!==n||124===t.charCodeAt(i+1)||124===t.charCodeAt(i-1)||f||d||p){switch(n){case 34:c=!0;break;case 39:s=!0;break;case 96:u=!0;break;case 40:p++;break;case 41:p--;break;case 91:d++;break;case 93:d--;break;case 123:f++;break;case 125:f--}if(47===n){for(var h=i-1,m=void 0;h>=0&&" "===(m=t.charAt(h));h--);m&&Ii.test(m)||(l=!0)}}else void 0===o?(v=i+1,o=t.slice(0,i).trim()):e();if(void 0===o?o=t.slice(0,i).trim():0!==v&&e(),a)for(i=0;i<a.length;i++)o=function(t,e){var n=e.indexOf("(");{if(n<0)return'_f("'+e+'")('+t+")";var r=e.slice(0,n),i=e.slice(n+1);return'_f("'+r+'")('+t+","+i}}(o,a[i]);return o}function se(t){console.error("[Vue compiler]: "+t)}function ce(t,e){return t?t.map(function(t){return t[e]}).filter(function(t){return t}):[]}function ue(t,e,n){(t.props||(t.props=[])).push({name:e,value:n})}function le(t,e,n){(t.attrs||(t.attrs=[])).push({name:e,value:n})}function fe(t,e,n,r,i,o){(t.directives||(t.directives=[])).push({name:e,rawName:n,value:r,arg:i,modifiers:o})}function de(t,e,n,r,i,o){(r=r||jn).capture&&(delete r.capture,e="!"+e),r.once&&(delete r.once,e="~"+e),r.passive&&(delete r.passive,e="&"+e),"click"===e&&(r.right?(e="contextmenu",delete r.right):r.middle&&(e="mouseup"));var a;r.native?(delete r.native,a=t.nativeEvents||(t.nativeEvents={})):a=t.events||(t.events={});var s={value:n};r!==jn&&(s.modifiers=r);var c=a[e];Array.isArray(c)?i?c.unshift(s):c.push(s):a[e]=c?i?[s,c]:[c,s]:s}function pe(t,e,n){var r=ve(t,":"+e)||ve(t,"v-bind:"+e);if(null!=r)return ae(r);if(!1!==n){var i=ve(t,e);if(null!=i)return JSON.stringify(i)}}function ve(t,e,n){var r;if(null!=(r=t.attrsMap[e]))for(var i=t.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===e){i.splice(o,1);break}return n&&delete t.attrsMap[e],r}function he(t,e,n){var r=n||{},i="$$v";r.trim&&(i="(typeof $$v === 'string'? $$v.trim(): $$v)"),r.number&&(i="_n("+i+")");var o=me(e,i);t.model={value:"("+e+")",expression:'"'+e+'"',callback:"function ($$v) {"+o+"}"}}function me(t,e){var n=function(t){if(ei=t.length,t.indexOf("[")<0||t.lastIndexOf("]")<ei-1)return(ii=t.lastIndexOf("."))>-1?{exp:t.slice(0,ii),key:'"'+t.slice(ii+1)+'"'}:{exp:t,key:null};ni=t,ii=oi=ai=0;for(;!ge();)_e(ri=ye())?be(ri):91===ri&&function(t){var e=1;oi=ii;for(;!ge();)if(t=ye(),_e(t))be(t);else if(91===t&&e++,93===t&&e--,0===e){ai=ii;break}}(ri);return{exp:t.slice(0,oi),key:t.slice(oi+1,ai)}}(t);return null===n.key?t+"="+e:"$set("+n.exp+", "+n.key+", "+e+")"}function ye(){return ni.charCodeAt(++ii)}function ge(){return ii>=ei}function _e(t){return 34===t||39===t}function be(t){for(var e=t;!ge()&&(t=ye())!==e;);}function $e(t,e,n,r,i){e=function(t){return t._withTask||(t._withTask=function(){Er=!0;var e=t.apply(null,arguments);return Er=!1,e})}(e),n&&(e=function(t,e,n){var r=si;return function i(){null!==t.apply(null,arguments)&&Ce(e,i,n,r)}}(e,t,r)),si.addEventListener(t,e,or?{capture:r,passive:i}:r)}function Ce(t,e,n,r){(r||si).removeEventListener(t,e._withTask||e,n)}function we(n,r){if(!t(n.data.on)||!t(r.data.on)){var i=r.data.on||{},o=n.data.on||{};si=r.elm,function(t){if(e(t[Li])){var n=Qn?"change":"input";t[n]=[].concat(t[Li],t[n]||[]),delete t[Li]}e(t[Mi])&&(t.change=[].concat(t[Mi],t.change||[]),delete t[Mi])}(i),X(i,o,$e,Ce,r.context),si=void 0}}function xe(n,r){if(!t(n.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=n.data.domProps||{},u=r.data.domProps||{};e(u.__ob__)&&(u=r.data.domProps=h({},u));for(i in s)t(u[i])&&(a[i]="");for(i in u){if(o=u[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i){a._value=o;var l=t(o)?"":String(o);(function(t,n){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,n)||function(t,n){var r=t.value,i=t._vModifiers;if(e(i)){if(i.lazy)return!1;if(i.number)return c(r)!==c(n);if(i.trim)return r.trim()!==n.trim()}return r!==n}(t,n))})(a,l)&&(a.value=l)}else a[i]=o}}}function ke(t){var e=Ae(t.style);return t.staticStyle?h(t.staticStyle,e):e}function Ae(t){return Array.isArray(t)?m(t):"string"==typeof t?Fi(t):t}function Oe(n,r){var i=r.data,o=n.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,d=Ae(r.data.style)||{};r.data.normalizedStyle=e(d.__ob__)?h({},d):d;var p=function(t,e){var n,r={};if(e)for(var i=t;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=ke(i.data))&&h(r,n);(n=ke(t.data))&&h(r,n);for(var o=t;o=o.parent;)o.data&&(n=ke(o.data))&&h(r,n);return r}(r,!0);for(s in f)t(p[s])&&Bi(c,s,"");for(s in p)(a=p[s])!==f[s]&&Bi(c,s,null==a?"":a)}}function Se(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(/\s+/).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function Te(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(/\s+/).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",r=" "+e+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function Ee(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&h(e,Ki(t.name||"v")),h(e,t),e}return"string"==typeof t?Ki(t):void 0}}function je(t){Qi(function(){Qi(t)})}function Ne(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),Se(t,e))}function Ie(t,e){t._transitionClasses&&l(t._transitionClasses,e),Te(t,e)}function Le(t,e,n){var r=Me(t,e),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===qi?Zi:Yi,c=0,u=function(){t.removeEventListener(s,l),n()},l=function(e){e.target===t&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),t.addEventListener(s,l)}function Me(t,e){var n,r=window.getComputedStyle(t),i=r[Gi+"Delay"].split(", "),o=r[Gi+"Duration"].split(", "),a=De(i,o),s=r[Xi+"Delay"].split(", "),c=r[Xi+"Duration"].split(", "),u=De(s,c),l=0,f=0;e===qi?a>0&&(n=qi,l=a,f=o.length):e===Wi?u>0&&(n=Wi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?qi:Wi:null)?n===qi?o.length:c.length:0;return{type:n,timeout:l,propCount:f,hasTransform:n===qi&&to.test(r[Gi+"Property"])}}function De(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map(function(e,n){return Pe(e)+Pe(t[n])}))}function Pe(t){return 1e3*Number(t.slice(0,-1))}function Fe(n,r){var o=n.elm;e(o._leaveCb)&&(o._leaveCb.cancelled=!0,o._leaveCb());var a=Ee(n.data.transition);if(!t(a)&&!e(o._enterCb)&&1===o.nodeType){for(var s=a.css,u=a.type,l=a.enterClass,f=a.enterToClass,d=a.enterActiveClass,p=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,$=a.beforeAppear,C=a.appear,w=a.afterAppear,x=a.appearCancelled,k=a.duration,A=Pr,O=Pr.$vnode;O&&O.parent;)A=(O=O.parent).context;var S=!A._isMounted||!n.isRootInsert;if(!S||C||""===C){var T=S&&p?p:l,E=S&&h?h:d,j=S&&v?v:f,N=S?$||m:m,I=S&&"function"==typeof C?C:y,L=S?w||g:g,M=S?x||_:_,D=c(i(k)?k.enter:k),P=!1!==s&&!tr,F=Be(I),R=o._enterCb=b(function(){P&&(Ie(o,j),Ie(o,E)),R.cancelled?(P&&Ie(o,T),M&&M(o)):L&&L(o),o._enterCb=null});n.data.show||Y(n,"insert",function(){var t=o.parentNode,e=t&&t._pending&&t._pending[n.key];e&&e.tag===n.tag&&e.elm._leaveCb&&e.elm._leaveCb(),I&&I(o,R)}),N&&N(o),P&&(Ne(o,T),Ne(o,E),je(function(){Ne(o,j),Ie(o,T),R.cancelled||F||(He(D)?setTimeout(R,D):Le(o,u,R))})),n.data.show&&(r&&r(),I&&I(o,R)),P||F||R()}}}function Re(n,r){function o(){x.cancelled||(n.data.show||((a.parentNode._pending||(a.parentNode._pending={}))[n.key]=n),v&&v(a),$&&(Ne(a,f),Ne(a,p),je(function(){Ne(a,d),Ie(a,f),x.cancelled||C||(He(w)?setTimeout(x,w):Le(a,l,x))})),h&&h(a,x),$||C||x())}var a=n.elm;e(a._enterCb)&&(a._enterCb.cancelled=!0,a._enterCb());var s=Ee(n.data.transition);if(t(s)||1!==a.nodeType)return r();if(!e(a._leaveCb)){var u=s.css,l=s.type,f=s.leaveClass,d=s.leaveToClass,p=s.leaveActiveClass,v=s.beforeLeave,h=s.leave,m=s.afterLeave,y=s.leaveCancelled,g=s.delayLeave,_=s.duration,$=!1!==u&&!tr,C=Be(h),w=c(i(_)?_.leave:_),x=a._leaveCb=b(function(){a.parentNode&&a.parentNode._pending&&(a.parentNode._pending[n.key]=null),$&&(Ie(a,d),Ie(a,p)),x.cancelled?($&&Ie(a,f),y&&y(a)):(r(),m&&m(a)),a._leaveCb=null});g?g(o):o()}}function He(t){return"number"==typeof t&&!isNaN(t)}function Be(n){if(t(n))return!1;var r=n.fns;return e(r)?Be(Array.isArray(r)?r[0]:r):(n._length||n.length)>1}function Ue(t,e){!0!==e.data.show&&Fe(e)}function Ve(t,e,n){ze(t,e,n),(Qn||er)&&setTimeout(function(){ze(t,e,n)},0)}function ze(t,e,n){var r=e.value,i=t.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=t.options.length;s<c;s++)if(a=t.options[s],i)o=_(r,Je(a))>-1,a.selected!==o&&(a.selected=o);else if(g(Je(a),r))return void(t.selectedIndex!==s&&(t.selectedIndex=s));i||(t.selectedIndex=-1)}}function Ke(t,e){return e.every(function(e){return!g(e,t)})}function Je(t){return"_value"in t?t._value:t.value}function qe(t){t.target.composing=!0}function We(t){t.target.composing&&(t.target.composing=!1,Ge(t.target,"input"))}function Ge(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function Ze(t){return!t.componentInstance||t.data&&t.data.transition?t:Ze(t.componentInstance._vnode)}function Xe(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?Xe(it(e.children)):t}function Ye(t){var e={},n=t.$options;for(var r in n.propsData)e[r]=t[r];var i=n._parentListeners;for(var o in i)e[Pn(o)]=i[o];return e}function Qe(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}function tn(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function en(t){t.data.newPos=t.elm.getBoundingClientRect()}function nn(t){var e=t.data.pos,n=t.data.newPos,r=e.left-n.left,i=e.top-n.top;if(r||i){t.data.moved=!0;var o=t.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}function rn(t,e){var n=e?zo:Vo;return t.replace(n,function(t){return Uo[t]})}function on(t,e,n){return{type:1,tag:t,attrsList:e,attrsMap:function(t){for(var e={},n=0,r=t.length;n<r;n++)e[t[n].name]=t[n].value;return e}(e),parent:n,children:[]}}function an(t,e){function n(t){t.pre&&(s=!1),Lo(t.tag)&&(c=!1)}To=e.warn||se,Lo=e.isPreTag||Bn,Mo=e.mustUseProp||Bn,Do=e.getTagNamespace||Bn,jo=ce(e.modules,"transformNode"),No=ce(e.modules,"preTransformNode"),Io=ce(e.modules,"postTransformNode"),Eo=e.delimiters;var r,i,o=[],a=!1!==e.preserveWhitespace,s=!1,c=!1;return function(t,e){function n(e){l+=e,t=t.substring(e)}function r(t,n,r){var i,s;if(null==n&&(n=l),null==r&&(r=l),t&&(s=t.toLowerCase()),t)for(i=a.length-1;i>=0&&a[i].lowerCasedTag!==s;i--);else i=0;if(i>=0){for(var c=a.length-1;c>=i;c--)e.end&&e.end(a[c].tag,n,r);a.length=i,o=i&&a[i-1].tag}else"br"===s?e.start&&e.start(t,[],!0,n,r):"p"===s&&(e.start&&e.start(t,[],!1,n,r),e.end&&e.end(t,n,r))}for(var i,o,a=[],s=e.expectHTML,c=e.isUnaryTag||Bn,u=e.canBeLeftOpenTag||Bn,l=0;t;){if(i=t,o&&Ho(o)){var f=0,d=o.toLowerCase(),p=Bo[d]||(Bo[d]=new RegExp("([\\s\\S]*?)(</"+d+"[^>]*>)","i")),v=t.replace(p,function(t,n,r){return f=r.length,Ho(d)||"noscript"===d||(n=n.replace(/<!--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Jo(d,n)&&(n=n.slice(1)),e.chars&&e.chars(n),""});l+=t.length-v.length,t=v,r(d,l-f,l)}else{var h=t.indexOf("<");if(0===h){if(Ao.test(t)){var m=t.indexOf("--\x3e");if(m>=0){e.shouldKeepComment&&e.comment(t.substring(4,m)),n(m+3);continue}}if(Oo.test(t)){var y=t.indexOf("]>");if(y>=0){n(y+2);continue}}var g=t.match(ko);if(g){n(g[0].length);continue}var _=t.match(xo);if(_){var b=l;n(_[0].length),r(_[1],b,l);continue}var $=function(){var e=t.match(Co);if(e){var r={tagName:e[1],attrs:[],start:l};n(e[0].length);for(var i,o;!(i=t.match(wo))&&(o=t.match(_o));)n(o[0].length),r.attrs.push(o);if(i)return r.unarySlash=i[1],n(i[0].length),r.end=l,r}}();if($){!function(t){var n=t.tagName,i=t.unarySlash;s&&("p"===o&&go(n)&&r(o),u(n)&&o===n&&r(n));for(var l=c(n)||!!i,f=t.attrs.length,d=new Array(f),p=0;p<f;p++){var v=t.attrs[p];So&&-1===v[0].indexOf('""')&&(""===v[3]&&delete v[3],""===v[4]&&delete v[4],""===v[5]&&delete v[5]);var h=v[3]||v[4]||v[5]||"",m="a"===n&&"href"===v[1]?e.shouldDecodeNewlinesForHref:e.shouldDecodeNewlines;d[p]={name:v[1],value:rn(h,m)}}l||(a.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:d}),o=n),e.start&&e.start(n,d,l,t.start,t.end)}($),Jo(o,t)&&n(1);continue}}var C=void 0,w=void 0,x=void 0;if(h>=0){for(w=t.slice(h);!(xo.test(w)||Co.test(w)||Ao.test(w)||Oo.test(w)||(x=w.indexOf("<",1))<0);)h+=x,w=t.slice(h);C=t.substring(0,h),n(h)}h<0&&(C=t,t=""),e.chars&&C&&e.chars(C)}if(t===i){e.chars&&e.chars(t);break}}r()}(t,{warn:To,expectHTML:e.expectHTML,isUnaryTag:e.isUnaryTag,canBeLeftOpenTag:e.canBeLeftOpenTag,shouldDecodeNewlines:e.shouldDecodeNewlines,shouldDecodeNewlinesForHref:e.shouldDecodeNewlinesForHref,shouldKeepComment:e.comments,start:function(t,a,u){var l=i&&i.ns||Do(t);Qn&&"svg"===l&&(a=function(t){for(var e=[],n=0;n<t.length;n++){var r=t[n];na.test(r.name)||(r.name=r.name.replace(ra,""),e.push(r))}return e}(a));var f=on(t,a,i);l&&(f.ns=l),function(t){return"style"===t.tag||"script"===t.tag&&(!t.attrsMap.type||"text/javascript"===t.attrsMap.type)}(f)&&!ur()&&(f.forbidden=!0);for(var d=0;d<No.length;d++)f=No[d](f,e)||f;if(s||(!function(t){null!=ve(t,"v-pre")&&(t.pre=!0)}(f),f.pre&&(s=!0)),Lo(f.tag)&&(c=!0),s?function(t){var e=t.attrsList.length;if(e)for(var n=t.attrs=new Array(e),r=0;r<e;r++)n[r]={name:t.attrsList[r].name,value:JSON.stringify(t.attrsList[r].value)};else t.pre||(t.plain=!0)}(f):f.processed||(cn(f),function(t){var e=ve(t,"v-if");if(e)t.if=e,un(t,{exp:e,block:t});else{null!=ve(t,"v-else")&&(t.else=!0);var n=ve(t,"v-else-if");n&&(t.elseif=n)}}(f),function(t){null!=ve(t,"v-once")&&(t.once=!0)}(f),sn(f,e)),r?o.length||r.if&&(f.elseif||f.else)&&un(r,{exp:f.elseif,block:f}):r=f,i&&!f.forbidden)if(f.elseif||f.else)!function(t,e){var n=function(t){var e=t.length;for(;e--;){if(1===t[e].type)return t[e];t.pop()}}(e.children);n&&n.if&&un(n,{exp:t.elseif,block:t})}(f,i);else if(f.slotScope){i.plain=!1;var p=f.slotTarget||'"default"';(i.scopedSlots||(i.scopedSlots={}))[p]=f}else i.children.push(f),f.parent=i;u?n(f):(i=f,o.push(f));for(var v=0;v<Io.length;v++)Io[v](f,e)},end:function(){var t=o[o.length-1],e=t.children[t.children.length-1];e&&3===e.type&&" "===e.text&&!c&&t.children.pop(),o.length-=1,i=o[o.length-1],n(t)},chars:function(t){if(i&&(!Qn||"textarea"!==i.tag||i.attrsMap.placeholder!==t)){var e=i.children;if(t=c||t.trim()?function(t){return"script"===t.tag||"style"===t.tag}(i)?t:ea(t):a&&e.length?" ":""){var n;!s&&" "!==t&&(n=function(t,e){var n=e?fo(e):uo;if(n.test(t)){for(var r,i,o=[],a=n.lastIndex=0;r=n.exec(t);){(i=r.index)>a&&o.push(JSON.stringify(t.slice(a,i)));var s=ae(r[1].trim());o.push("_s("+s+")"),a=i+r[0].length}return a<t.length&&o.push(JSON.stringify(t.slice(a))),o.join("+")}}(t,Eo))?e.push({type:2,expression:n,text:t}):" "===t&&e.length&&" "===e[e.length-1].text||e.push({type:3,text:t})}}},comment:function(t){i.children.push({type:3,text:t,isComment:!0})}}),r}function sn(t,e){!function(t){var e=pe(t,"key");e&&(t.key=e)}(t),t.plain=!t.key&&!t.attrsList.length,function(t){var e=pe(t,"ref");e&&(t.ref=e,t.refInFor=function(t){var e=t;for(;e;){if(void 0!==e.for)return!0;e=e.parent}return!1}(t))}(t),function(t){if("slot"===t.tag)t.slotName=pe(t,"name");else{var e;"template"===t.tag?(e=ve(t,"scope"),t.slotScope=e||ve(t,"slot-scope")):(e=ve(t,"slot-scope"))&&(t.slotScope=e);var n=pe(t,"slot");n&&(t.slotTarget='""'===n?'"default"':n,"template"===t.tag||t.slotScope||le(t,"slot",n))}}(t),function(t){var e;(e=pe(t,"is"))&&(t.component=e);null!=ve(t,"inline-template")&&(t.inlineTemplate=!0)}(t);for(var n=0;n<jo.length;n++)t=jo[n](t,e)||t;!function(t){var e,n,r,i,o,a,s,c=t.attrsList;for(e=0,n=c.length;e<n;e++)if(r=i=c[e].name,o=c[e].value,Wo.test(r))if(t.hasBindings=!0,(a=function(t){var e=t.match(ta);if(e){var n={};return e.forEach(function(t){n[t.slice(1)]=!0}),n}}(r))&&(r=r.replace(ta,"")),Qo.test(r))r=r.replace(Qo,""),o=ae(o),s=!1,a&&(a.prop&&(s=!0,"innerHtml"===(r=Pn(r))&&(r="innerHTML")),a.camel&&(r=Pn(r)),a.sync&&de(t,"update:"+Pn(r),me(o,"$event"))),s||!t.component&&Mo(t.tag,t.attrsMap.type,r)?ue(t,r,o):le(t,r,o);else if(qo.test(r))r=r.replace(qo,""),de(t,r,o,a,!1);else{var u=(r=r.replace(Wo,"")).match(Yo),l=u&&u[1];l&&(r=r.slice(0,-(l.length+1))),fe(t,r,i,o,l,a)}else le(t,r,JSON.stringify(o)),!t.component&&"muted"===r&&Mo(t.tag,t.attrsMap.type,r)&&ue(t,r,"true")}(t)}function cn(t){var e;if(e=ve(t,"v-for")){var n=e.match(Go);if(!n)return;t.for=n[2].trim();var r=n[1].trim().replace(Xo,""),i=r.match(Zo);i?(t.alias=r.replace(Zo,""),t.iterator1=i[1].trim(),i[2]&&(t.iterator2=i[2].trim())):t.alias=r}}function un(t,e){t.ifConditions||(t.ifConditions=[]),t.ifConditions.push(e)}function ln(t){return on(t.tag,t.attrsList.slice(),t.parent)}function fn(t,e,n){t.attrsMap[e]=n,t.attrsList.push({name:e,value:n})}function dn(t){if(t.static=function(t){if(2===t.type)return!1;if(3===t.type)return!0;return!(!t.pre&&(t.hasBindings||t.if||t.for||In(t.tag)||!Fo(t.tag)||function(t){for(;t.parent;){if("template"!==(t=t.parent).tag)return!1;if(t.for)return!0}return!1}(t)||!Object.keys(t).every(Po)))}(t),1===t.type){if(!Fo(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var e=0,n=t.children.length;e<n;e++){var r=t.children[e];dn(r),r.static||(t.static=!1)}if(t.ifConditions)for(var i=1,o=t.ifConditions.length;i<o;i++){var a=t.ifConditions[i].block;dn(a),a.static||(t.static=!1)}}}function pn(t,e){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=e),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var n=0,r=t.children.length;n<r;n++)pn(t.children[n],e||!!t.for);if(t.ifConditions)for(var i=1,o=t.ifConditions.length;i<o;i++)pn(t.ifConditions[i].block,e)}}function vn(t,e,n){var r=e?"nativeOn:{":"on:{";for(var i in t)r+='"'+i+'":'+hn(i,t[i])+",";return r.slice(0,-1)+"}"}function hn(t,e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return hn(t,e)}).join(",")+"]";var n=ca.test(e.value),r=sa.test(e.value);if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(fa[s])o+=fa[s],ua[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=la(["ctrl","shift","alt","meta"].filter(function(t){return!c[t]}).map(function(t){return"$event."+t+"Key"}).join("||"))}else a.push(s);a.length&&(i+=function(t){return"if(!('button' in $event)&&"+t.map(mn).join("&&")+")return null;"}(a)),o&&(i+=o);return"function($event){"+i+(n?e.value+"($event)":r?"("+e.value+")($event)":e.value)+"}"}return n||r?e.value:"function($event){"+e.value+"}"}function mn(t){var e=parseInt(t,10);if(e)return"$event.keyCode!=="+e;var n=ua[t];return"_k($event.keyCode,"+JSON.stringify(t)+","+JSON.stringify(n)+",$event.key)"}function yn(t,e){var n=new pa(e);return{render:"with(this){return "+(t?gn(t,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function gn(t,e){if(t.staticRoot&&!t.staticProcessed)return _n(t,e);if(t.once&&!t.onceProcessed)return bn(t,e);if(t.for&&!t.forProcessed)return function(t,e,n,r){var i=t.for,o=t.alias,a=t.iterator1?","+t.iterator1:"",s=t.iterator2?","+t.iterator2:"";return t.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||gn)(t,e)+"})"}(t,e);if(t.if&&!t.ifProcessed)return $n(t,e);if("template"!==t.tag||t.slotTarget){if("slot"===t.tag)return function(t,e){var n=t.slotName||'"default"',r=kn(t,e),i="_t("+n+(r?","+r:""),o=t.attrs&&"{"+t.attrs.map(function(t){return Pn(t.name)+":"+t.value}).join(",")+"}",a=t.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(t,e);var n;if(t.component)n=function(t,e,n){var r=e.inlineTemplate?null:kn(e,n,!0);return"_c("+t+","+wn(e,n)+(r?","+r:"")+")"}(t.component,t,e);else{var r=t.plain?void 0:wn(t,e),i=t.inlineTemplate?null:kn(t,e,!0);n="_c('"+t.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<e.transforms.length;o++)n=e.transforms[o](t,n);return n}return kn(t,e)||"void 0"}function _n(t,e){return t.staticProcessed=!0,e.staticRenderFns.push("with(this){return "+gn(t,e)+"}"),"_m("+(e.staticRenderFns.length-1)+(t.staticInFor?",true":"")+")"}function bn(t,e){if(t.onceProcessed=!0,t.if&&!t.ifProcessed)return $n(t,e);if(t.staticInFor){for(var n="",r=t.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+gn(t,e)+","+e.onceId+++","+n+")":gn(t,e)}return _n(t,e)}function $n(t,e,n,r){return t.ifProcessed=!0,Cn(t.ifConditions.slice(),e,n,r)}function Cn(t,e,n,r){function i(t){return n?n(t,e):t.once?bn(t,e):gn(t,e)}if(!t.length)return r||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+i(o.block)+":"+Cn(t,e,n,r):""+i(o.block)}function wn(t,e){var n="{",r=function(t,e){var n=t.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=e.directives[o.name];u&&(a=!!u(t,o,e.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?',arg:"'+o.arg+'"':"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(t,e);r&&(n+=r+","),t.key&&(n+="key:"+t.key+","),t.ref&&(n+="ref:"+t.ref+","),t.refInFor&&(n+="refInFor:true,"),t.pre&&(n+="pre:true,"),t.component&&(n+='tag:"'+t.tag+'",');for(var i=0;i<e.dataGenFns.length;i++)n+=e.dataGenFns[i](t);if(t.attrs&&(n+="attrs:{"+On(t.attrs)+"},"),t.props&&(n+="domProps:{"+On(t.props)+"},"),t.events&&(n+=vn(t.events,!1,e.warn)+","),t.nativeEvents&&(n+=vn(t.nativeEvents,!0,e.warn)+","),t.slotTarget&&!t.slotScope&&(n+="slot:"+t.slotTarget+","),t.scopedSlots&&(n+=function(t,e){return"scopedSlots:_u(["+Object.keys(t).map(function(n){return xn(n,t[n],e)}).join(",")+"])"}(t.scopedSlots,e)+","),t.model&&(n+="model:{value:"+t.model.value+",callback:"+t.model.callback+",expression:"+t.model.expression+"},"),t.inlineTemplate){var o=function(t,e){var n=t.children[0];if(1===n.type){var r=yn(n,e.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(t){return"function(){"+t+"}"}).join(",")+"]}"}}(t,e);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",t.wrapData&&(n=t.wrapData(n)),t.wrapListeners&&(n=t.wrapListeners(n)),n}function xn(t,e,n){if(e.for&&!e.forProcessed)return function(t,e,n){var r=e.for,i=e.alias,o=e.iterator1?","+e.iterator1:"",a=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,"_l(("+r+"),function("+i+o+a+"){return "+xn(t,e,n)+"})"}(t,e,n);return"{key:"+t+",fn:"+("function("+String(e.slotScope)+"){return "+("template"===e.tag?e.if?e.if+"?"+(kn(e,n)||"undefined")+":undefined":kn(e,n)||"undefined":gn(e,n))+"}")+"}"}function kn(t,e,n,r,i){var o=t.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag)return(r||gn)(a,e);var s=n?function(t,e){for(var n=0,r=0;r<t.length;r++){var i=t[r];if(1===i.type){if(An(i)||i.ifConditions&&i.ifConditions.some(function(t){return An(t.block)})){n=2;break}(e(i)||i.ifConditions&&i.ifConditions.some(function(t){return e(t.block)}))&&(n=1)}}return n}(o,e.maybeComponent):0,c=i||function(t,e){if(1===t.type)return gn(t,e);return 3===t.type&&t.isComment?function(t){return"_e("+JSON.stringify(t.text)+")"}(t):function(t){return"_v("+(2===t.type?t.expression:Sn(JSON.stringify(t.text)))+")"}(t)};return"["+o.map(function(t){return c(t,e)}).join(",")+"]"+(s?","+s:"")}}function An(t){return void 0!==t.for||"template"===t.tag||"slot"===t.tag}function On(t){for(var e="",n=0;n<t.length;n++){var r=t[n];e+='"'+r.name+'":'+Sn(r.value)+","}return e.slice(0,-1)}function Sn(t){return t.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}function Tn(t,e){try{return new Function(t)}catch(n){return e.push({err:n,code:t}),y}}function En(t){return Ro=Ro||document.createElement("div"),Ro.innerHTML=t?'<a href="\n"/>':'<div a="\n"/>',Ro.innerHTML.indexOf("&#10;")>0}var jn=Object.freeze({}),Nn=Object.prototype.toString,In=u("slot,component",!0),Ln=u("key,ref,slot,slot-scope,is"),Mn=Object.prototype.hasOwnProperty,Dn=/-(\w)/g,Pn=d(function(t){return t.replace(Dn,function(t,e){return e?e.toUpperCase():""})}),Fn=d(function(t){return t.charAt(0).toUpperCase()+t.slice(1)}),Rn=/\B([A-Z])/g,Hn=d(function(t){return t.replace(Rn,"-$1").toLowerCase()}),Bn=function(t,e,n){return!1},Un=function(t){return t},Vn="data-server-rendered",zn=["component","directive","filter"],Kn=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured"],Jn={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:Bn,isReservedAttr:Bn,isUnknownElement:Bn,getTagNamespace:y,parsePlatformTagName:Un,mustUseProp:Bn,_lifecycleHooks:Kn},qn=/[^\w.$]/,Wn="__proto__"in{},Gn="undefined"!=typeof window,Zn="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,Xn=Zn&&WXEnvironment.platform.toLowerCase(),Yn=Gn&&window.navigator.userAgent.toLowerCase(),Qn=Yn&&/msie|trident/.test(Yn),tr=Yn&&Yn.indexOf("msie 9.0")>0,er=Yn&&Yn.indexOf("edge/")>0,nr=Yn&&Yn.indexOf("android")>0||"android"===Xn,rr=Yn&&/iphone|ipad|ipod|ios/.test(Yn)||"ios"===Xn,ir=(Yn&&/chrome\/\d+/.test(Yn),{}.watch),or=!1;if(Gn)try{var ar={};Object.defineProperty(ar,"passive",{get:function(){or=!0}}),window.addEventListener("test-passive",null,ar)}catch(t){}var sr,cr,ur=function(){return void 0===sr&&(sr=!Gn&&"undefined"!=typeof global&&"server"===global.process.env.VUE_ENV),sr},lr=Gn&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__,fr="undefined"!=typeof Symbol&&w(Symbol)&&"undefined"!=typeof Reflect&&w(Reflect.ownKeys);cr="undefined"!=typeof Set&&w(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var dr=y,pr=0,vr=function(){this.id=pr++,this.subs=[]};vr.prototype.addSub=function(t){this.subs.push(t)},vr.prototype.removeSub=function(t){l(this.subs,t)},vr.prototype.depend=function(){vr.target&&vr.target.addDep(this)},vr.prototype.notify=function(){for(var t=this.subs.slice(),e=0,n=t.length;e<n;e++)t[e].update()},vr.target=null;var hr=[],mr=function(t,e,n,r,i,o,a,s){this.tag=t,this.data=e,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},yr={child:{configurable:!0}};yr.child.get=function(){return this.componentInstance},Object.defineProperties(mr.prototype,yr);var gr=function(t){void 0===t&&(t="");var e=new mr;return e.text=t,e.isComment=!0,e},_r=Array.prototype,br=Object.create(_r);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(t){var e=_r[t];C(br,t,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=e.apply(this,n),a=this.__ob__;switch(t){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var $r=Object.getOwnPropertyNames(br),Cr={shouldConvert:!0},wr=function(t){if(this.value=t,this.dep=new vr,this.vmCount=0,C(t,"__ob__",this),Array.isArray(t)){(Wn?O:S)(t,br,$r),this.observeArray(t)}else this.walk(t)};wr.prototype.walk=function(t){for(var e=Object.keys(t),n=0;n<e.length;n++)E(t,e[n],t[e[n]])},wr.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)T(t[e])};var xr=Jn.optionMergeStrategies;xr.data=function(t,e,n){return n?M(t,e,n):e&&"function"!=typeof e?t:M(t,e)},Kn.forEach(function(t){xr[t]=D}),zn.forEach(function(t){xr[t+"s"]=P}),xr.watch=function(t,e,n,r){if(t===ir&&(t=void 0),e===ir&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var i={};h(i,t);for(var o in e){var a=i[o],s=e[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},xr.props=xr.methods=xr.inject=xr.computed=function(t,e,n,r){if(!t)return e;var i=Object.create(null);return h(i,t),e&&h(i,e),i},xr.provide=M;var kr,Ar,Or=function(t,e){return void 0===e?t:e},Sr=[],Tr=!1,Er=!1;if("undefined"!=typeof setImmediate&&w(setImmediate))Ar=function(){setImmediate(J)};else if("undefined"==typeof MessageChannel||!w(MessageChannel)&&"[object MessageChannelConstructor]"!==MessageChannel.toString())Ar=function(){setTimeout(J,0)};else{var jr=new MessageChannel,Nr=jr.port2;jr.port1.onmessage=J,Ar=function(){Nr.postMessage(1)}}if("undefined"!=typeof Promise&&w(Promise)){var Ir=Promise.resolve();kr=function(){Ir.then(J),rr&&setTimeout(y)}}else kr=Ar;var Lr,Mr=new cr,Dr=d(function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),r="!"===(t=n?t.slice(1):t).charAt(0);return t=r?t.slice(1):t,{name:t,once:n,capture:r,passive:e}}),Pr=null,Fr=[],Rr=[],Hr={},Br=!1,Ur=!1,Vr=0,zr=0,Kr=function(t,e,n,r,i){this.vm=t,i&&(t._watcher=this),t._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++zr,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new cr,this.newDepIds=new cr,this.expression="","function"==typeof e?this.getter=e:(this.getter=function(t){if(!qn.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=function(){})),this.value=this.lazy?void 0:this.get()};Kr.prototype.get=function(){!function(t){vr.target&&hr.push(vr.target),vr.target=t}(this);var t,e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;V(t,e,'getter for watcher "'+this.expression+'"')}finally{this.deep&&W(t),vr.target=hr.pop(),this.cleanupDeps()}return t},Kr.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},Kr.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},Kr.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(t){var e=t.id;if(null==Hr[e]){if(Hr[e]=!0,Ur){for(var n=Fr.length-1;n>Vr&&Fr[n].id>t.id;)n--;Fr.splice(n+1,0,t)}else Fr.push(t);Br||(Br=!0,q(ht))}}(this)},Kr.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||i(t)||this.deep){var e=this.value;if(this.value=t,this.user)try{this.cb.call(this.vm,t,e)}catch(t){V(t,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,t,e)}}},Kr.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},Kr.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},Kr.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||l(this.vm._watchers,this);for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1}};var Jr={enumerable:!0,configurable:!0,get:y,set:y},qr={lazy:!0};Nt(It.prototype);var Wr={init:function(t,n,r,i){if(!t.componentInstance||t.componentInstance._isDestroyed){(t.componentInstance=function(t,n,r,i){var o={_isComponent:!0,parent:n,_parentVnode:t,_parentElm:r||null,_refElm:i||null},a=t.data.inlineTemplate;return e(a)&&(o.render=a.render,o.staticRenderFns=a.staticRenderFns),new t.componentOptions.Ctor(o)}(t,Pr,r,i)).$mount(n?t.elm:void 0,n)}else if(t.data.keepAlive){var o=t;Wr.prepatch(o,o)}},prepatch:function(t,e){var n=e.componentOptions;!function(t,e,n,r,i){var o=!!(i||t.$options._renderChildren||r.data.scopedSlots||t.$scopedSlots!==jn);if(t.$options._parentVnode=r,t.$vnode=r,t._vnode&&(t._vnode.parent=r),t.$options._renderChildren=i,t.$attrs=r.data&&r.data.attrs||jn,t.$listeners=n||jn,e&&t.$options.props){Cr.shouldConvert=!1;for(var a=t._props,s=t.$options._propKeys||[],c=0;c<s.length;c++){var u=s[c];a[u]=H(u,t.$options.props,e,t)}Cr.shouldConvert=!0,t.$options.propsData=e}if(n){var l=t.$options._parentListeners;t.$options._parentListeners=n,st(t,n,l)}o&&(t.$slots=ct(i,r.context),t.$forceUpdate())}(e.componentInstance=t.componentInstance,n.propsData,n.listeners,e,n.children)},insert:function(t){var e=t.context,n=t.componentInstance;n._isMounted||(n._isMounted=!0,vt(n,"mounted")),t.data.keepAlive&&(e._isMounted?function(t){t._inactive=!1,Rr.push(t)}(n):dt(n,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?pt(e,!0):e.$destroy())}},Gr=Object.keys(Wr),Zr=1,Xr=2,Yr=0;!function(t){t.prototype._init=function(t){this._uid=Yr++,this._isVue=!0,t&&t._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),r=e._parentVnode;n.parent=e.parent,n._parentVnode=r,n._parentElm=e._parentElm,n._refElm=e._refElm;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(this,t):this.$options=F(Ft(this.constructor),t||{},this),this._renderProxy=this,this._self=this,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(this),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&st(t,e)}(this),function(t){t._vnode=null,t._staticTrees=null;var e=t.$options,n=t.$vnode=e._parentVnode,r=n&&n.context;t.$slots=ct(e._renderChildren,r),t.$scopedSlots=jn,t._c=function(e,n,r,i){return Dt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Dt(t,e,n,r,i,!0)};var i=n&&n.data;E(t,"$attrs",i&&i.attrs||jn,0,!0),E(t,"$listeners",e._parentListeners||jn,0,!0)}(this),vt(this,"beforeCreate"),function(t){var e=$t(t.$options.inject,t);e&&(Cr.shouldConvert=!1,Object.keys(e).forEach(function(n){E(t,n,e[n])}),Cr.shouldConvert=!0)}(this),yt(this),function(t){var e=t.$options.provide;e&&(t._provided="function"==typeof e?e.call(t):e)}(this),vt(this,"created"),this.$options.el&&this.$mount(this.$options.el)}}(Rt),function(t){var e={};e.get=function(){return this._data};var n={};n.get=function(){return this._props},Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",n),t.prototype.$set=j,t.prototype.$delete=N,t.prototype.$watch=function(t,e,n){if(o(e))return bt(this,t,e,n);(n=n||{}).user=!0;var r=new Kr(this,t,e,n);return n.immediate&&e.call(this,r.value),function(){r.teardown()}}}(Rt),function(t){var e=/^hook:/;t.prototype.$on=function(t,n){if(Array.isArray(t))for(var r=0,i=t.length;r<i;r++)this.$on(t[r],n);else(this._events[t]||(this._events[t]=[])).push(n),e.test(t)&&(this._hasHookEvent=!0);return this},t.prototype.$once=function(t,e){function n(){r.$off(t,n),e.apply(r,arguments)}var r=this;return n.fn=e,r.$on(t,n),r},t.prototype.$off=function(t,e){if(!arguments.length)return this._events=Object.create(null),this;if(Array.isArray(t)){for(var n=0,r=t.length;n<r;n++)this.$off(t[n],e);return this}var i=this._events[t];if(!i)return this;if(!e)return this._events[t]=null,this;if(e)for(var o,a=i.length;a--;)if((o=i[a])===e||o.fn===e){i.splice(a,1);break}return this},t.prototype.$emit=function(t){var e=this,n=e._events[t];if(n){n=n.length>1?v(n):n;for(var r=v(arguments,1),i=0,o=n.length;i<o;i++)try{n[i].apply(e,r)}catch(n){V(n,e,'event handler for "'+t+'"')}}return e}}(Rt),function(t){t.prototype._update=function(t,e){this._isMounted&&vt(this,"beforeUpdate");var n=this.$el,r=this._vnode,i=Pr;Pr=this,this._vnode=t,r?this.$el=this.__patch__(r,t):(this.$el=this.__patch__(this.$el,t,e,!1,this.$options._parentElm,this.$options._refElm),this.$options._parentElm=this.$options._refElm=null),Pr=i,n&&(n.__vue__=null),this.$el&&(this.$el.__vue__=this),this.$vnode&&this.$parent&&this.$vnode===this.$parent._vnode&&(this.$parent.$el=this.$el)},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){if(!this._isBeingDestroyed){vt(this,"beforeDestroy"),this._isBeingDestroyed=!0;var t=this.$parent;!t||t._isBeingDestroyed||this.$options.abstract||l(t.$children,this),this._watcher&&this._watcher.teardown();for(var e=this._watchers.length;e--;)this._watchers[e].teardown();this._data.__ob__&&this._data.__ob__.vmCount--,this._isDestroyed=!0,this.__patch__(this._vnode,null),vt(this,"destroyed"),this.$off(),this.$el&&(this.$el.__vue__=null),this.$vnode&&(this.$vnode.parent=null)}}}(Rt),function(t){Nt(t.prototype),t.prototype.$nextTick=function(t){return q(t,this)},t.prototype._render=function(){var t=this,e=t.$options,n=e.render,r=e._parentVnode;if(t._isMounted)for(var i in t.$slots){var o=t.$slots[i];(o._rendered||o[0]&&o[0].elm)&&(t.$slots[i]=A(o,!0))}t.$scopedSlots=r&&r.data.scopedSlots||jn,t.$vnode=r;var a;try{a=n.call(t._renderProxy,t.$createElement)}catch(e){V(e,t,"render"),a=t._vnode}return a instanceof mr||(a=gr()),a.parent=r,a}}(Rt);var Qr=[String,RegExp,Array],ti={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Qr,exclude:Qr,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)zt(this.cache,t,this.keys)},watch:{include:function(t){Vt(this,function(e){return Ut(t,e)})},exclude:function(t){Vt(this,function(e){return!Ut(t,e)})}},render:function(){var t=this.$slots.default,e=it(t),n=e&&e.componentOptions;if(n){var r=Bt(n),i=this.include,o=this.exclude;if(i&&(!r||!Ut(i,r))||o&&r&&Ut(o,r))return e;var a=this.cache,s=this.keys,c=null==e.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):e.key;a[c]?(e.componentInstance=a[c].componentInstance,l(s,c),s.push(c)):(a[c]=e,s.push(c),this.max&&s.length>parseInt(this.max)&&zt(a,s[0],s,this._vnode)),e.data.keepAlive=!0}return e||t&&t[0]}}};!function(t){var e={};e.get=function(){return Jn},Object.defineProperty(t,"config",e),t.util={warn:dr,extend:h,mergeOptions:F,defineReactive:E},t.set=j,t.delete=N,t.nextTick=q,t.options=Object.create(null),zn.forEach(function(e){t.options[e+"s"]=Object.create(null)}),t.options._base=t,h(t.options.components,ti),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=v(arguments,1);return n.unshift(this),"function"==typeof t.install?t.install.apply(t,n):"function"==typeof t&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=F(this.options,t),this}}(t),Ht(t),function(t){zn.forEach(function(e){t[e]=function(t,n){return n?("component"===e&&o(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&"function"==typeof n&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}})}(t)}(Rt),Object.defineProperty(Rt.prototype,"$isServer",{get:ur}),Object.defineProperty(Rt.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Rt.version="2.5.11";var ei,ni,ri,ii,oi,ai,si,ci,ui=u("style,class"),li=u("input,textarea,option,select,progress"),fi=function(t,e,n){return"value"===n&&li(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},di=u("contenteditable,draggable,spellcheck"),pi=u("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),vi="http://www.w3.org/1999/xlink",hi=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},mi=function(t){return hi(t)?t.slice(6,t.length):""},yi=function(t){return null==t||!1===t},gi={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},_i=u("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),bi=u("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),$i=function(t){return _i(t)||bi(t)},Ci=Object.create(null),wi=u("text,number,password,search,email,tel,url"),xi=Object.freeze({createElement:function(t,e){var n=document.createElement(t);return"select"!==t?n:(e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(t,e){return document.createElementNS(gi[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setAttribute:function(t,e,n){t.setAttribute(e,n)}}),ki={create:function(t,e){Xt(e)},update:function(t,e){t.data.ref!==e.data.ref&&(Xt(t,!0),Xt(e))},destroy:function(t){Xt(t,!0)}},Ai=new mr("",{},[]),Oi=["create","activate","update","remove","destroy"],Si={create:te,update:te,destroy:function(t){te(t,Ai)}},Ti=Object.create(null),Ei=[ki,Si],ji={create:re,update:re},Ni={create:oe,update:oe},Ii=/[\w).+\-_$\]]/,Li="__r",Mi="__c",Di={create:we,update:we},Pi={create:xe,update:xe},Fi=d(function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach(function(t){if(t){var r=t.split(n);r.length>1&&(e[r[0].trim()]=r[1].trim())}}),e}),Ri=/^--/,Hi=/\s*!important$/,Bi=function(t,e,n){if(Ri.test(e))t.style.setProperty(e,n);else if(Hi.test(n))t.style.setProperty(e,n.replace(Hi,""),"important");else{var r=Vi(e);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)t.style[r]=n[i];else t.style[r]=n}},Ui=["Webkit","Moz","ms"],Vi=d(function(t){if(ci=ci||document.createElement("div").style,"filter"!==(t=Pn(t))&&t in ci)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<Ui.length;n++){var r=Ui[n]+e;if(r in ci)return r}}),zi={create:Oe,update:Oe},Ki=d(function(t){return{enterClass:t+"-enter",enterToClass:t+"-enter-to",enterActiveClass:t+"-enter-active",leaveClass:t+"-leave",leaveToClass:t+"-leave-to",leaveActiveClass:t+"-leave-active"}}),Ji=Gn&&!tr,qi="transition",Wi="animation",Gi="transition",Zi="transitionend",Xi="animation",Yi="animationend";Ji&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Gi="WebkitTransition",Zi="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Xi="WebkitAnimation",Yi="webkitAnimationEnd"));var Qi=Gn?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()},to=/\b(transform|all)(,|$)/,eo=function(i){function o(t){var n=A.parentNode(t);e(n)&&A.removeChild(n,t)}function a(t,r,i,o,a){if(t.isRootInsert=!a,!function(t,r,i,o){var a=t.data;if(e(a)){var u=e(t.componentInstance)&&a.keepAlive;if(e(a=a.hook)&&e(a=a.init)&&a(t,!1,i,o),e(t.componentInstance))return s(t,r),n(u)&&function(t,n,r,i){for(var o,a=t;a.componentInstance;)if(a=a.componentInstance._vnode,e(o=a.data)&&e(o=o.transition)){for(o=0;o<x.activate.length;++o)x.activate[o](Ai,a);n.push(a);break}c(r,t.elm,i)}(t,r,i,o),!0}}(t,r,i,o)){var u=t.data,f=t.children,v=t.tag;e(v)?(t.elm=t.ns?A.createElementNS(t.ns,v):A.createElement(v,t),p(t),l(t,f,r),e(u)&&d(t,r),c(i,t.elm,o)):n(t.isComment)?(t.elm=A.createComment(t.text),c(i,t.elm,o)):(t.elm=A.createTextNode(t.text),c(i,t.elm,o))}}function s(t,n){e(t.data.pendingInsert)&&(n.push.apply(n,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,f(t)?(d(t,n),p(t)):(Xt(t),n.push(t))}function c(t,n,r){e(t)&&(e(r)?r.parentNode===t&&A.insertBefore(t,n,r):A.appendChild(t,n))}function l(t,e,n){if(Array.isArray(e))for(var i=0;i<e.length;++i)a(e[i],n,t.elm,null,!0);else r(t.text)&&A.appendChild(t.elm,A.createTextNode(t.text))}function f(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return e(t.tag)}function d(t,n){for(var r=0;r<x.create.length;++r)x.create[r](Ai,t);e(C=t.data.hook)&&(e(C.create)&&C.create(Ai,t),e(C.insert)&&n.push(t))}function p(t){var n;if(e(n=t.fnScopeId))A.setAttribute(t.elm,n,"");else for(var r=t;r;)e(n=r.context)&&e(n=n.$options._scopeId)&&A.setAttribute(t.elm,n,""),r=r.parent;e(n=Pr)&&n!==t.context&&n!==t.fnContext&&e(n=n.$options._scopeId)&&A.setAttribute(t.elm,n,"")}function v(t,e,n,r,i,o){for(;r<=i;++r)a(n[r],o,t,e)}function h(t){var n,r,i=t.data;if(e(i))for(e(n=i.hook)&&e(n=n.destroy)&&n(t),n=0;n<x.destroy.length;++n)x.destroy[n](t);if(e(n=t.children))for(r=0;r<t.children.length;++r)h(t.children[r])}function m(t,n,r,i){for(;r<=i;++r){var a=n[r];e(a)&&(e(a.tag)?(y(a),h(a)):o(a.elm))}}function y(t,n){if(e(n)||e(t.data)){var r,i=x.remove.length+1;for(e(n)?n.listeners+=i:n=function(t,e){function n(){0==--n.listeners&&o(t)}return n.listeners=e,n}(t.elm,i),e(r=t.componentInstance)&&e(r=r._vnode)&&e(r.data)&&y(r,n),r=0;r<x.remove.length;++r)x.remove[r](t,n);e(r=t.data.hook)&&e(r=r.remove)?r(t,n):n()}else o(t.elm)}function g(n,r,i,o,s){for(var c,u,l,f=0,d=0,p=r.length-1,h=r[0],y=r[p],g=i.length-1,b=i[0],$=i[g],C=!s;f<=p&&d<=g;)t(h)?h=r[++f]:t(y)?y=r[--p]:Yt(h,b)?(_(h,b,o),h=r[++f],b=i[++d]):Yt(y,$)?(_(y,$,o),y=r[--p],$=i[--g]):Yt(h,$)?(_(h,$,o),C&&A.insertBefore(n,h.elm,A.nextSibling(y.elm)),h=r[++f],$=i[--g]):Yt(y,b)?(_(y,b,o),C&&A.insertBefore(n,y.elm,h.elm),y=r[--p],b=i[++d]):(t(c)&&(c=Qt(r,f,p)),t(u=e(b.key)?c[b.key]:function(t,n,r,i){for(var o=r;o<i;o++){var a=n[o];if(e(a)&&Yt(t,a))return o}}(b,r,f,p))?a(b,o,n,h.elm):Yt(l=r[u],b)?(_(l,b,o),r[u]=void 0,C&&A.insertBefore(n,l.elm,h.elm)):a(b,o,n,h.elm),b=i[++d]);f>p?v(n,t(i[g+1])?null:i[g+1].elm,i,d,g,o):d>g&&m(0,r,f,p)}function _(r,i,o,a){if(r!==i){var s=i.elm=r.elm;if(n(r.isAsyncPlaceholder))e(i.asyncFactory.resolved)?$(r.elm,i,o):i.isAsyncPlaceholder=!0;else if(n(i.isStatic)&&n(r.isStatic)&&i.key===r.key&&(n(i.isCloned)||n(i.isOnce)))i.componentInstance=r.componentInstance;else{var c,u=i.data;e(u)&&e(c=u.hook)&&e(c=c.prepatch)&&c(r,i);var l=r.children,d=i.children;if(e(u)&&f(i)){for(c=0;c<x.update.length;++c)x.update[c](r,i);e(c=u.hook)&&e(c=c.update)&&c(r,i)}t(i.text)?e(l)&&e(d)?l!==d&&g(s,l,d,o,a):e(d)?(e(r.text)&&A.setTextContent(s,""),v(s,null,d,0,d.length-1,o)):e(l)?m(0,l,0,l.length-1):e(r.text)&&A.setTextContent(s,""):r.text!==i.text&&A.setTextContent(s,i.text),e(u)&&e(c=u.hook)&&e(c=c.postpatch)&&c(r,i)}}}function b(t,r,i){if(n(i)&&e(t.parent))t.parent.data.pendingInsert=r;else for(var o=0;o<r.length;++o)r[o].data.hook.insert(r[o])}function $(t,r,i,o){var a,c=r.tag,u=r.data,f=r.children;if(o=o||u&&u.pre,r.elm=t,n(r.isComment)&&e(r.asyncFactory))return r.isAsyncPlaceholder=!0,!0;if(e(u)&&(e(a=u.hook)&&e(a=a.init)&&a(r,!0),e(a=r.componentInstance)))return s(r,i),!0;if(e(c)){if(e(f))if(t.hasChildNodes())if(e(a=u)&&e(a=a.domProps)&&e(a=a.innerHTML)){if(a!==t.innerHTML)return!1}else{for(var p=!0,v=t.firstChild,h=0;h<f.length;h++){if(!v||!$(v,f[h],i,o)){p=!1;break}v=v.nextSibling}if(!p||v)return!1}else l(r,f,i);if(e(u)){var m=!1;for(var y in u)if(!O(y)){m=!0,d(r,i);break}!m&&u.class&&W(u.class)}}else t.data!==r.text&&(t.data=r.text);return!0}var C,w,x={},k=i.modules,A=i.nodeOps;for(C=0;C<Oi.length;++C)for(x[Oi[C]]=[],w=0;w<k.length;++w)e(k[w][Oi[C]])&&x[Oi[C]].push(k[w][Oi[C]]);var O=u("attrs,class,staticClass,staticStyle,key");return function(r,i,o,s,c,u){if(!t(i)){var l=!1,d=[];if(t(r))l=!0,a(i,d,c,u);else{var p=e(r.nodeType);if(!p&&Yt(r,i))_(r,i,d,s);else{if(p){if(1===r.nodeType&&r.hasAttribute(Vn)&&(r.removeAttribute(Vn),o=!0),n(o)&&$(r,i,d))return b(i,d,!0),r;r=function(t){return new mr(A.tagName(t).toLowerCase(),{},[],void 0,t)}(r)}var v=r.elm,y=A.parentNode(v);if(a(i,d,v._leaveCb?null:y,A.nextSibling(v)),e(i.parent))for(var g=i.parent,C=f(i);g;){for(var w=0;w<x.destroy.length;++w)x.destroy[w](g);if(g.elm=i.elm,C){for(var k=0;k<x.create.length;++k)x.create[k](Ai,g);var O=g.data.hook.insert;if(O.merged)for(var S=1;S<O.fns.length;S++)O.fns[S]()}else Xt(g);g=g.parent}e(y)?m(0,[r],0,0):e(r.tag)&&h(r)}}return b(i,d,l),i.elm}e(r)&&h(r)}}({nodeOps:xi,modules:[ji,Ni,Di,Pi,zi,Gn?{create:Ue,activate:Ue,remove:function(t,e){!0!==t.data.show?Re(t,e):e()}}:{}].concat(Ei)});tr&&document.addEventListener("selectionchange",function(){var t=document.activeElement;t&&t.vmodel&&Ge(t,"input")});var no={inserted:function(t,e,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?Y(n,"postpatch",function(){no.componentUpdated(t,e,n)}):Ve(t,e,n.context),t._vOptions=[].map.call(t.options,Je)):("textarea"===n.tag||wi(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("change",We),nr||(t.addEventListener("compositionstart",qe),t.addEventListener("compositionend",We)),tr&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){Ve(t,e,n.context);var r=t._vOptions,i=t._vOptions=[].map.call(t.options,Je);if(i.some(function(t,e){return!g(t,r[e])})){(t.multiple?e.value.some(function(t){return Ke(t,i)}):e.value!==e.oldValue&&Ke(e.value,i))&&Ge(t,"change")}}}},ro={model:no,show:{bind:function(t,e,n){var r=e.value,i=(n=Ze(n)).data&&n.data.transition,o=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;r&&i?(n.data.show=!0,Fe(n,function(){t.style.display=o})):t.style.display=r?o:"none"},update:function(t,e,n){var r=e.value;if(r!==e.oldValue){(n=Ze(n)).data&&n.data.transition?(n.data.show=!0,r?Fe(n,function(){t.style.display=t.__vOriginalDisplay}):Re(n,function(){t.style.display="none"})):t.style.display=r?t.__vOriginalDisplay:"none"}},unbind:function(t,e,n,r,i){i||(t.style.display=t.__vOriginalDisplay)}}},io={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]},oo={name:"transition",props:io,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(function(t){return t.tag||rt(t)})).length){var i=this.mode,o=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return o;var a=Xe(o);if(!a)return o;if(this._leaving)return Qe(t,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:r(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=Ye(this),u=this._vnode,l=Xe(u);if(a.data.directives&&a.data.directives.some(function(t){return"show"===t.name})&&(a.data.show=!0),l&&l.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(a,l)&&!rt(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=h({},c);if("out-in"===i)return this._leaving=!0,Y(f,"afterLeave",function(){e._leaving=!1,e.$forceUpdate()}),Qe(t,o);if("in-out"===i){if(rt(a))return u;var d,p=function(){d()};Y(c,"afterEnter",p),Y(c,"enterCancelled",p),Y(f,"delayLeave",function(t){d=t})}}return o}}},ao=h({tag:String,moveClass:String},io);delete ao.mode;var so={Transition:oo,TransitionGroup:{props:ao,render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=Ye(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var d=r[f];d.data.transition=a,d.data.pos=d.elm.getBoundingClientRect(),n[d.key]?u.push(d):l.push(d)}this.kept=t(e,null,u),this.removed=l}return t(e,null,o)},beforeUpdate:function(){this.__patch__(this._vnode,this.kept,!1,!0),this._vnode=this.kept},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(tn),t.forEach(en),t.forEach(nn),this._reflow=document.body.offsetHeight,t.forEach(function(t){if(t.data.moved){var n=t.elm,r=n.style;Ne(n,e),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Zi,n._moveCb=function t(r){r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Zi,t),n._moveCb=null,Ie(n,e))})}}))},methods:{hasMove:function(t,e){if(!Ji)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach(function(t){Te(n,t)}),Se(n,e),n.style.display="none",this.$el.appendChild(n);var r=Me(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};Rt.config.mustUseProp=fi,Rt.config.isReservedTag=$i,Rt.config.isReservedAttr=ui,Rt.config.getTagNamespace=Gt,Rt.config.isUnknownElement=function(t){if(!Gn)return!0;if($i(t))return!1;if(t=t.toLowerCase(),null!=Ci[t])return Ci[t];var e=document.createElement(t);return t.indexOf("-")>-1?Ci[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:Ci[t]=/HTMLUnknownElement/.test(e.toString())},h(Rt.options.directives,ro),h(Rt.options.components,so),Rt.prototype.__patch__=Gn?eo:y,Rt.prototype.$mount=function(t,e){return t=t&&Gn?Zt(t):void 0,function(t,e,n){t.$el=e,t.$options.render||(t.$options.render=gr),vt(t,"beforeMount");var r;return r=function(){t._update(t._render(),n)},new Kr(t,r,y,null,!0),n=!1,null==t.$vnode&&(t._isMounted=!0,vt(t,"mounted")),t}(this,t,e)},Rt.nextTick(function(){Jn.devtools&&lr&&lr.emit("init",Rt)},0);var co,uo=/\{\{((?:.|\n)+?)\}\}/g,lo=/[-.*+?^${}()|[\]\/\\]/g,fo=d(function(t){var e=t[0].replace(lo,"\\$&"),n=t[1].replace(lo,"\\$&");return new RegExp(e+"((?:.|\\n)+?)"+n,"g")}),po={staticKeys:["staticClass"],transformNode:function(t,e){e.warn;var n=ve(t,"class");n&&(t.staticClass=JSON.stringify(n));var r=pe(t,"class",!1);r&&(t.classBinding=r)},genData:function(t){var e="";return t.staticClass&&(e+="staticClass:"+t.staticClass+","),t.classBinding&&(e+="class:"+t.classBinding+","),e}},vo={staticKeys:["staticStyle"],transformNode:function(t,e){e.warn;var n=ve(t,"style");n&&(t.staticStyle=JSON.stringify(Fi(n)));var r=pe(t,"style",!1);r&&(t.styleBinding=r)},genData:function(t){var e="";return t.staticStyle&&(e+="staticStyle:"+t.staticStyle+","),t.styleBinding&&(e+="style:("+t.styleBinding+"),"),e}},ho=function(t){return co=co||document.createElement("div"),co.innerHTML=t,co.textContent},mo=u("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),yo=u("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),go=u("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),_o=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,bo="[a-zA-Z_][\\w\\-\\.]*",$o="((?:"+bo+"\\:)?"+bo+")",Co=new RegExp("^<"+$o),wo=/^\s*(\/?)>/,xo=new RegExp("^<\\/"+$o+"[^>]*>"),ko=/^<!DOCTYPE [^>]+>/i,Ao=/^<!--/,Oo=/^<!\[/,So=!1;"x".replace(/x(.)?/g,function(t,e){So=""===e});var To,Eo,jo,No,Io,Lo,Mo,Do,Po,Fo,Ro,Ho=u("script,style,textarea",!0),Bo={},Uo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t"},Vo=/&(?:lt|gt|quot|amp);/g,zo=/&(?:lt|gt|quot|amp|#10|#9);/g,Ko=u("pre,textarea",!0),Jo=function(t,e){return t&&Ko(t)&&"\n"===e[0]},qo=/^@|^v-on:/,Wo=/^v-|^@|^:/,Go=/(.*?)\s+(?:in|of)\s+(.*)/,Zo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Xo=/^\(|\)$/g,Yo=/:(.*)$/,Qo=/^:|^v-bind:/,ta=/\.[^.]+/g,ea=d(ho),na=/^xmlns:NS\d+/,ra=/^NS\d+:/,ia=[po,vo,{preTransformNode:function(t,e){if("input"===t.tag){var n=t.attrsMap;if(n["v-model"]&&(n["v-bind:type"]||n[":type"])){var r=pe(t,"type"),i=ve(t,"v-if",!0),o=i?"&&("+i+")":"",a=null!=ve(t,"v-else",!0),s=ve(t,"v-else-if",!0),c=ln(t);cn(c),fn(c,"type","checkbox"),sn(c,e),c.processed=!0,c.if="("+r+")==='checkbox'"+o,un(c,{exp:c.if,block:c});var u=ln(t);ve(u,"v-for",!0),fn(u,"type","radio"),sn(u,e),un(c,{exp:"("+r+")==='radio'"+o,block:u});var l=ln(t);return ve(l,"v-for",!0),fn(l,":type",r),sn(l,e),un(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}],oa={expectHTML:!0,modules:ia,directives:{model:function(t,e,n){var r=e.value,i=e.modifiers,o=t.tag,a=t.attrsMap.type;if(t.component)return he(t,r,i),!1;if("select"===o)!function(t,e,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+me(e,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),de(t,"change",r,null,!0)}(t,r,i);else if("input"===o&&"checkbox"===a)!function(t,e,n){var r=n&&n.number,i=pe(t,"value")||"null",o=pe(t,"true-value")||"true",a=pe(t,"false-value")||"false";ue(t,"checked","Array.isArray("+e+")?_i("+e+","+i+")>-1"+("true"===o?":("+e+")":":_q("+e+","+o+")")),de(t,"change","var $$a="+e+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+e+"=$$a.concat([$$v]))}else{$$i>-1&&("+e+"=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{"+me(e,"$$c")+"}",null,!0)}(t,r,i);else if("input"===o&&"radio"===a)!function(t,e,n){var r=n&&n.number,i=pe(t,"value")||"null";ue(t,"checked","_q("+e+","+(i=r?"_n("+i+")":i)+")"),de(t,"change",me(e,i),null,!0)}(t,r,i);else if("input"===o||"textarea"===o)!function(t,e,n){var r=t.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Li:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=me(e,l);c&&(f="if($event.target.composing)return;"+f),ue(t,"value","("+e+")"),de(t,u,f,null,!0),(s||a)&&de(t,"blur","$forceUpdate()")}(t,r,i);else if(!Jn.isReservedTag(o))return he(t,r,i),!1;return!0},text:function(t,e){e.value&&ue(t,"textContent","_s("+e.value+")")},html:function(t,e){e.value&&ue(t,"innerHTML","_s("+e.value+")")}},isPreTag:function(t){return"pre"===t},isUnaryTag:mo,mustUseProp:fi,canBeLeftOpenTag:yo,isReservedTag:$i,getTagNamespace:Gt,staticKeys:function(t){return t.reduce(function(t,e){return t.concat(e.staticKeys||[])},[]).join(",")}(ia)},aa=d(function(t){return u("type,tag,attrsList,attrsMap,plain,parent,children,attrs"+(t?","+t:""))}),sa=/^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/,ca=/^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/,ua={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},la=function(t){return"if("+t+")return null;"},fa={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:la("$event.target !== $event.currentTarget"),ctrl:la("!$event.ctrlKey"),shift:la("!$event.shiftKey"),alt:la("!$event.altKey"),meta:la("!$event.metaKey"),left:la("'button' in $event && $event.button !== 0"),middle:la("'button' in $event && $event.button !== 1"),right:la("'button' in $event && $event.button !== 2")},da={on:function(t,e){t.wrapListeners=function(t){return"_g("+t+","+e.value+")"}},bind:function(t,e){t.wrapData=function(n){return"_b("+n+",'"+t.tag+"',"+e.value+","+(e.modifiers&&e.modifiers.prop?"true":"false")+(e.modifiers&&e.modifiers.sync?",true":"")+")"}},cloak:y},pa=function(t){this.options=t,this.warn=t.warn||se,this.transforms=ce(t.modules,"transformCode"),this.dataGenFns=ce(t.modules,"genData"),this.directives=h(h({},da),t.directives);var e=t.isReservedTag||Bn;this.maybeComponent=function(t){return!e(t.tag)},this.onceId=0,this.staticRenderFns=[]},va=(new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),new RegExp("\\b"+"delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b")+"\\s*\\([^\\)]*\\)"),function(t){return function(e){function n(n,r){var i=Object.create(e),o=[],a=[];if(i.warn=function(t,e){(e?a:o).push(t)},r){r.modules&&(i.modules=(e.modules||[]).concat(r.modules)),r.directives&&(i.directives=h(Object.create(e.directives||null),r.directives));for(var s in r)"modules"!==s&&"directives"!==s&&(i[s]=r[s])}var c=t(n,i);return c.errors=o,c.tips=a,c}return{compile:n,compileToFunctions:function(t){var e=Object.create(null);return function(n,r,i){(r=h({},r)).warn,delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(e[o])return e[o];var a=t(n,r),s={},c=[];return s.render=Tn(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(t){return Tn(t,c)}),e[o]=s}}(n)}}}(function(t,e){var n=an(t.trim(),e);!function(t,e){t&&(Po=aa(e.staticKeys||""),Fo=e.isReservedTag||Bn,dn(t),pn(t,!1))}(n,e);var r=yn(n,e);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}})(oa).compileToFunctions),ha=!!Gn&&En(!1),ma=!!Gn&&En(!0),ya=d(function(t){var e=Zt(t);return e&&e.innerHTML}),ga=Rt.prototype.$mount;return Rt.prototype.$mount=function(t,e){if((t=t&&Zt(t))===document.body||t===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ya(r));else{if(!r.nodeType)return this;r=r.innerHTML}else t&&(r=function(t){if(t.outerHTML)return t.outerHTML;var e=document.createElement("div");return e.appendChild(t.cloneNode(!0)),e.innerHTML}(t));if(r){var i=va(r,{shouldDecodeNewlines:ha,shouldDecodeNewlinesForHref:ma,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return ga.call(this,t,e)},Rt.compile=va,Rt});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(84).setImmediate))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(85);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(86)))

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {

    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }

    return cookieEnabled;

  },

  add: function () {

  },

  remove: function () {

  },

  update: function () {

  }
  
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.comingSoon);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

(function () {
  // Newsletter stuff
})();

(function () {

  // Jump out if not needed
  if (!document.querySelector('.section-filters'))
    return;

  // The elements
  var section = document.querySelector('.section-filters'),
      filters = document.querySelectorAll('.section-filters__filter'),
      title = section.querySelector('.section-filters__title'),
      Filter = function (wrapper) {

        // Store this as self
        var self = this;

        // Add self to the filter list
        Filter.prototype.filters.push(this);

        // Store the wrapper
        this.wrapper = wrapper;

        // Add the heading
        this.list = wrapper.querySelector('.section-filters__list');

        // Loop through the toggles
        this.list.addEventListener(
          'change',
          function () {

            // Fires the cat change
            self.change();

          }
        );

      };

  // To store all the filters
  Filter.prototype.filters = [];

  // Toggles a filter
  Filter.prototype.change = function () {
    if(this.list.value)
      window.location.href =
        this.list.value;
  };

  // Toggles the wrapper's open state (mobile)
  Filter.prototype.toggle = function () {

  };

  // Open the filters (mobile)
  title.addEventListener(
    'click',
    function () {
      section.classList.toggle('section-filters--show');
    }
  );

  // Init the filters
  for (var i = 0, l = filters.length; i < l; i++)
    new Filter(filters[i]);

})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ Components ================*/
//
// these easing functions are based on the code of glsl-easing module.
// https://github.com/glslify/glsl-easings
//

var ease = {
  exponentialIn: function (t)  {
    return t == 0.0 ? t : Math.pow(2.0, 10.0 * (t - 1.0));
  },
  exponentialOut: function (t)  {
    return t == 1.0 ? t : 1.0 - Math.pow(2.0, -10.0 * t);
  },
  exponentialInOut: function (t)  {
    return t == 0.0 || t == 1.0
      ? t
      : t < 0.5
        ? +0.5 * Math.pow(2.0, (20.0 * t) - 10.0)
        : -0.5 * Math.pow(2.0, 10.0 - (t * 20.0)) + 1.0;
  },
  sineOut: function (t)  {
    var HALF_PI = 1.5707963267948966;
    return Math.sin(t * HALF_PI);
  },
  circularInOut: function (t)  {
    return t < 0.5
        ? 0.5 * (1.0 - Math.sqrt(1.0 - 4.0 * t * t))
        : 0.5 * (Math.sqrt((3.0 - 2.0 * t) * (2.0 * t - 1.0)) + 1.0);
  },
  cubicIn: function (t)  {
    return t * t * t;
  },
  cubicOut: function (t)  {
    var f = t - 1.0;
    return f * f * f + 1.0;
  },
  cubicInOut: function (t)  {
    return t < 0.5
      ? 4.0 * t * t * t
      : 0.5 * Math.pow(2.0 * t - 2.0, 3.0) + 1.0;
  },
  quadraticOut: function (t)  {
    return -t * (t - 2.0);
  },
  quarticOut: function (t)  {
    return Math.pow(t - 1.0, 3.0) * (1.0 - t) + 1.0;
  },
}

function ShapeOverlays (elm) {

  var self = this;

  this.elm = elm;
  this.body = document.body;
  this.path = elm.querySelectorAll('path');
  this.numPoints = 18;
  this.duration = 600;
  this.delayPointsArray = [];
  this.delayPointsMax = 300;
  this.delayPerPath = 100;
  this.timeStart = Date.now();
  this.isOpened = false;
  this.isAnimating = false;

  this.toggle = function () {
    this.isAnimating = true;
    var range = 4 * Math.random() + 6;
    for (var i = 0; i < this.numPoints; i++) {
      var radian = i / (this.numPoints - 1) * Math.PI;
      this.delayPointsArray[i] = (Math.sin(-radian) + Math.sin(-radian * range) + 2) / 4 * this.delayPointsMax;
    }
    if (this.isOpened === false) {
      this.open();
    } else {
      this.close();
    }
  };
  this.open = function () {
    this.isOpened = true;

    this.elm.setAttribute(
      'class',
      this.elm.getAttribute('class').replace(
        /is-opened/g, ''
      ) + ' is-opened'
    );

    this.body.classList.add('site-nav--open');
    this.timeStart = Date.now();
    this.renderLoop();
  };
  this.close = function () {
    this.isOpened = false;

    this.elm.setAttribute(
      'class',
      this.elm.getAttribute('class').replace(
        /is-opened/g, ''
      )
    );

    this.body.classList.remove('site-nav--open');
    setTimeout( function () {
      self.timeStart = Date.now();
      self.renderLoop();
    }, 200);
  };
  this.updatePath = function (time) {
    var points = [];
    for (var i = 0; i < this.numPoints + 1; i++) {
      points[i] = ease.cubicInOut(Math.min(Math.max(time - this.delayPointsArray[i], 0) / this.duration, 1)) * 100
    }

    var str = '';
    str += (this.isOpened) ? 'M 0 0 V ' + points[0] + ' ' : 'M 0 ' + points[0] + ' ';
    for (var i = 0; i < this.numPoints - 1; i++) {
      var p = (i + 1) / (this.numPoints - 1) * 100;
      var cp = p - (1 / (this.numPoints - 1) * 100) / 2;
      str += 'C ' + cp + ' ' + points[i] + ' ' + cp + ' ' + points[i + 1] + ' ' + p + ' ' + points[i + 1] + ' ';
    }
    str += (this.isOpened) ? 'V 0 H 0' : 'V 100 H 0';
    return str;
  };
  this.render = function () {
    if (this.isOpened) {
      for (var i = 0; i < this.path.length; i++) {
        this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * i)));
      }
    } else {
      for (var i = 0; i < this.path.length; i++) {
        this.path[i].setAttribute('d', this.updatePath(Date.now() - (this.timeStart + this.delayPerPath * (this.path.length - i - 1))));
      }
    }
  };
  this.renderLoop = function () {
    this.render();
    if (Date.now() - this.timeStart < this.duration + this.delayPerPath * (this.path.length - 1) + this.delayPointsMax) {
      requestAnimationFrame(function () {
        self.renderLoop();
      });
    }
    else {
      this.isAnimating = false;
    }
  };
}

( function() {

  var elmHamburger = document.querySelector('.hamburger'),
      gNavItems = document.querySelectorAll('.global-menu__item'),
      elmOverlay = document.querySelector('.shape-overlays'),
      overlay = new ShapeOverlays(elmOverlay),
      logo = document.getElementsByClassName('site-header__logo')[0],
      calcTop = function () {
        logo.style.top = window.pageYOffset + 'px' ;
      };

  elmHamburger.addEventListener( 'click', function() {
    if (overlay.isAnimating) {
      return false;
    }
    overlay.toggle();
    if (overlay.isOpened === true) {
      elmHamburger.classList.add('is-opened-navi');
      for (var i = 0; i < gNavItems.length; i++) {
        gNavItems[i].classList.add('is-opened');
      }
      window.addEventListener('resize', calcTop);
      calcTop();
    } else {
      elmHamburger.classList.remove('is-opened-navi');
      for (var i = 0; i < gNavItems.length; i++) {
        gNavItems[i].classList.remove('is-opened');
      }
      window.removeEventListener('resize', calcTop);
      logo.style.top = '';
    }
  });

}());

(function () {

  var body = document.body,
      threshold = 64,
      below_threshold = null,
      smush = document.getElementsByClassName('site-header__smush'),
      sizeElements = function () {
        for (var i = 0; i < smush.length; i++)
          smush[i].style.height =
            Math.max(threshold * 2 - window.pageYOffset,0)
            + 'px';
      },
      scroll = function () {

        if (!below_threshold || window.pageYOffset <= threshold)
          window.requestAnimationFrame(sizeElements);

        if(below_threshold !== true && window.pageYOffset > threshold) {
          body.classList.remove('site-header--above');
          body.classList.add('site-header--below');
          below_threshold = true;
        }else if(below_threshold !== false && window.pageYOffset <= threshold) {
          body.classList.add('site-header--above');
          body.classList.remove('site-header--below');
          below_threshold = false;
        }

      };

  // init scroll callback
  scroll();

  // Set up the scroll listener
  window.addEventListener('scroll', scroll);

})();

(function () {

  var body = document.body,
      index = 1,
      max = 11;

  setInterval(function () {

    body.classList.remove('highlight--' + index);

    index = index == max ? 1 : index+1;

    body.classList.add('highlight--' + index);

  }, 200);

})();

/**
 * Revealer text
 */
(function () {

  // Scroll revealer
  var scroll_revealer = ScrollReveal({
    viewFactor: 0.3,
    scale: 1,
    opacity: 0,
    easing: 'ease',
    distance: '20px',
    origin: 'bottom'
  });

  // Mostly for text
  scroll_revealer.reveal('.revealer--text');

  // Mostly for text
  scroll_revealer.reveal('.revealer--image');

})();

'use strict';

/**
 * Handles logic for the quantities
 */

(function () {

  // Set the base class
  var base_class = 'component-quantity',
      base_class_element = base_class + '__',
      quantity_elements = document.getElementsByClassName(base_class + '--js');

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  // Quantity class

  var Quantity = function () {

    /**
     * Construct the quantity class
     * @param  {Node} element The quantity element
     */
    function Quantity(element) {
      _classCallCheck(this, Quantity);

      // Add props to this class
      Object.assign(this, {

        // Store the element
        element: element,

        // Set the min value
        min: 0,

        // Store the up increment
        element_input: element.querySelector('.' + base_class_element + 'input'),

        // Store the up increment
        element_adjustors: element.getElementsByClassName(base_class_element + 'adjust')

      });

      // Set the min value
      this.min = this.element_input.getAttribute('min') || 0;

      // Sets up the init
      this.init();
    }

    /**
     * Increments the inputs +/-
     * @param  {Integer} amount The amount to increment
     * @return {Null}
     */


    _createClass(Quantity, [{
      key: 'increment',
      value: function increment(amount) {
        this.element_input.value = Math.max(this.min, +this.element_input.value + amount);
      }

      /**
       * Init the quantity object
       * @return {Null}
       */

    }, {
      key: 'init',
      value: function init() {
        var _this = this;

        // Loop through the element adjustors
        for (var i = 0, l = this.element_adjustors.length; i < l; i++) {
          this.element_adjustors[i].addEventListener('click', function (e) {
            return _this.increment(+e.target.getAttribute('data-amount'));
          });
        }
      }
    }]);

    return Quantity;
  }();

  // init the quantity elements


  for (var i = 0, l = quantity_elements.length; i < l; i++) {
    new Quantity(quantity_elements[i]);
  }
})();

(function () {

  // update sticky sidebar
  if(window.cc_stickySidebar)
    window.cc_stickySidebar.updateSticky();

  // grab our toggles
  var toggles = document.getElementsByClassName('page-product__large-images--toggler'),
      attempts = [1,10,50,100,200,300];

  // loop through the toggles
  for (var i = 0, l = toggles.length; i < l; i++)
    toggles[i].addEventListener(
      'click',
      function () {

        // Toggle the class on the body
        document.body.classList.toggle('page-product--large-images');

        // refresh stick sidebar
        if(window.cc_stickySidebar) {

          // Once after it starts
          for (var i = 0; i < attempts.length; i++)
            setTimeout(function () {
              window.cc_stickySidebar.updateSticky();
            }, attempts[i]);

        }

      }
    );

})();

/**
 * This handles clicking the arrows to
 * the next image on mobile product pages
 * @return {Null}
 */

(function () {

  // init our vars
  var hints = document.getElementsByClassName('page-product__hint'),
      parent = null

  // jump out if no hints present
  if(!hints.length) return;

  // Set the parent
  parent = hints[0].parentNode;

  // Add the click event
  for (var i = 0, l = hints.length; i < l; i++)
    hints[i].addEventListener(
      'click',
      function () {

        // Get some env vars
        var posfromleft = this.offsetLeft - parent.scrollLeft - window.innerWidth/2;

        // Set the scroll position on the parent
        parent.scrollLeft = posfromleft <= 0
          ? this.offsetLeft - window.innerWidth + this.offsetWidth
          : this.offsetLeft ;

      }
    );

})();

/**
 * Inits a sticky sidebar if present
 */

window.cc_stickySidebar = (function () {

  // Jump out if no sticky sidebar
  if(!(element = document.getElementById('sticky-sidebar')))
    return;

  // Init the sidebar
  var stickySidebar = new StickySidebar('#sticky-sidebar', {
    containerSelector: '#sticky-sidebar__container',
    innerWrapperSelector: '.sticky-sidebar__inner',
    topSpacing: element.getAttribute('data-topSpacing') || 0,
    bottomSpacing: 0
  });

  return stickySidebar;

})();


/*================ Heroes ================*/
(function () {

  // Set the video
  var video = document.querySelector('.video-article'),
      dimensions_width = 16,
      dimensions_height = 9,
      min_width = 320,
      below = false,
      video_sizer = function (trigger_render) {

        // Calculate the top
        var trigger_render = trigger_render === true ? true : false,
            top = document.body.scrollTop || document.documentElement.scrollTop,
            height = (window.innerWidth) * dimensions_height/dimensions_width,
            width = (height - top) * dimensions_width/dimensions_height,
            percent = Math.max((width-min_width)/(window.innerWidth-min_width) * 100, 0),
            full_right = 20 + (window.innerWidth - Math.min(990,window.innerWidth)) / 2;

        // If below or above the threshold
        if(width < min_width && !below) {

          // Sets the below flag to true
          below = true;

          // Set the trigger render flag
          trigger_render = true;

          // Add the below class
          document.body.classList.add('video-article--below');

          // update the sidebar
          setTimeout(
            function () {
              window.cc_stickySidebar.updateSticky();
            }, 800
          );

        }else if(width >= min_width){

          // Set the trigger render flag
          trigger_render = true;

          // If below was not set
          if(below) {

            // Set the
            document.body.classList.remove('video-article--below');

            // update the sidebar
            setTimeout(
              function () {
                window.cc_stickySidebar.updateSticky();
              }, 300
            );

            // Set the blow flag
            below = false;

          }

        }

        // Resizes the video
        if (trigger_render) {

          // Sets the offset from the top when
          // (hides youtube chrome)
          // video.style.marginBottom = -47 * (1 - percent / 100) + 'px';

          // Sets the width of the video container
          // before snapping it to the grid
          video.style.width = Math.max(width,0) + 'px';

          // Sets how far from the right the video will place
          video.style.right = Math.max(full_right * (1 - percent / 100), 0) + 'px';

        }

      };

  // jump out if no video
  if(!video) return;

  // Callback for on scroll and resize
  window.addEventListener('scroll', video_sizer);
  window.addEventListener('resize', function () {
    video_sizer(true);
  });

  window.addEventListener('load', function () {
    video_sizer(true);
  });

})();


// Ready jquery
$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
